import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1080.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)">
<path d="M0 5400 l0 -5400 5400 0 5400 0 0 5400 0 5400 -5400 0 -5400 0 0
-5400z m6065 4765 c66 -9 143 -18 170 -21 28 -3 57 -8 65 -11 8 -3 31 -6 51
-8 45 -4 249 -42 304 -56 22 -6 56 -15 75 -20 78 -19 157 -42 190 -54 19 -7
71 -23 115 -36 44 -12 98 -30 120 -40 22 -9 76 -29 120 -45 44 -15 85 -31 91
-36 6 -4 28 -14 50 -22 21 -7 73 -29 114 -48 41 -19 91 -41 110 -48 19 -7 40
-17 45 -21 6 -4 47 -26 92 -49 46 -23 80 -46 77 -51 -3 -5 3 -9 13 -9 33 -1
249 -128 266 -157 4 -7 16 -13 25 -13 9 0 41 -19 71 -41 30 -23 76 -55 103
-71 26 -16 48 -34 48 -39 0 -5 6 -9 13 -9 7 0 24 -11 39 -25 15 -14 32 -25 37
-25 6 0 14 -6 18 -13 4 -7 47 -43 94 -79 48 -37 98 -81 113 -98 14 -17 26 -28
26 -25 0 4 7 2 15 -5 8 -7 12 -16 9 -21 -3 -5 -2 -8 3 -7 16 6 63 -40 57 -55
-11 -29 -36 -29 -67 0 -26 24 -28 25 -18 6 16 -32 46 -46 70 -33 11 5 21 15
23 21 2 6 31 -15 63 -46 33 -32 52 -55 43 -52 -10 4 -18 2 -18 -3 0 -5 10 -10
22 -12 13 -2 24 -11 26 -23 2 -11 9 -24 14 -30 7 -7 8 -2 3 15 -7 26 -5 24
141 -133 30 -31 54 -61 54 -66 0 -5 12 -19 26 -30 23 -18 25 -23 13 -38 -13
-16 -12 -17 2 -5 14 11 22 6 56 -35 90 -110 109 -137 88 -130 -19 8 -19 8 0
-15 11 -13 22 -25 24 -28 2 -3 1 3 -2 13 -4 10 -3 16 2 13 15 -9 131 -174 131
-186 0 -6 7 -13 15 -16 8 -4 15 -11 15 -16 0 -5 22 -42 48 -81 27 -40 51 -79
55 -87 10 -22 31 -54 39 -60 17 -13 208 -394 208 -415 0 -8 4 -15 9 -15 5 0
12 -13 16 -30 4 -16 10 -30 13 -30 4 0 15 -21 25 -48 10 -26 23 -55 28 -64 5
-10 9 -25 9 -33 0 -8 4 -15 9 -15 5 0 11 -10 14 -22 2 -13 19 -61 36 -108 17
-47 31 -95 31 -107 0 -13 4 -23 8 -23 5 0 21 -42 36 -92 16 -51 32 -104 37
-118 17 -50 69 -270 69 -294 0 -14 4 -27 9 -30 5 -4 12 -30 16 -59 4 -28 15
-102 26 -163 11 -62 24 -161 29 -220 6 -60 14 -147 19 -194 13 -116 12 -565
-1 -670 -5 -47 -11 -101 -12 -120 -11 -169 -19 -221 -36 -240 -10 -12 -22 -21
-26 -20 -5 1 -10 -4 -12 -12 -2 -9 0 -8 7 2 9 12 11 11 12 -10 2 -24 2 -24 6
-2 2 12 9 22 15 22 6 0 7 -8 3 -17 -3 -10 -12 -58 -20 -108 -8 -49 -21 -121
-30 -160 -39 -164 -58 -242 -70 -280 -6 -22 -24 -80 -39 -130 -16 -49 -41
-126 -56 -170 -16 -44 -34 -97 -41 -117 -7 -21 -17 -38 -22 -38 -5 0 -7 -7 -3
-15 3 -8 1 -15 -4 -15 -6 0 -10 -8 -10 -17 -1 -26 -55 -144 -63 -136 -4 3 -7
-5 -7 -18 -1 -30 -54 -142 -64 -132 -4 4 -4 0 0 -10 3 -9 2 -17 -3 -17 -5 0
-10 -6 -10 -12 0 -17 -33 -87 -44 -94 -8 -5 -13 22 -10 56 1 11 -2 10 -10 -4
-8 -13 -8 -25 0 -43 14 -31 14 -46 -1 -37 -6 4 -8 3 -4 -4 3 -6 -6 -32 -22
-59 -15 -26 -36 -64 -45 -83 -10 -19 -35 -64 -57 -99 -22 -34 -40 -67 -40 -72
0 -5 -3 -9 -7 -9 -5 0 -21 -23 -37 -50 -16 -27 -33 -47 -37 -45 -4 3 -10 -6
-13 -19 -3 -13 -23 -46 -44 -73 -21 -26 -47 -63 -57 -81 -11 -18 -25 -30 -32
-28 -8 3 -10 -1 -6 -11 4 -9 0 -21 -9 -27 -8 -6 -29 -31 -47 -56 -37 -52 -107
-133 -168 -198 -24 -25 -43 -48 -43 -52 0 -4 -17 -23 -37 -42 -21 -19 -56 -54
-77 -78 -22 -24 -37 -36 -33 -26 6 16 5 17 -7 6 -9 -6 -14 -15 -13 -20 3 -11
-58 -75 -138 -145 -38 -33 -77 -68 -87 -78 -10 -10 -24 -15 -30 -11 -6 4 -8 3
-5 -3 11 -18 -223 -210 -242 -198 -7 4 -8 0 -4 -11 5 -13 2 -15 -18 -9 -21 7
-22 6 -10 -9 11 -12 11 -16 1 -16 -7 0 -36 -17 -64 -38 -65 -49 -185 -132
-192 -132 -2 0 -35 -20 -73 -45 -38 -25 -72 -45 -76 -45 -4 0 -19 -9 -34 -19
-14 -10 -37 -21 -51 -23 -15 -2 -24 -9 -22 -17 3 -13 -4 -13 -44 0 -7 2 -11 0
-11 -6 1 -5 7 -9 14 -7 26 6 12 -7 -37 -32 -27 -14 -57 -26 -66 -26 -10 0 -14
-3 -10 -7 3 -4 -42 -30 -101 -59 -60 -29 -110 -50 -113 -48 -2 3 2 9 10 14 11
7 7 10 -15 16 -26 7 -27 8 -10 20 23 17 12 18 -18 2 -22 -11 -22 -12 8 -24 17
-7 24 -13 17 -14 -7 0 -10 -4 -7 -10 3 -5 -11 -17 -32 -27 -21 -9 -65 -29 -98
-44 -33 -15 -78 -32 -100 -39 -22 -7 -53 -18 -70 -26 -57 -25 -213 -74 -238
-74 -14 0 -27 -4 -29 -8 -1 -5 -16 -12 -33 -16 -22 -5 -26 -4 -15 4 8 5 11 10
5 10 -14 0 -43 -20 -30 -20 26 -2 -76 -31 -118 -35 -27 -2 -54 -8 -61 -14 -6
-5 -27 -13 -46 -16 -19 -3 -60 -12 -90 -19 -75 -19 -151 -29 -125 -17 19 9 19
10 -2 10 -14 1 -23 -5 -23 -14 0 -14 -34 -21 -84 -16 -11 1 -22 -3 -25 -8 -3
-5 -96 -18 -206 -30 -220 -24 -495 -30 -780 -19 -158 6 -240 15 -526 58 -105
16 -359 72 -489 109 -41 12 -87 24 -102 27 -16 4 -28 10 -28 15 0 5 -9 9 -20
9 -27 0 -150 41 -146 49 2 3 -9 6 -26 7 -16 1 -39 6 -51 11 -18 8 -171 73
-337 142 -14 6 -32 16 -40 21 -8 6 -44 24 -80 41 -122 57 -182 90 -177 96 4 3
22 -2 41 -11 38 -18 59 -21 36 -6 -13 9 -13 12 3 24 16 12 15 14 -10 14 -16 0
-43 -4 -61 -10 -27 -8 -37 -7 -51 6 -10 9 -21 16 -24 16 -10 0 -112 63 -115
72 -2 4 -8 8 -13 8 -13 0 -92 52 -102 67 -4 7 -15 13 -23 13 -15 0 -105 59
-154 100 -25 21 -25 22 -2 17 13 -3 20 -1 16 5 -3 5 -16 7 -29 4 -16 -4 -31 2
-53 22 -16 15 -41 35 -56 45 -14 9 -24 23 -22 30 1 6 1 9 -1 5 -8 -14 -35 -8
-30 6 3 7 0 13 -7 12 -14 -1 -256 200 -256 212 0 4 -16 18 -36 31 -19 13 -33
30 -30 37 3 8 0 11 -9 8 -10 -4 -12 1 -8 18 4 18 3 20 -6 8 -9 -12 -24 -2 -87
60 -42 41 -85 89 -95 105 -10 17 -19 27 -19 23 0 -4 -21 15 -46 42 -38 40 -44
53 -35 64 8 10 9 16 1 21 -5 3 -10 -1 -10 -9 0 -22 -17 -20 -30 4 -6 11 -30
42 -53 68 -56 64 -99 119 -117 150 -8 13 -28 37 -43 53 -16 16 -25 34 -21 40
4 7 3 9 -4 5 -6 -3 -13 3 -17 14 -3 11 -10 20 -14 20 -4 0 -13 12 -20 27 -7
15 -25 43 -41 63 -19 24 -27 44 -24 57 3 11 1 24 -4 27 -6 4 -8 -2 -5 -14 9
-36 -6 -21 -38 35 -17 30 -35 58 -40 61 -5 3 -7 17 -4 32 4 19 3 21 -3 9 -6
-15 -11 -12 -30 22 -13 23 -20 41 -17 41 4 0 -5 14 -19 31 -15 17 -38 56 -53
87 -14 32 -29 59 -32 62 -3 3 -24 40 -45 83 -28 54 -41 94 -43 130 -2 29 -7
53 -13 55 -5 2 -10 11 -11 20 0 11 -2 13 -6 4 -3 -7 -1 -18 5 -25 14 -19 25
-70 12 -62 -17 10 -41 77 -35 96 4 12 -1 23 -14 31 -12 7 -21 17 -21 22 0 9
-44 116 -61 149 -5 9 -6 29 -3 44 5 17 3 24 -4 19 -17 -10 -76 160 -74 219 0
26 0 27 -5 5 -4 -19 -12 -2 -33 70 -65 225 -110 420 -110 477 0 22 -4 43 -9
49 -14 16 -31 150 -26 216 3 47 2 54 -4 28 -7 -30 -9 -31 -10 -10 -2 14 -4 34
-6 45 -26 127 -35 720 -16 937 18 191 51 432 61 442 6 6 10 28 10 51 0 22 7
69 16 105 8 36 19 88 25 115 10 57 25 105 110 373 34 105 65 192 69 192 5 0
11 18 15 41 5 29 14 43 31 51 13 6 24 16 24 22 0 6 -5 5 -12 -2 -24 -24 -26
-11 -5 38 14 33 24 46 29 37 5 -7 7 -3 6 13 -2 31 61 180 79 187 7 3 13 12 13
21 0 23 59 142 70 142 5 0 10 8 10 19 0 22 52 117 141 261 51 82 65 99 67 80
2 -13 11 -30 19 -38 13 -13 16 -13 24 -1 5 8 8 19 8 24 0 6 -3 4 -6 -2 -8 -22
-21 -14 -32 19 -9 26 -9 35 1 43 7 5 22 26 32 45 20 37 109 164 133 190 28 31
73 93 73 101 0 5 7 6 15 3 8 -4 22 -1 29 6 11 8 20 9 35 0 12 -6 21 -13 21
-15 0 -3 -35 -51 -78 -108 -43 -56 -102 -137 -131 -179 -30 -43 -57 -78 -61
-78 -4 0 -10 -10 -14 -22 -3 -13 -22 -48 -42 -78 -43 -65 -193 -328 -218 -384
-11 -23 -21 -34 -25 -27 -4 6 -7 -5 -7 -25 0 -19 -5 -38 -10 -42 -6 -4 -16
-22 -23 -39 -9 -21 -20 -33 -32 -33 -11 0 -19 -7 -19 -17 0 -15 2 -16 10 -3 5
8 12 12 15 8 3 -3 -5 -30 -19 -59 -14 -30 -39 -90 -56 -134 -17 -44 -35 -89
-40 -100 -5 -11 -23 -65 -40 -120 -18 -55 -36 -109 -40 -120 -10 -22 -41 -130
-60 -210 -6 -27 -15 -59 -20 -70 -12 -30 -41 -167 -60 -290 -10 -60 -19 -105
-21 -100 -2 11 -6 -26 -34 -325 -23 -246 -16 -721 14 -940 23 -171 55 -366 70
-434 9 -36 9 -52 0 -62 -9 -11 -8 -14 5 -14 10 0 16 -8 16 -23 0 -13 4 -27 9
-32 5 -6 16 -43 25 -84 14 -60 15 -76 4 -82 -10 -7 -10 -9 2 -9 10 0 33 -56
76 -185 50 -152 58 -187 47 -196 -7 -6 -13 -16 -13 -21 0 -5 7 -2 16 7 15 14
21 3 81 -142 35 -87 67 -167 70 -178 4 -11 11 -23 18 -27 6 -4 24 -38 40 -75
15 -37 33 -75 40 -83 22 -29 65 -122 60 -130 -3 -5 3 -15 12 -22 21 -15 73
-93 73 -108 0 -5 4 -10 10 -10 5 0 17 -17 26 -37 10 -21 37 -64 61 -96 24 -31
43 -60 43 -63 0 -9 57 -89 136 -189 41 -53 71 -101 68 -107 -4 -6 -3 -8 4 -4
6 3 24 -10 40 -30 29 -35 30 -36 11 -55 -10 -10 -19 -24 -19 -31 0 -6 8 -2 18
8 27 30 37 27 78 -24 21 -26 54 -62 74 -81 21 -21 35 -44 35 -59 0 -14 6 -26
13 -28 7 -1 8 0 2 3 -5 2 -10 12 -10 21 0 12 5 10 25 -8 l26 -24 -23 -13 -23
-12 22 -1 c12 0 25 4 28 10 3 5 23 -9 43 -33 20 -24 54 -56 74 -73 20 -16 35
-35 33 -42 -3 -7 1 -12 8 -10 7 2 30 -13 51 -32 114 -103 129 -119 123 -134
-3 -8 -2 -18 3 -21 6 -4 10 4 10 17 1 20 2 21 13 8 7 -8 29 -28 50 -43 28 -21
37 -35 37 -58 0 -20 5 -29 16 -29 14 0 14 3 4 15 -37 44 31 13 82 -38 7 -7 26
-22 43 -33 41 -26 177 -121 194 -136 7 -6 36 -22 64 -36 l49 -25 -28 -13 -29
-14 32 6 c24 4 46 -3 95 -30 35 -20 98 -55 141 -77 42 -23 77 -45 77 -50 0 -5
7 -9 16 -9 9 0 56 -19 103 -41 143 -69 212 -99 229 -99 8 0 12 -3 9 -6 -6 -7
77 -39 178 -71 28 -8 55 -18 60 -23 6 -4 57 -22 115 -39 58 -18 114 -36 125
-41 11 -5 70 -21 130 -36 61 -14 122 -35 137 -45 15 -11 40 -21 55 -23 16 -2
20 -1 11 1 -38 9 -16 20 25 12 109 -22 331 -59 356 -59 15 0 31 -3 35 -7 4 -5
40 -9 79 -10 87 -2 120 -10 111 -25 -5 -7 -3 -8 6 -3 8 5 185 9 394 11 210 1
400 5 423 8 24 3 60 8 82 10 21 2 43 6 48 9 5 3 33 7 62 8 28 2 54 6 57 11 3
4 17 8 32 7 46 -2 232 31 367 65 33 8 63 12 68 9 5 -3 12 -1 16 5 4 7 38 19
76 28 39 9 86 23 105 30 19 7 78 26 130 43 52 16 124 41 160 55 42 17 76 25
95 21 23 -4 25 -3 10 4 l-20 9 20 8 c11 4 60 25 109 45 49 21 92 36 97 34 4
-3 20 6 35 20 15 14 31 25 36 25 5 0 40 16 79 35 39 19 76 32 82 28 5 -3 7 -2
4 4 -7 12 46 44 87 53 18 4 30 12 28 20 -2 9 5 11 25 6 18 -4 23 -3 15 2 -10
7 -4 15 24 32 30 17 42 20 56 11 12 -7 18 -7 18 -1 0 5 -4 10 -10 10 -5 0 -10
5 -10 10 0 6 4 10 10 10 5 0 46 25 91 55 45 30 83 55 86 55 2 0 20 12 39 26
26 20 33 22 28 9 -6 -15 -5 -16 15 -4 12 8 16 16 11 17 -14 5 8 32 25 32 7 0
15 7 19 15 3 8 12 15 21 15 8 0 15 4 15 8 0 5 21 24 48 42 26 19 68 51 93 72
30 24 53 36 63 32 9 -3 16 -1 16 6 0 6 -4 8 -10 5 -5 -3 -10 -3 -10 2 1 4 21
24 45 43 25 19 45 38 45 42 0 3 10 4 23 2 12 -2 16 -2 9 2 -8 4 -3 15 19 35
17 16 35 29 39 29 4 0 11 7 14 16 4 9 13 14 22 10 9 -3 12 -2 8 5 -5 8 59 79
71 79 2 0 1 -9 -2 -21 -3 -11 -16 -25 -29 -30 -13 -4 -24 -14 -23 -21 0 -10 2
-10 6 0 2 6 13 12 23 12 23 0 31 12 32 50 1 35 8 38 26 10 7 -11 20 -20 30
-19 14 0 13 2 -5 11 -42 20 -35 37 47 119 44 45 80 74 80 66 0 -9 -6 -17 -12
-20 -7 -2 -9 -8 -5 -13 12 -13 28 18 22 44 -4 15 -1 22 10 22 8 0 15 6 15 13
0 7 13 26 29 41 21 20 30 24 35 14 3 -7 4 -4 1 8 -3 13 2 28 16 40 12 10 44
48 72 84 28 36 61 76 74 89 12 12 25 32 28 42 4 11 14 18 22 17 9 -2 18 4 20
12 4 13 3 13 -6 0 -7 -10 -11 -11 -11 -3 0 7 10 22 23 33 12 12 22 24 22 28 1
16 52 81 59 75 4 -4 4 0 0 10 -3 9 -2 17 2 17 5 0 15 12 21 27 7 16 26 43 43
61 16 18 30 39 30 45 1 20 97 167 104 159 4 -4 6 -2 4 3 -3 10 31 96 42 105 4
3 22 38 40 78 19 39 38 72 42 72 4 0 8 6 8 14 0 8 18 52 39 98 57 122 115 262
147 353 15 44 30 82 33 85 3 3 6 10 6 15 1 15 23 92 46 160 12 33 23 78 26
100 3 22 9 42 12 45 4 3 13 30 19 60 7 30 24 107 38 170 30 134 35 165 59 363
10 81 21 144 24 138 10 -16 10 779 -1 879 -25 248 -74 534 -127 740 -39 149
-53 195 -62 206 -5 7 -8 30 -4 51 3 26 2 32 -3 18 -8 -18 -10 -17 -14 10 -3
17 -22 72 -42 124 -20 51 -36 100 -36 107 0 8 -4 14 -10 14 -5 0 -10 6 -10 13
0 11 -21 64 -79 202 -15 37 -92 200 -107 228 -8 15 -12 32 -8 39 4 6 3 8 -2 5
-5 -3 -24 20 -41 51 -17 31 -56 101 -87 155 -31 53 -54 102 -50 109 5 8 2 9
-9 5 -10 -3 -17 -2 -17 4 0 6 -10 25 -22 42 -13 18 -28 42 -35 54 -6 12 -16
28 -22 35 -66 80 -71 92 -48 102 6 3 3 4 -8 3 -14 -2 -31 13 -59 53 -22 30
-42 57 -45 60 -4 3 -20 23 -36 45 -16 22 -37 49 -47 60 -9 11 -26 31 -38 44
-11 14 -18 31 -15 38 2 8 0 11 -5 8 -9 -5 -110 90 -110 103 0 3 -12 16 -26 29
-14 13 -24 27 -20 30 8 8 -14 34 -24 28 -4 -2 -25 14 -47 38 -32 35 -124 121
-278 262 -16 15 -65 55 -107 88 -43 33 -75 64 -72 69 3 5 2 7 -3 6 -5 -2 -33
15 -62 37 -30 22 -68 48 -85 58 -17 11 -53 36 -81 57 -27 20 -63 46 -80 56
-16 10 -34 24 -38 31 -4 7 -14 13 -21 13 -7 0 -42 19 -77 41 -79 52 -149 91
-306 170 -121 62 -122 62 -100 80 12 10 16 18 10 19 -7 0 -13 -4 -13 -9 0 -20
-36 -21 -75 -2 -38 19 -142 63 -212 91 -18 7 -30 17 -26 23 3 6 1 7 -5 3 -12
-7 -132 31 -142 45 -3 4 -22 10 -43 14 -21 4 -41 14 -44 22 -3 8 -9 11 -12 6
-3 -5 -28 -3 -56 5 -42 12 -47 16 -30 23 13 6 7 7 -17 3 -23 -4 -38 -2 -38 4
0 5 -10 10 -22 10 -30 0 -250 57 -244 63 3 2 -12 4 -33 4 -20 0 -55 6 -76 12
-22 7 -58 15 -80 19 -37 6 -38 7 -16 15 36 14 19 21 -18 8 -23 -8 -48 -8 -94
0 -179 33 -473 55 -747 56 -118 0 -208 4 -212 10 -4 5 -16 4 -30 -3 -13 -7
-62 -14 -110 -16 -48 -2 -90 -6 -95 -9 -4 -3 -44 -8 -88 -12 -44 -3 -145 -17
-225 -31 -80 -13 -159 -24 -176 -24 -16 0 -39 -7 -50 -15 -10 -8 -28 -15 -39
-15 -27 0 -234 -50 -262 -62 -11 -6 -26 -8 -31 -4 -6 3 -12 2 -14 -3 -1 -4
-46 -22 -98 -39 -158 -51 -263 -90 -355 -131 -27 -12 -84 -36 -125 -54 -78
-32 -330 -156 -352 -174 -7 -5 -38 -23 -68 -39 -30 -16 -69 -39 -86 -51 -17
-13 -36 -23 -41 -23 -6 0 -16 -7 -24 -16 -7 -9 -22 -14 -36 -11 -18 3 -21 1
-13 -9 8 -9 6 -14 -9 -19 -11 -3 -61 -35 -111 -70 -50 -36 -93 -65 -95 -65 -2
0 -14 -9 -27 -20 -18 -15 -131 -105 -196 -155 -7 -5 -21 -18 -31 -28 -11 -11
-25 -15 -37 -11 -13 4 -15 3 -6 -3 10 -7 -7 -27 -65 -79 -43 -38 -125 -116
-183 -174 -58 -58 -108 -104 -112 -102 -5 1 -7 -2 -6 -6 2 -4 -19 -32 -47 -61
-27 -29 -57 -63 -65 -77 -17 -29 -40 -39 -40 -18 0 8 -5 12 -10 9 -8 -5 -7
-11 1 -21 9 -11 5 -21 -17 -48 -16 -19 -32 -35 -35 -35 -3 -1 -15 8 -28 20
-22 20 -23 20 -36 3 -7 -11 -17 -16 -20 -12 -6 6 117 160 175 219 8 9 34 36
57 61 55 60 63 65 57 31 -3 -20 -2 -24 5 -13 5 8 7 18 5 22 -3 4 1 8 8 8 11 0
11 2 0 9 -10 6 -6 15 15 39 32 37 43 41 36 12 -4 -14 0 -20 11 -20 9 0 16 5
16 10 0 6 -4 10 -8 10 -11 0 -12 33 -1 40 4 3 45 41 91 85 46 44 110 103 142
130 32 28 64 55 70 61 6 5 79 61 161 122 83 62 158 119 168 127 9 8 20 15 23
15 3 0 20 11 38 25 18 14 38 25 44 25 6 0 12 4 14 9 5 14 118 72 128 66 5 -3
8 0 5 7 -5 14 129 94 153 92 7 -1 11 0 8 4 -3 3 7 12 22 20 55 30 201 102 207
102 13 0 -8 -22 -29 -30 -14 -6 -16 -9 -5 -9 18 -1 61 33 53 42 -7 6 111 63
191 92 28 10 55 22 60 26 29 21 290 110 293 100 2 -6 10 -11 18 -11 8 0 11 -6
8 -15 -4 -10 -15 -13 -33 -10 -25 5 -25 5 -3 -5 16 -7 30 -6 45 1 l21 12 -23
18 -23 19 29 11 c77 30 113 39 130 32 10 -3 14 -2 10 2 -8 9 122 50 208 65 28
4 91 18 140 30 165 38 391 71 625 90 159 13 694 3 835 -15z m20 -199 c361 -49
575 -95 855 -183 594 -186 1153 -495 1615 -895 634 -548 1094 -1235 1359
-2030 215 -645 282 -1305 200 -1988 -73 -616 -263 -1181 -594 -1765 -12 -22
-35 -59 -51 -82 -16 -23 -29 -45 -29 -48 0 -16 -207 -304 -309 -430 -629 -776
-1495 -1325 -2465 -1565 -418 -103 -717 -135 -1181 -127 -367 7 -586 32 -899
103 -973 221 -1784 704 -2467 1469 -76 86 -232 288 -312 406 -756 1110 -991
2469 -651 3764 93 352 249 732 446 1088 55 100 233 374 295 454 97 126 138
179 148 189 5 6 32 37 60 70 69 81 200 218 325 340 469 455 1105 833 1745
1037 307 98 698 177 1020 206 161 15 749 6 890 -13z m-2742 -8693 c-7 -2 -19
-2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z"/>
<path d="M5558 10173 c23 -2 61 -2 85 0 23 2 4 4 -43 4 -47 0 -66 -2 -42 -4z"/>
<path d="M5265 10160 c-14 -7 -8 -8 20 -3 22 3 42 7 44 9 9 8 -45 2 -64 -6z"/>
<path d="M5858 10163 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"/>
<path d="M5178 10153 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5968 10143 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M4935 10130 c-19 -8 -19 -9 3 -9 12 -1 22 4 22 9 0 6 -1 10 -2 9 -2
0 -12 -4 -23 -9z"/>
<path d="M5293 10133 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M5898 10133 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5403 10123 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M5483 10123 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M5681 10126 c2 -2 65 -6 139 -9 87 -3 112 -2 70 3 -69 8 -216 13
-209 6z"/>
<path d="M6220 10120 c-26 -8 -26 -8 32 -29 17 -7 29 -7 33 -1 4 6 -6 10 -21
10 -22 0 -25 2 -14 15 13 16 8 17 -30 5z"/>
<path d="M4858 10103 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4670 10091 c-24 -7 -24 -7 9 -14 19 -4 36 -5 39 -2 3 3 -3 5 -14 6
-18 0 -18 1 1 9 24 10 1 11 -35 1z"/>
<path d="M4780 10086 c0 -14 29 -30 38 -21 3 3 0 5 -6 5 -19 0 -14 18 6 23 10
3 6 5 -10 6 -18 1 -28 -4 -28 -13z"/>
<path d="M6408 10093 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4863 10073 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"/>
<path d="M6228 10073 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6380 10070 c-21 -7 -21 -8 -5 -9 11 0 27 4 35 9 18 11 5 11 -30 0z"/>
<path d="M4648 10063 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6480 10061 c0 -5 9 -7 20 -4 11 3 20 7 20 9 0 2 -9 4 -20 4 -11 0
-20 -4 -20 -9z"/>
<path d="M4710 10050 c-18 -12 -2 -12 25 0 13 6 15 9 5 9 -8 0 -22 -4 -30 -9z"/>
<path d="M4440 10040 c-13 -9 -13 -10 0 -10 8 0 22 5 30 10 13 9 13 10 0 10
-8 0 -22 -5 -30 -10z"/>
<path d="M6508 10033 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6688 10033 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M6735 10020 c3 -5 16 -10 28 -10 18 0 19 2 7 10 -20 13 -43 13 -35 0z"/>
<path d="M4365 10010 c3 -5 14 -10 23 -10 15 0 15 2 2 10 -20 13 -33 13 -25 0z"/>
<path d="M4305 10000 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M6790 9990 c8 -5 22 -9 30 -9 10 0 8 3 -5 9 -27 12 -43 12 -25 0z"/>
<path d="M6703 9983 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M4226 9961 c-12 -5 -16 -10 -9 -14 11 -7 63 8 63 18 0 7 -31 5 -54
-4z"/>
<path d="M7025 9940 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M4000 9892 c0 -14 41 -26 67 -19 11 3 6 5 -12 6 -17 0 -36 6 -43 13
-9 9 -12 9 -12 0z"/>
<path d="M7113 9882 c-7 -4 9 -8 35 -9 34 -1 41 1 27 7 -26 11 -47 12 -62 2z"/>
<path d="M3914 9865 c8 -8 18 -15 22 -15 3 0 1 7 -6 15 -7 8 -17 15 -22 15 -5
0 -3 -7 6 -15z"/>
<path d="M7211 9850 c-13 -12 -18 -20 -10 -20 16 1 49 24 49 34 0 11 -14 6
-39 -14z"/>
<path d="M3848 9830 c18 -11 36 -20 40 -20 14 1 -43 40 -58 40 -8 0 0 -9 18
-20z"/>
<path d="M3950 9840 c-18 -12 -2 -12 25 0 13 6 15 9 5 9 -8 0 -22 -4 -30 -9z"/>
<path d="M7292 9834 c-11 -12 -9 -14 8 -14 11 0 20 4 20 9 0 17 -15 19 -28 5z"/>
<path d="M7230 9826 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0
-15 -2 -15 -4z"/>
<path d="M7310 9800 c-12 -8 -11 -10 7 -10 12 0 25 5 28 10 8 13 -15 13 -35 0z"/>
<path d="M7368 9803 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7435 9780 c-3 -5 1 -10 10 -10 9 0 13 5 10 10 -3 6 -8 10 -10 10 -2
0 -7 -4 -10 -10z"/>
<path d="M3668 9773 c18 -7 15 -21 -5 -25 -10 -3 1 -5 25 -5 l43 0 -28 18
c-15 11 -32 19 -38 18 -5 0 -4 -3 3 -6z"/>
<path d="M7378 9773 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3625 9760 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"/>
<path d="M7388 9753 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7431 9751 c-10 -6 -10 -10 -1 -16 13 -8 24 -1 19 14 -3 6 -10 7 -18
2z"/>
<path d="M7532 9738 c2 -6 10 -14 16 -16 7 -2 10 2 6 12 -7 18 -28 22 -22 4z"/>
<path d="M3615 9720 c3 -5 13 -10 21 -10 8 0 12 5 9 10 -3 6 -13 10 -21 10 -8
0 -12 -4 -9 -10z"/>
<path d="M7478 9723 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M7585 9709 c4 -6 9 -8 12 -5 3 3 14 1 24 -5 11 -6 19 -6 19 0 0 10
-24 21 -46 21 -9 0 -12 -5 -9 -11z"/>
<path d="M7558 9683 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3510 9668 c0 -12 22 -21 29 -11 3 6 13 13 21 16 8 3 0 4 -17 4 -18
-1 -33 -5 -33 -9z"/>
<path d="M7700 9656 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 -5 3
-10 -1 -10 -9z"/>
<path d="M3418 9643 c18 -4 21 -9 16 -26 -6 -20 -6 -20 10 -4 10 9 23 17 29
18 19 2 -36 17 -58 17 -16 -1 -15 -2 3 -5z"/>
<path d="M7755 9633 c11 -3 23 -10 27 -16 4 -6 10 -8 15 -4 10 11 -17 27 -42
26 l-20 -1 20 -5z"/>
<path d="M3336 9614 c-17 -12 -17 -14 -4 -14 9 0 20 5 23 11 11 17 2 18 -19 3z"/>
<path d="M3370 9610 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0 -15
-4 -15 -10z"/>
<path d="M7720 9606 c0 -9 40 -13 46 -5 3 5 -6 9 -20 9 -14 0 -26 -2 -26 -4z"/>
<path d="M7820 9595 c18 -22 5 -30 -27 -16 -26 10 -27 10 -9 -4 11 -8 30 -15
42 -15 17 0 20 5 16 25 -2 14 -11 25 -19 25 -13 0 -13 -3 -3 -15z"/>
<path d="M3236 9554 c-11 -8 -16 -14 -10 -14 13 0 39 18 34 24 -3 2 -14 -2
-24 -10z"/>
<path d="M7840 9540 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3
-15 1 -15 -4z"/>
<path d="M7920 9541 c0 -9 30 -24 36 -18 2 1 -6 8 -16 15 -11 7 -20 8 -20 3z"/>
<path d="M3165 9525 l-30 -14 40 1 c22 1 34 3 27 6 -7 2 -10 8 -6 13 6 11 7
11 -31 -6z"/>
<path d="M7880 9516 c0 -7 40 -14 44 -7 3 4 -6 8 -20 9 -13 1 -24 0 -24 -2z"/>
<path d="M3209 9493 c-13 -15 -12 -15 9 -4 23 12 28 21 13 21 -5 0 -15 -7 -22
-17z"/>
<path d="M7960 9489 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M3165 9480 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"/>
<path d="M7980 9460 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0
-15 -4 -15 -10z"/>
<path d="M8025 9440 c-15 -7 -16 -9 -4 -9 9 -1 22 -8 29 -16 7 -8 18 -15 24
-15 6 1 1 9 -11 19 -12 10 -19 21 -16 25 8 8 3 7 -22 -4z"/>
<path d="M8075 9441 c-3 -5 -2 -12 3 -15 5 -3 9 1 9 9 0 17 -3 19 -12 6z"/>
<path d="M3020 9420 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M2978 9393 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8156 9392 c-3 -6 3 -12 15 -15 12 -3 19 -1 16 6 -5 15 -24 20 -31 9z"/>
<path d="M2916 9365 c-11 -8 -15 -15 -10 -15 6 0 19 7 30 15 10 8 15 14 9 14
-5 0 -19 -6 -29 -14z"/>
<path d="M8205 9360 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M8205 9320 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M8240 9321 c0 -10 30 -24 37 -17 3 2 -5 9 -16 16 -12 6 -21 7 -21 1z"/>
<path d="M2829 9293 c-13 -15 -12 -15 9 -4 23 12 28 21 13 21 -5 0 -15 -7 -22
-17z"/>
<path d="M2890 9301 c0 -6 5 -13 10 -16 6 -3 10 1 10 9 0 9 -4 16 -10 16 -5 0
-10 -4 -10 -9z"/>
<path d="M8285 9260 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M2740 9240 c-12 -8 -10 -10 8 -10 13 0 20 4 17 10 -7 12 -6 12 -25 0z"/>
<path d="M8370 9219 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M8410 9201 c-8 -6 -18 -7 -24 -4 -5 3 -6 1 -2 -5 5 -9 13 -9 27 -2
10 6 19 13 19 15 0 7 -3 6 -20 -4z"/>
<path d="M8470 9178 c0 -10 40 -51 45 -46 3 2 -6 15 -20 28 -14 13 -25 21 -25
18z"/>
<path d="M2655 9140 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M2631 9123 c-1 -18 13 -23 29 -11 12 8 12 9 -2 5 -9 -3 -19 -1 -22 6
-3 9 -5 9 -5 0z"/>
<path d="M8550 9117 c0 -9 10 -22 23 -28 l22 -12 -20 24 c-11 13 -21 26 -22
28 -2 2 -3 -3 -3 -12z"/>
<path d="M8495 9110 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M2595 9089 c-10 -15 3 -25 16 -12 7 7 7 13 1 17 -6 3 -14 1 -17 -5z"/>
<path d="M8554 9059 c-3 -6 -2 -15 3 -20 5 -5 9 -1 10 11 2 22 -2 25 -13 9z"/>
<path d="M2505 9040 c-3 -5 1 -10 9 -10 8 0 18 5 21 10 3 6 -1 10 -9 10 -8 0
-18 -4 -21 -10z"/>
<path d="M8580 9046 c0 -2 7 -9 15 -16 12 -10 15 -10 15 4 0 9 -7 16 -15 16
-8 0 -15 -2 -15 -4z"/>
<path d="M2476 9015 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0
-7 -7 -4 -15z"/>
<path d="M8631 9010 c-2 -28 12 -40 31 -26 11 8 14 17 7 27 -7 11 -9 11 -9 -3
0 -10 -4 -18 -9 -18 -5 0 -12 8 -14 18 -3 12 -5 13 -6 2z"/>
<path d="M2458 8963 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8715 8950 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M8755 8920 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M2328 8888 c-6 -16 20 -43 30 -33 4 4 2 10 -5 12 -7 2 -9 11 -6 19 3
8 1 14 -5 14 -6 0 -12 -6 -14 -12z"/>
<path d="M8833 8860 c1 -16 9 -26 22 -29 11 -2 23 -8 27 -15 6 -8 8 -7 8 2 0
7 -11 17 -24 22 -13 5 -27 17 -30 27 -3 11 -4 9 -3 -7z"/>
<path d="M8795 8860 c-7 -11 20 -59 33 -61 4 0 17 -2 29 -3 12 -1 20 1 17 6
-4 5 -12 7 -20 4 -19 -7 -55 30 -48 49 7 17 -1 20 -11 5z"/>
<path d="M2276 8836 c-27 -24 -34 -46 -16 -46 6 0 10 5 10 12 0 6 10 22 22 35
28 30 16 30 -16 -1z"/>
<path d="M2301 8816 c-7 -8 -8 -17 -3 -19 4 -3 13 3 20 14 14 22 0 26 -17 5z"/>
<path d="M2271 8767 c-13 -21 -12 -21 5 -5 10 10 16 20 13 22 -3 3 -11 -5 -18
-17z"/>
<path d="M2195 8760 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M8910 8755 c7 -9 15 -13 17 -11 7 7 -7 26 -19 26 -6 0 -6 -6 2 -15z"/>
<path d="M2217 8734 c-10 -13 -14 -24 -9 -24 13 0 35 27 30 39 -1 5 -11 -2
-21 -15z"/>
<path d="M8956 8705 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M2153 8670 c-29 -26 -33 -40 -11 -40 5 0 7 4 3 9 -3 5 7 19 21 30 15
12 25 23 23 25 -2 3 -18 -8 -36 -24z"/>
<path d="M8990 8692 c0 -12 19 -26 26 -19 2 2 -2 10 -11 17 -9 8 -15 8 -15 2z"/>
<path d="M9021 8646 c-13 -7 -20 -15 -15 -18 5 -3 18 3 28 13 23 22 20 23 -13
5z"/>
<path d="M2075 8630 c-10 -11 -15 -20 -12 -20 4 0 16 9 27 20 11 11 16 20 12
20 -5 0 -17 -9 -27 -20z"/>
<path d="M9073 8620 c1 -19 8 -26 27 -27 21 -2 22 -1 6 5 -11 5 -23 17 -28 28
-6 16 -7 15 -5 -6z"/>
<path d="M2077 8589 c-16 -16 -27 -34 -25 -39 2 -5 18 9 36 30 39 46 30 53
-11 9z"/>
<path d="M2010 8559 c0 -6 8 -18 17 -27 16 -16 16 -16 10 1 -4 10 -7 23 -7 28
0 5 -4 9 -10 9 -5 0 -10 -5 -10 -11z"/>
<path d="M1991 8546 c0 -10 -9 -25 -18 -32 -10 -7 -13 -14 -7 -14 18 0 36 27
31 47 -4 17 -5 17 -6 -1z"/>
<path d="M9078 8553 c6 -2 12 -11 12 -19 0 -8 5 -14 10 -14 6 0 10 4 10 8 0
12 -22 32 -34 31 -6 0 -5 -3 2 -6z"/>
<path d="M9146 8506 c3 -9 11 -16 16 -16 13 0 5 23 -10 28 -7 2 -10 -2 -6 -12z"/>
<path d="M9206 8455 c-5 -14 -9 -15 -21 -5 -19 16 -20 3 -1 -15 12 -12 15 -12
21 3 5 15 9 14 25 -8 11 -14 20 -20 20 -15 0 6 -9 21 -19 34 -16 21 -19 22
-25 6z"/>
<path d="M1945 8449 c-11 -17 1 -21 15 -4 8 9 8 15 2 15 -6 0 -14 -5 -17 -11z"/>
<path d="M9254 8398 c-5 -8 -2 -9 10 -5 14 5 16 3 11 -12 -6 -21 10 -38 20
-21 7 11 -12 50 -25 50 -5 0 -12 -5 -16 -12z"/>
<path d="M1841 8371 c-1 -8 -10 -24 -21 -36 -20 -22 -20 -22 0 -20 11 1 23 5
27 10 5 4 2 5 -4 1 -16 -9 -17 6 -2 21 6 6 9 17 6 25 -4 10 -6 10 -6 -1z"/>
<path d="M1870 8349 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M9310 8331 c0 -5 -10 -12 -22 -14 -20 -4 -19 -4 5 -6 18 -1 27 4 27
14 0 8 -2 15 -5 15 -3 0 -5 -4 -5 -9z"/>
<path d="M1795 8290 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M9310 8286 c0 -18 22 -56 32 -55 10 0 10 2 1 6 -7 2 -13 13 -13 23 0
10 -4 22 -10 25 -5 3 -10 4 -10 1z"/>
<path d="M1785 8230 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M1736 8221 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 -4 11 -6 11 -12 0z"/>
<path d="M9357 8199 c4 -13 8 -18 11 -10 2 7 -1 18 -6 23 -8 8 -9 4 -5 -13z"/>
<path d="M9433 8155 c-3 -9 -3 -18 -1 -21 3 -3 8 4 11 16 6 23 -1 27 -10 5z"/>
<path d="M9450 8141 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5
3 -10 2 -10 -4z"/>
<path d="M1675 8130 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M1699 8110 c-15 -17 -23 -33 -17 -36 11 -7 11 -7 32 34 20 39 18 39
-15 2z"/>
<path d="M1652 8108 c-7 -7 -12 -16 -12 -21 0 -5 7 -1 16 8 9 9 14 18 12 20
-2 3 -10 -1 -16 -7z"/>
<path d="M9420 8115 c0 -5 4 -16 9 -23 6 -11 10 -10 15 4 3 9 4 19 1 22 -3 3
-5 -1 -5 -9 0 -11 -2 -11 -10 1 -5 8 -10 11 -10 5z"/>
<path d="M9476 8071 c-5 -8 -2 -20 8 -29 17 -17 19 -9 7 22 -6 15 -10 16 -15
7z"/>
<path d="M1650 8060 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M1615 8020 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M9510 7980 c13 -23 20 -26 20 -6 0 8 -7 16 -15 20 -13 4 -14 2 -5
-14z"/>
<path d="M1567 7973 c-4 -3 -7 -13 -7 -22 1 -13 3 -13 11 2 11 19 8 33 -4 20z"/>
<path d="M9562 7949 c2 -7 10 -15 17 -17 8 -3 12 1 9 9 -2 7 -10 15 -17 17 -8
3 -12 -1 -9 -9z"/>
<path d="M1601 7934 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1575 7919 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M9600 7900 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M1503 7864 c-15 -16 -16 -24 -4 -24 8 0 24 30 19 35 -2 2 -9 -3 -15
-11z"/>
<path d="M9620 7864 c0 -8 5 -12 10 -9 6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0
-10 -7 -10 -16z"/>
<path d="M1523 7825 c-3 -9 -3 -18 -1 -21 3 -3 8 4 11 16 6 23 -1 27 -10 5z"/>
<path d="M9662 7820 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M1465 7790 c-4 -16 -12 -30 -18 -30 -11 0 -26 -25 -45 -70 -5 -13 -3
-13 10 -2 9 7 19 24 22 38 4 14 10 23 15 20 4 -3 13 5 19 17 17 37 22 57 12
57 -4 0 -11 -13 -15 -30z"/>
<path d="M9627 7800 c3 -11 9 -20 15 -20 5 0 4 9 -2 20 -6 11 -12 20 -14 20
-2 0 -2 -9 1 -20z"/>
<path d="M1501 7783 c-1 -12 -7 -24 -13 -26 -10 -4 -10 -6 0 -6 15 -1 26 23
19 41 -3 7 -6 3 -6 -9z"/>
<path d="M9690 7759 c0 -8 7 -23 15 -33 11 -14 15 -16 15 -5 0 8 -7 23 -15 33
-11 14 -15 16 -15 5z"/>
<path d="M9656 7745 c4 -8 11 -15 16 -15 6 0 5 6 -2 15 -7 8 -14 15 -16 15 -2
0 -1 -7 2 -15z"/>
<path d="M1437 7697 c-3 -8 -2 -20 3 -26 5 -9 8 -4 8 13 0 29 -3 32 -11 13z"/>
<path d="M9710 7650 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M9750 7635 c0 -8 5 -15 11 -15 6 0 8 -7 5 -16 -3 -9 -1 -14 5 -12 6
2 10 7 9 11 -8 35 -14 47 -21 47 -5 0 -9 -7 -9 -15z"/>
<path d="M1376 7611 c-4 -6 -12 -9 -17 -6 -5 3 -6 -1 -2 -10 5 -13 7 -14 14
-3 7 11 11 10 19 -2 5 -8 10 -10 10 -5 0 20 -17 38 -24 26z"/>
<path d="M1377 7563 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M9796 7530 c-9 -47 -8 -50 14 -50 12 0 20 7 20 16 0 14 -3 14 -15 4
-12 -10 -15 -10 -15 3 0 8 5 17 12 19 8 3 8 9 1 22 -9 16 -11 14 -17 -14z"/>
<path d="M9850 7450 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M1278 7443 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M9820 7435 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25
-5 8 -10 11 -10 5z"/>
<path d="M1290 7421 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M9851 7394 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1251 7377 c-13 -21 -12 -21 5 -5 10 10 16 20 13 22 -3 3 -11 -5 -18
-17z"/>
<path d="M9883 7368 c3 -10 2 -20 -3 -23 -13 -8 -13 -62 0 -70 6 -3 7 1 4 9
-3 9 -1 30 5 48 8 24 8 34 0 42 -9 8 -10 6 -6 -6z"/>
<path d="M1226 7315 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0
-6 -7 -10 -15z"/>
<path d="M9901 7294 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1243 7285 c-7 -8 -12 -24 -12 -37 1 -21 2 -21 6 -3 3 11 11 24 19
28 15 8 19 27 7 27 -5 -1 -14 -7 -20 -15z"/>
<path d="M9936 7277 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M1191 7244 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M9890 7251 c0 -6 5 -13 10 -16 6 -3 10 1 10 9 0 9 -4 16 -10 16 -5 0
-10 -4 -10 -9z"/>
<path d="M9911 7204 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1210 7189 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M1191 7161 c-7 -5 -11 -15 -9 -22 3 -10 8 -7 17 9 13 24 12 26 -8 13z"/>
<path d="M1150 7131 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M9956 7100 c13 -51 24 -71 35 -64 7 4 8 9 1 13 -5 3 -17 22 -26 41
-9 21 -13 25 -10 10z"/>
<path d="M1110 7051 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M1093 6988 c-7 -17 -5 -32 9 -58 17 -34 18 -34 11 -5 -4 17 -7 42 -6
58 3 33 -1 34 -14 5z"/>
<path d="M1137 7003 c-4 -3 -7 -20 -6 -37 l1 -31 8 35 c9 36 8 45 -3 33z"/>
<path d="M10036 6965 c-4 -19 -3 -43 2 -52 7 -12 10 -2 10 35 0 29 -2 52 -3
52 -2 0 -6 -16 -9 -35z"/>
<path d="M1072 6925 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M10084 6855 c-1 -26 2 -41 6 -35 5 7 10 1 14 -15 4 -15 9 -25 12 -22
5 5 -3 39 -25 100 -3 10 -6 -3 -7 -28z"/>
<path d="M1080 6849 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M1037 6836 c-4 -10 -7 -25 -6 -34 0 -11 4 -9 10 7 5 13 8 29 6 35 -2
5 -6 2 -10 -8z"/>
<path d="M10050 6815 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25
-5 8 -10 11 -10 5z"/>
<path d="M1051 6764 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1017 6764 c-4 -4 -7 -14 -7 -23 0 -11 3 -12 11 -4 6 6 10 16 7 23
-2 6 -7 8 -11 4z"/>
<path d="M990 6650 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M10126 6557 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M971 6544 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M951 6498 c1 -7 5 -24 9 -38 8 -24 8 -24 9 7 1 17 -3 35 -9 38 -5 3
-10 0 -9 -7z"/>
<path d="M992 6485 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M10146 6491 c-3 -5 1 -11 9 -15 9 -3 15 0 15 9 0 16 -16 20 -24 6z"/>
<path d="M931 6413 c-21 -84 -23 -102 -5 -63 15 32 30 110 21 110 -2 0 -9 -21
-16 -47z"/>
<path d="M971 6400 c0 -33 1 -34 10 -11 6 16 6 28 -1 35 -7 7 -10 -1 -9 -24z"/>
<path d="M10190 6410 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5
0 -10 -4 -10 -10z"/>
<path d="M10222 6300 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M952 6260 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M10252 6180 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M10200 6153 c0 -5 5 -15 10 -23 7 -12 9 -10 7 8 -1 19 -17 33 -17 15z"/>
<path d="M873 6075 c0 -27 2 -38 4 -22 2 15 2 37 0 50 -2 12 -4 0 -4 -28z"/>
<path d="M891 6094 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M916 6088 c-3 -13 -5 -32 -5 -43 1 -11 5 -2 10 19 10 42 6 62 -5 24z"/>
<path d="M10241 6064 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M10232 5980 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M10252 5975 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M867 5915 c3 -38 7 -72 9 -74 7 -8 3 64 -6 104 -7 31 -7 24 -3 -30z"/>
<path d="M10281 5915 c0 -27 3 -56 8 -63 5 -8 6 8 4 40 -6 73 -11 83 -12 23z"/>
<path d="M890 5878 c0 -39 2 -69 4 -67 8 9 13 139 5 139 -5 0 -9 -32 -9 -72z"/>
<path d="M10231 5904 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M10252 5865 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M832 5735 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M862 5655 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M881 5664 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M832 5625 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M831 5284 c0 -160 9 -224 22 -173 9 34 7 48 -3 24 -5 -12 -8 41 -8
138 1 86 -2 160 -5 164 -4 3 -7 -65 -6 -153z"/>
<path d="M880 5240 c-2 -42 -3 -43 -10 -15 -7 28 -8 28 -9 5 0 -14 3 -32 8
-39 8 -12 11 -10 16 11 4 14 5 39 2 54 -3 22 -5 18 -7 -16z"/>
<path d="M882 5135 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M873 5055 c0 -27 2 -38 4 -22 2 15 2 37 0 50 -2 12 -4 0 -4 -28z"/>
<path d="M846 4993 c4 -27 11 -52 17 -58 6 -7 8 -2 3 15 -3 14 -6 40 -6 58 0
17 -4 32 -10 32 -6 0 -7 -19 -4 -47z"/>
<path d="M10241 5024 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M886 4963 c-4 -38 -2 -81 3 -98 5 -16 10 -22 10 -13 1 9 4 25 7 35 5
15 4 16 -6 3 -9 -12 -10 3 -5 63 4 42 5 77 2 77 -3 0 -8 -30 -11 -67z"/>
<path d="M10282 4930 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"/>
<path d="M10247 4891 c-4 -17 -3 -21 5 -13 5 5 8 16 6 23 -3 8 -7 3 -11 -10z"/>
<path d="M10223 4835 c0 -16 2 -43 6 -60 l7 -30 6 28 c3 15 2 27 -3 27 -4 0
-10 15 -12 33 -4 32 -4 32 -4 2z"/>
<path d="M877 4810 c-9 -33 -8 -50 2 -25 7 16 10 12 19 -25 l10 -45 1 43 c1
26 5 41 11 37 6 -4 7 1 3 11 -4 11 -8 13 -11 6 -6 -18 -20 -15 -24 6 -3 13 -5
11 -11 -8z"/>
<path d="M10262 4800 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"/>
<path d="M10187 4586 c-4 -10 -5 -21 -2 -24 9 -9 17 6 13 25 -3 17 -4 17 -11
-1z"/>
<path d="M910 4551 c0 -6 5 -13 10 -16 6 -3 10 1 10 9 0 9 -4 16 -10 16 -5 0
-10 -4 -10 -9z"/>
<path d="M935 4479 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M954 4449 c-3 -6 -1 -16 5 -22 8 -8 11 -5 11 11 0 24 -5 28 -16 11z"/>
<path d="M10144 4395 c-4 -14 -4 -29 0 -32 3 -4 6 4 6 16 0 12 4 19 10 16 6
-3 7 1 4 9 -8 22 -13 20 -20 -9z"/>
<path d="M961 4384 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M10157 4350 c-4 -14 -7 -32 -7 -40 0 -13 1 -13 10 0 8 13 10 12 10
-4 0 -11 2 -17 5 -14 3 3 2 23 -3 44 -7 36 -9 37 -15 14z"/>
<path d="M10121 4284 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M991 4230 c0 -8 4 -24 9 -35 5 -13 9 -14 9 -5 0 8 -4 24 -9 35 -5 13
-9 14 -9 5z"/>
<path d="M10117 4140 c-3 -11 -1 -20 4 -20 5 0 9 9 9 20 0 11 -2 20 -4 20 -2
0 -6 -9 -9 -20z"/>
<path d="M1033 4095 c-6 -6 -8 -18 -3 -24 5 -9 9 -5 13 10 7 28 6 31 -10 14z"/>
<path d="M1065 4101 c-3 -5 -1 -12 5 -16 5 -3 10 1 10 9 0 18 -6 21 -15 7z"/>
<path d="M10087 4074 c3 -7 9 -14 14 -14 14 0 10 17 -5 23 -10 4 -13 1 -9 -9z"/>
<path d="M1051 4064 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1082 4040 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M10072 4020 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M10040 4011 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M1096 4002 c-2 -4 -1 -14 5 -22 7 -12 9 -10 9 8 0 23 -5 28 -14 14z"/>
<path d="M1071 3954 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M10031 3954 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M10061 3954 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1111 3904 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M10001 3890 c0 -8 4 -24 9 -35 5 -13 9 -14 9 -5 0 8 -4 24 -9 35 -5
13 -9 14 -9 5z"/>
<path d="M10027 3832 l-18 -37 20 25 c12 14 21 31 21 38 0 19 -4 15 -23 -26z"/>
<path d="M1136 3845 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M1157 3800 c-3 -11 -1 -20 4 -20 5 0 9 9 9 20 0 11 -2 20 -4 20 -2 0
-6 -9 -9 -20z"/>
<path d="M9970 3796 c0 -8 7 -16 15 -20 8 -3 15 -13 15 -22 0 -10 3 -15 6 -11
8 7 -18 67 -28 67 -5 0 -8 -6 -8 -14z"/>
<path d="M9950 3770 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M1130 3749 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M9961 3724 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1195 3720 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M1152 3700 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M9952 3640 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M9903 3624 c-6 -13 -8 -24 -4 -24 10 0 31 39 23 44 -4 2 -12 -7 -19
-20z"/>
<path d="M9926 3584 c-9 -35 -4 -39 11 -8 6 13 8 26 3 29 -4 3 -11 -7 -14 -21z"/>
<path d="M9901 3554 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M9862 3530 c-17 -27 -15 -35 4 -16 8 9 14 21 12 26 -2 6 -9 1 -16
-10z"/>
<path d="M9882 3490 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M1281 3484 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M9831 3464 c-11 -13 -11 -18 -1 -24 7 -4 10 -17 6 -31 -3 -13 -3 -18
0 -11 3 6 10 10 15 6 5 -3 9 2 9 10 0 8 -5 18 -10 21 -6 4 -8 15 -5 26 8 23 5
23 -14 3z"/>
<path d="M1341 3363 c0 -6 -4 -20 -7 -30 -5 -14 -4 -15 5 -7 7 7 11 20 8 30
-3 11 -5 14 -6 7z"/>
<path d="M9807 3363 c-12 -21 -16 -63 -7 -63 5 0 11 6 11 13 1 6 3 22 4 35 2
22 -1 28 -8 15z"/>
<path d="M9770 3345 c0 -8 2 -15 4 -15 2 0 6 7 10 15 3 8 1 15 -4 15 -6 0 -10
-7 -10 -15z"/>
<path d="M1346 3292 c-2 -4 -1 -14 5 -22 7 -12 9 -10 9 8 0 23 -5 28 -14 14z"/>
<path d="M1380 3290 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M1390 3236 c0 -8 5 -18 10 -21 6 -3 10 1 10 9 0 8 -4 18 -10 21 -5 3
-10 -1 -10 -9z"/>
<path d="M9726 3194 c-9 -23 -7 -36 3 -30 12 8 21 46 11 46 -4 0 -11 -7 -14
-16z"/>
<path d="M1402 3178 c7 -13 14 -25 16 -28 5 -7 22 24 22 40 0 13 -1 13 -11 0
-8 -11 -12 -12 -16 -2 -2 6 -9 12 -14 12 -5 0 -4 -10 3 -22z"/>
<path d="M9691 3133 c-1 -18 4 -33 9 -33 12 0 12 17 0 45 -7 17 -9 15 -9 -12z"/>
<path d="M9670 3075 c0 -8 2 -15 4 -15 2 0 6 7 10 15 3 8 1 15 -4 15 -6 0 -10
-7 -10 -15z"/>
<path d="M1480 3032 c0 -5 7 -15 15 -22 8 -7 15 -9 15 -6 0 4 -7 14 -15 22 -8
9 -15 11 -15 6z"/>
<path d="M1538 3008 c7 -7 12 -21 12 -32 0 -14 3 -17 11 -9 12 12 -8 53 -25
53 -6 0 -5 -5 2 -12z"/>
<path d="M9621 2989 c-18 -42 -10 -45 11 -3 10 19 14 34 10 34 -4 0 -13 -14
-21 -31z"/>
<path d="M9570 2978 c-12 -22 -12 -22 6 -6 10 10 15 20 12 24 -4 3 -12 -5 -18
-18z"/>
<path d="M1550 2943 c0 -5 5 -15 10 -23 8 -12 10 -11 10 8 0 12 -4 22 -10 22
-5 0 -10 -3 -10 -7z"/>
<path d="M1590 2914 c0 -7 27 -34 34 -34 4 0 1 9 -6 20 -12 19 -28 27 -28 14z"/>
<path d="M9542 2868 c-14 -14 -16 -28 -3 -28 9 0 24 30 18 36 -2 2 -9 -2 -15
-8z"/>
<path d="M1630 2855 c0 -8 4 -15 10 -15 5 0 7 7 4 15 -4 8 -8 15 -10 15 -2 0
-4 -7 -4 -15z"/>
<path d="M9497 2863 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M1687 2793 c8 -23 33 -60 33 -50 0 11 -29 67 -35 67 -2 0 -2 -8 2
-17z"/>
<path d="M1650 2782 c6 -13 14 -21 18 -18 3 4 -2 14 -12 24 -18 16 -18 16 -6
-6z"/>
<path d="M9463 2764 c-6 -13 -7 -24 -3 -24 9 0 25 39 18 45 -2 2 -8 -7 -15
-21z"/>
<path d="M1675 2731 c-3 -6 1 -11 9 -11 9 0 16 -7 16 -15 0 -8 5 -15 10 -15
16 0 12 15 -9 34 -12 11 -21 14 -26 7z"/>
<path d="M9440 2709 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M1750 2670 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M9375 2620 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M1810 2579 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M9310 2579 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M1842 2575 c4 -4 3 -14 -4 -22 -6 -7 -9 -15 -7 -18 3 -2 10 4 17 15
9 15 9 21 -1 26 -6 4 -9 4 -5 -1z"/>
<path d="M9265 2532 c-27 -34 -37 -52 -31 -52 8 0 59 70 55 74 -2 2 -13 -8
-24 -22z"/>
<path d="M1870 2525 c0 -8 4 -15 10 -15 5 0 7 7 4 15 -4 8 -8 15 -10 15 -2 0
-4 -7 -4 -15z"/>
<path d="M9283 2495 c-8 -9 -9 -16 -3 -20 6 -3 13 1 16 10 9 21 2 26 -13 10z"/>
<path d="M1876 2465 c14 -19 31 -35 37 -35 9 0 -3 17 -40 57 -25 27 -23 11 3
-22z"/>
<path d="M1930 2459 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M9227 2463 c-4 -3 -7 -13 -7 -21 0 -12 3 -12 15 -2 8 7 15 16 15 21
0 11 -14 12 -23 2z"/>
<path d="M1950 2426 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 -5 3
-10 -1 -10 -9z"/>
<path d="M1930 2395 c7 -9 15 -13 17 -11 7 7 -7 26 -19 26 -6 0 -6 -6 2 -15z"/>
<path d="M9167 2398 c6 -11 31 -10 37 1 3 5 -5 8 -18 7 -13 0 -22 -4 -19 -8z"/>
<path d="M9153 2355 c-9 -24 1 -27 15 -5 8 13 8 20 2 20 -6 0 -13 -7 -17 -15z"/>
<path d="M2016 2345 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0
-7 -7 -4 -15z"/>
<path d="M2030 2301 c0 -5 7 -14 15 -21 12 -10 15 -10 15 3 0 8 -7 17 -15 21
-8 3 -15 2 -15 -3z"/>
<path d="M9055 2260 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M2070 2239 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M9060 2229 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M2110 2195 c7 -8 16 -15 21 -15 5 0 6 7 3 15 -4 8 -13 15 -21 15 -13
0 -13 -3 -3 -15z"/>
<path d="M8990 2200 c-12 -8 -11 -10 7 -10 12 0 25 5 28 10 8 13 -15 13 -35 0z"/>
<path d="M2150 2170 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M8950 2155 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25
-5 8 -10 11 -10 5z"/>
<path d="M2180 2132 c0 -5 5 -13 12 -20 16 -16 29 -15 22 2 -6 16 -34 30 -34
18z"/>
<path d="M2230 2119 c0 -11 4 -18 10 -14 5 3 7 12 3 20 -7 21 -13 19 -13 -6z"/>
<path d="M8910 2125 c-8 -9 -8 -15 -2 -15 12 0 26 19 19 26 -2 2 -10 -2 -17
-11z"/>
<path d="M8870 2060 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M8858 2019 c-10 -11 -25 -16 -35 -13 -15 5 -15 4 -4 -4 16 -11 44 -1
56 19 12 18 1 17 -17 -2z"/>
<path d="M2310 2021 c0 -10 29 -36 34 -30 1 2 -6 12 -16 22 -10 9 -18 13 -18
8z"/>
<path d="M2335 2020 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 -8 0 -12 -5 -9 -10z"/>
<path d="M8770 1980 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M2390 1932 c0 -11 4 -23 9 -27 6 -3 8 4 6 16 -6 30 -15 37 -15 11z"/>
<path d="M2415 1940 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M8735 1940 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M2445 1920 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M2470 1901 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5
3 -10 2 -10 -4z"/>
<path d="M8636 1884 c-4 -9 -4 -19 -1 -22 2 -3 7 3 11 12 4 9 4 19 1 22 -2 3
-7 -3 -11 -12z"/>
<path d="M2460 1860 c37 -34 42 -36 33 -14 -5 13 -2 15 17 9 16 -5 20 -4 15 5
-4 6 -17 9 -30 6 -14 -4 -28 0 -35 9 -7 8 -17 15 -22 15 -6 0 4 -13 22 -30z"/>
<path d="M8670 1869 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M8635 1841 c-3 -5 -2 -12 3 -15 5 -3 9 1 9 9 0 17 -3 19 -12 6z"/>
<path d="M2580 1802 c0 -7 -7 -12 -15 -12 -8 0 -15 -4 -15 -10 0 -5 4 -10 9
-10 13 0 35 29 27 37 -3 3 -6 1 -6 -5z"/>
<path d="M8581 1774 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M2590 1760 c19 -13 30 -13 30 0 0 6 -10 10 -22 10 -19 0 -20 -2 -8
-10z"/>
<path d="M8535 1760 c27 -12 43 -12 25 0 -8 5 -22 9 -30 9 -10 0 -8 -3 5 -9z"/>
<path d="M2641 1734 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M8484 1736 c23 -18 42 -21 51 -6 3 6 -3 10 -14 10 -10 0 -28 3 -38 6
-16 5 -16 4 1 -10z"/>
<path d="M8435 1710 c-3 -5 0 -10 9 -10 8 0 23 -3 33 -6 16 -5 16 -4 -1 10
-23 19 -32 20 -41 6z"/>
<path d="M2711 1690 c-9 -5 -10 -10 -2 -14 6 -4 11 -3 11 3 0 6 7 8 15 5 8 -4
15 -4 15 -1 0 10 -27 15 -39 7z"/>
<path d="M2750 1640 c20 -13 43 -13 35 0 -3 6 -16 10 -28 10 -18 0 -19 -2 -7
-10z"/>
<path d="M8338 1633 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2815 1620 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M8300 1608 c-12 -8 -12 -9 2 -5 9 3 19 1 22 -6 3 -9 5 -9 5 0 1 18
-13 23 -29 11z"/>
<path d="M2840 1600 c0 -5 4 -10 9 -10 6 0 13 5 16 10 3 6 -1 10 -9 10 -9 0
-16 -4 -16 -10z"/>
<path d="M2875 1590 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M2845 1560 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M2900 1560 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M8288 1563 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2875 1540 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M2945 1531 c-3 -5 -1 -12 5 -16 5 -3 10 1 10 9 0 18 -6 21 -15 7z"/>
<path d="M2900 1520 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M2930 1500 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M8205 1500 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M8130 1489 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M3037 1473 c-4 -3 -7 -11 -7 -17 0 -6 4 -5 9 3 6 9 11 10 15 2 4 -6
12 -11 18 -11 7 0 6 6 -2 15 -14 16 -23 19 -33 8z"/>
<path d="M8068 1459 c-12 -13 -14 -19 -5 -19 7 0 18 9 25 20 15 25 3 25 -20
-1z"/>
<path d="M8091 1434 c-20 -23 -9 -25 19 -4 16 13 20 20 10 19 -8 0 -21 -7 -29
-15z"/>
<path d="M3030 1430 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0 -15
-4 -15 -10z"/>
<path d="M3085 1400 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M3144 1395 c11 -8 27 -15 35 -15 9 0 3 7 -13 15 -36 19 -47 19 -22 0z"/>
<path d="M8048 1403 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7965 1390 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M7948 1353 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3278 1328 c5 -5 16 -8 23 -6 8 3 3 7 -10 11 -17 4 -21 3 -13 -5z"/>
<path d="M7920 1330 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M7810 1305 c-7 -8 -9 -15 -6 -15 4 0 14 7 22 15 9 8 11 15 6 15 -5 0
-15 -7 -22 -15z"/>
<path d="M7780 1261 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M3395 1240 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 -8 0
-12 -4 -9 -10z"/>
<path d="M7653 1227 c-22 -9 -32 -27 -15 -27 11 1 46 29 41 34 -2 2 -14 -1
-26 -7z"/>
<path d="M3436 1201 c-4 -5 3 -7 14 -4 23 6 26 13 6 13 -8 0 -17 -4 -20 -9z"/>
<path d="M3490 1200 c-13 -8 -12 -11 5 -24 11 -9 25 -15 30 -15 6 0 2 6 -7 13
-27 20 -22 26 15 20 24 -4 28 -3 17 5 -19 13 -40 14 -60 1z"/>
<path d="M7590 1195 c0 -8 8 -15 18 -14 10 0 12 3 4 6 -6 2 -10 9 -6 14 3 5 0
9 -5 9 -6 0 -11 -7 -11 -15z"/>
<path d="M3590 1180 c0 -6 7 -13 15 -16 12 -5 13 -10 4 -20 -9 -11 -8 -14 4
-14 20 0 35 22 19 28 -7 2 -19 10 -27 19 -9 8 -15 10 -15 3z"/>
<path d="M7610 1160 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"/>
<path d="M3562 1151 c4 -13 18 -16 19 -4 0 4 -5 9 -11 12 -7 2 -11 -2 -8 -8z"/>
<path d="M3655 1118 l-30 -20 29 7 c23 5 27 3 23 -9 -5 -13 -3 -14 14 -3 16
10 17 13 4 15 -8 2 -15 8 -15 13 0 12 7 11 31 -1 13 -7 19 -7 19 0 0 5 -4 10
-9 10 -5 0 -15 2 -23 4 -7 3 -26 -5 -43 -16z"/>
<path d="M7430 1101 c0 -10 19 -25 25 -20 1 2 -3 10 -11 17 -8 7 -14 8 -14 3z"/>
<path d="M3715 1080 c-3 -5 1 -10 9 -10 8 0 18 5 21 10 3 6 -1 10 -9 10 -8 0
-18 -4 -21 -10z"/>
<path d="M3778 1083 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3836 1052 c5 -21 3 -23 -18 -18 -20 6 -21 5 -5 -4 14 -9 24 -7 50
10 31 21 31 21 5 16 -16 -4 -29 -1 -32 7 -3 6 -3 1 0 -11z"/>
<path d="M3758 1053 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M7238 1043 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7288 1043 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7176 1024 c-11 -7 -16 -17 -13 -21 4 -4 15 1 24 10 22 21 14 30 -11
11z"/>
<path d="M3878 1003 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4025 990 c3 -5 13 -10 21 -10 8 0 14 5 14 10 0 6 -9 10 -21 10 -11
0 -17 -4 -14 -10z"/>
<path d="M7190 990 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5 0
-17 -5 -25 -10z"/>
<path d="M4116 955 c22 -16 38 -19 30 -6 -4 5 0 11 6 14 7 2 -2 4 -21 5 -30 1
-32 0 -15 -13z"/>
<path d="M7158 963 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6988 943 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7050 940 c-24 -15 -7 -18 25 -4 23 10 25 13 10 13 -11 1 -27 -3 -35
-9z"/>
<path d="M4120 920 c20 -13 33 -13 25 0 -3 6 -14 10 -23 10 -15 0 -15 -2 -2
-10z"/>
<path d="M4250 920 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M4306 905 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0
-6 -7 -10 -15z"/>
<path d="M6908 913 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6960 910 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0 -15
-4 -15 -10z"/>
<path d="M4335 900 c3 -5 13 -10 21 -10 8 0 12 5 9 10 -3 6 -13 10 -21 10 -8
0 -12 -4 -9 -10z"/>
<path d="M6810 880 c-18 -12 -2 -12 25 0 13 6 15 9 5 9 -8 0 -22 -4 -30 -9z"/>
<path d="M4288 868 c5 -5 16 -8 23 -6 8 3 3 7 -10 11 -17 4 -21 3 -13 -5z"/>
<path d="M4408 863 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M4398 838 c6 -6 18 -8 28 -6 14 3 12 5 -9 10 -19 3 -25 2 -19 -4z"/>
<path d="M4600 820 l-45 -7 42 -1 c23 -1 45 3 48 8 3 6 5 9 3 8 -2 0 -23 -4
-48 -8z"/>
<path d="M4713 813 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M6378 813 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6538 813 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6610 816 c0 -2 9 -6 20 -9 11 -3 18 -1 14 4 -5 9 -34 13 -34 5z"/>
<path d="M4808 803 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6314 799 c-10 -17 11 -31 42 -26 29 4 28 4 -3 6 -35 1 -45 17 -15
24 15 4 15 5 0 6 -9 0 -20 -4 -24 -10z"/>
<path d="M4656 791 c-6 -9 54 -25 62 -16 3 3 -2 5 -12 5 -9 0 -14 5 -11 10 3
6 -3 10 -14 10 -11 0 -22 -4 -25 -9z"/>
<path d="M4843 783 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M6413 783 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"/>
<path d="M6488 783 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6073 763 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z"/>
<path d="M5264 752 c5 -8 -5 -12 -31 -13 -25 -1 -29 -3 -13 -6 14 -2 52 1 85
6 47 7 52 9 23 10 -20 0 -44 4 -54 8 -12 4 -15 3 -10 -5z"/>
<path d="M5888 753 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M5985 750 c19 -8 103 -14 94 -6 -2 2 -29 6 -59 9 -34 3 -47 2 -35 -3z"/>
<path d="M5053 743 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M5517 743 c-3 -4 41 -8 98 -8 57 0 102 3 99 6 -5 10 -191 11 -197 2z"/>
<path d="M5825 740 c27 -12 43 -12 25 0 -8 5 -22 9 -30 9 -10 0 -8 -3 5 -9z"/>
<path d="M5105 714 c16 -8 45 -13 65 -11 33 3 33 4 -7 5 -24 1 -43 7 -43 12 0
6 -10 10 -22 10 -21 0 -20 -2 7 -16z"/>
<path d="M5280 723 c0 -5 28 -8 63 -9 41 0 54 2 37 7 -34 10 -100 11 -100 2z"/>
<path d="M5745 720 c-13 -6 -15 -9 -5 -9 8 0 22 4 30 9 18 12 2 12 -25 0z"/>
<path d="M5335 700 c-4 -6 7 -10 27 -9 27 0 30 2 13 9 -27 12 -33 12 -40 0z"/>
<path d="M5448 703 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5538 703 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"/>
<path d="M5633 703 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"/>
<path d="M5933 703 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"/>
<path d="M6008 703 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M5853 693 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M5538 683 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"/>
<path d="M5658 683 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5301 9899 c-79 -5 -214 -18 -300 -29 -706 -93 -1354 -339 -1941
-736 -251 -170 -440 -326 -654 -540 -354 -355 -603 -699 -826 -1139 -285 -566
-432 -1091 -481 -1718 -15 -194 -7 -605 16 -807 99 -898 470 -1753 1053 -2430
111 -129 361 -380 468 -470 16 -14 56 -48 89 -75 458 -386 1087 -710 1691
-870 688 -183 1368 -202 2074 -58 255 51 616 163 810 250 30 14 75 33 100 43
55 22 279 135 379 191 492 274 996 707 1326 1139 28 35 58 73 67 84 10 11 48
64 85 118 430 626 684 1300 779 2068 26 208 26 805 1 1000 -52 388 -103 610
-216 945 -226 663 -557 1198 -1061 1715 -119 122 -326 306 -440 390 -18 14
-45 34 -59 46 -37 29 -217 153 -276 190 -27 17 -81 50 -120 74 -169 105 -511
267 -740 352 -251 93 -571 176 -835 217 -360 57 -631 70 -989 50z m734 -129
c66 -5 122 -15 123 -20 2 -6 8 -8 12 -5 17 10 395 -56 436 -76 11 -6 24 -9 30
-7 5 1 58 -11 118 -27 88 -25 110 -34 117 -52 5 -13 16 -22 26 -22 17 1 17 2
1 6 -22 5 -24 23 -3 23 21 0 199 -60 205 -69 3 -4 28 -14 55 -21 110 -30 620
-274 609 -291 -3 -5 1 -6 9 -4 7 3 31 -7 53 -22 21 -16 56 -37 77 -48 20 -11
37 -23 37 -27 0 -5 4 -8 10 -8 22 0 332 -220 354 -251 7 -11 15 -17 17 -15 3
3 36 -22 74 -54 39 -33 73 -60 77 -60 4 0 4 -7 1 -17 -4 -11 -3 -14 5 -9 7 4
35 -16 69 -48 32 -31 62 -56 66 -56 5 0 5 -10 2 -22 -6 -19 -5 -21 6 -11 10
10 23 2 62 -37 28 -28 47 -53 43 -57 -3 -4 -12 0 -19 8 -25 29 -77 73 -77 65
0 -15 94 -99 98 -87 8 24 24 10 18 -16 -3 -16 -3 -22 0 -15 7 14 34 16 34 2 0
-5 -4 -10 -10 -10 -5 0 -10 -5 -10 -10 0 -6 10 -8 23 -5 16 4 26 0 36 -17 10
-16 10 -23 2 -26 -6 -2 -8 -8 -5 -14 4 -7 9 -6 14 2 8 13 30 6 30 -10 0 -5 -7
-15 -15 -24 -9 -9 -11 -17 -5 -21 5 -3 15 3 21 13 12 19 13 18 36 -9 14 -16
22 -33 18 -39 -3 -5 0 -7 7 -5 8 3 30 -16 53 -46 22 -29 46 -59 54 -66 12 -13
12 -16 0 -25 -11 -8 -11 -9 3 -5 10 4 25 -5 40 -25 110 -143 124 -166 92 -154
-9 3 -12 2 -8 -5 3 -6 15 -9 25 -6 11 3 19 1 19 -5 0 -5 9 -22 20 -38 11 -15
17 -30 13 -34 -3 -3 -2 -6 4 -6 10 0 85 -109 132 -193 22 -39 18 -50 -6 -19
-13 15 -13 15 -4 -4 6 -12 8 -24 5 -27 -3 -3 2 -4 13 -1 14 3 27 -12 59 -68
52 -93 158 -312 184 -380 20 -53 23 -60 54 -130 29 -65 76 -202 71 -207 -3 -2
0 -10 5 -16 15 -18 70 -194 70 -225 0 -14 4 -30 9 -35 9 -10 12 -19 26 -95 5
-28 4 -32 -5 -20 -10 13 -11 12 -6 -3 3 -10 6 -24 6 -30 0 -8 3 -7 9 1 5 9 14
-18 25 -75 10 -48 21 -104 26 -123 8 -34 16 -86 41 -295 7 -55 13 -166 13
-246 1 -81 4 -142 8 -135 18 27 -3 -433 -28 -624 -9 -63 -18 -143 -21 -178 -3
-34 -10 -65 -14 -68 -5 -3 -9 -17 -9 -31 0 -14 -4 -42 -10 -62 -5 -20 -18 -79
-30 -131 -12 -52 -25 -106 -30 -120 -5 -14 -21 -70 -36 -125 -15 -55 -32 -111
-39 -125 -7 -14 -23 -59 -35 -100 -19 -61 -25 -71 -31 -55 -7 15 -8 12 -4 -11
6 -33 -26 -119 -40 -106 -5 4 -5 2 -2 -4 7 -12 -34 -119 -52 -137 -6 -6 -11
-17 -11 -25 0 -8 -6 -26 -14 -40 -8 -15 -22 -43 -31 -62 -13 -29 -15 -30 -11
-8 4 15 1 30 -6 34 -6 4 -8 3 -5 -3 15 -23 -62 -223 -85 -223 -4 0 -8 -6 -8
-14 0 -13 -48 -106 -55 -106 -2 0 -1 8 2 19 3 10 0 22 -7 26 -8 5 -10 -2 -6
-25 4 -26 -4 -46 -37 -99 -22 -36 -44 -68 -47 -71 -3 -3 -10 -14 -17 -25 -6
-11 -16 -19 -22 -18 -6 2 -8 -3 -5 -11 10 -26 -16 -27 -27 -2 -7 14 -16 23
-20 20 -5 -3 0 -15 11 -26 11 -12 20 -24 20 -28 0 -5 -64 -94 -96 -133 -7 -9
-14 -20 -14 -23 0 -6 -77 -104 -118 -149 -15 -17 -45 -53 -67 -80 -43 -55
-181 -200 -259 -274 -27 -25 -65 -63 -84 -84 -19 -20 -37 -35 -39 -33 -2 2
-21 -13 -41 -33 -61 -57 -173 -156 -183 -159 -5 -2 -9 1 -9 7 0 6 7 11 15 11
8 0 15 7 15 16 0 14 -1 14 -16 0 -8 -9 -19 -16 -24 -16 -5 0 -7 -6 -4 -13 6
-17 -21 -41 -35 -32 -6 3 -9 0 -6 -8 4 -8 -16 -28 -52 -52 -32 -22 -60 -42
-63 -45 -16 -17 -334 -220 -344 -220 -3 0 -47 -25 -100 -55 -52 -30 -97 -55
-100 -55 -3 0 -58 -25 -123 -56 -181 -85 -192 -90 -283 -124 -47 -17 -98 -37
-115 -44 -98 -43 -518 -156 -577 -156 -21 0 -38 -4 -38 -9 0 -5 -28 -12 -62
-16 -35 -4 -88 -13 -118 -22 -30 -8 -68 -14 -84 -14 -15 1 -34 -4 -42 -10 -14
-11 -38 -3 -29 11 8 14 -20 19 -56 9 l-34 -8 33 3 c18 1 35 -1 38 -6 3 -4 -3
-8 -13 -8 -10 0 -61 -5 -113 -11 -126 -14 -509 -19 -640 -8 -209 17 -405 42
-385 50 13 4 -3 7 -40 7 -33 0 -82 4 -110 9 -225 45 -323 70 -550 145 -240 78
-313 108 -318 129 -3 10 -11 19 -19 18 -10 0 -10 -2 0 -6 6 -2 12 -8 12 -13 0
-5 -18 -1 -40 7 -22 9 -37 19 -35 24 3 4 0 11 -6 15 -8 4 -9 3 -5 -4 9 -15 1
-15 -41 0 -38 14 -42 25 -10 31 12 2 7 3 -12 1 -25 -2 -63 11 -150 55 -152 76
-185 94 -189 104 -2 4 -9 7 -15 7 -7 0 -21 7 -32 16 -17 13 -18 16 -5 24 12 8
11 10 -5 10 -18 1 -17 2 5 14 l25 14 -27 -1 c-21 -2 -25 -6 -22 -25 4 -22 2
-21 -53 14 -32 20 -70 44 -84 53 -37 23 -142 94 -156 106 -6 6 -34 26 -62 45
-28 19 -49 40 -46 47 2 7 -2 10 -9 7 -19 -7 -64 37 -60 59 1 9 -2 17 -8 17 -6
0 -8 -7 -4 -15 8 -22 -1 -19 -44 18 -44 36 -52 54 -17 37 20 -10 21 -10 4 4
-11 8 -25 12 -33 9 -8 -3 -14 -1 -14 4 0 6 -8 14 -19 19 -10 5 -46 33 -79 63
-45 39 -61 60 -58 75 2 12 -4 26 -13 33 -28 22 -35 14 -11 -12 13 -14 19 -25
13 -25 -9 0 -148 137 -273 268 -11 12 -12 16 -2 20 6 2 12 8 12 13 0 6 -4 8
-9 5 -5 -3 -12 1 -15 10 -5 12 -2 15 11 10 14 -6 15 -4 6 5 -15 15 -34 3 -26
-19 6 -15 5 -15 -10 -3 -10 8 -15 16 -13 19 3 2 -8 15 -25 29 -16 14 -58 64
-94 111 -35 48 -71 96 -79 107 -57 73 -93 125 -153 216 -37 57 -73 113 -79
124 -6 11 -25 43 -42 71 -18 28 -32 59 -32 68 0 9 -4 16 -9 16 -15 0 -22 32
-10 46 7 9 8 14 1 14 -6 0 -12 -6 -15 -12 -6 -19 -47 66 -48 99 0 25 -1 26 -9
8 -5 -11 -9 -14 -9 -7 -1 12 -22 62 -71 167 -40 84 -93 212 -110 265 -27 80
-42 122 -51 145 -28 67 -90 292 -124 450 -14 66 -30 136 -35 155 -10 34 -20
107 -41 290 -12 103 -28 385 -28 495 -1 55 2 75 9 65 8 -12 10 -9 10 12 0 14
-5 28 -12 30 -7 3 -9 14 -4 33 5 21 10 25 16 15 5 -8 9 13 12 54 1 38 0 73 -4
79 -4 6 -9 -15 -11 -48 l-3 -60 -2 64 c-2 75 32 393 52 496 8 39 27 129 41
200 15 72 33 143 41 158 8 16 14 39 14 52 0 37 112 377 155 470 7 17 23 55 35
85 49 125 184 390 197 386 7 -3 13 -1 13 4 0 6 5 10 10 10 6 0 10 -8 10 -17 0
-13 3 -14 11 -6 9 9 8 16 -3 27 -11 11 -18 12 -27 3 -6 -6 -11 -8 -11 -4 0 16
112 205 187 315 24 35 43 67 43 72 0 5 7 7 15 4 10 -4 13 -2 10 7 -10 28 350
473 365 450 4 -7 14 -3 29 13 16 16 19 25 10 28 -9 3 -5 12 11 28 15 15 25 19
28 12 3 -9 12 -7 30 7 15 10 33 17 40 15 7 -1 8 0 2 3 -7 3 -7 9 1 19 10 12
14 12 21 2 7 -10 8 -10 6 2 -1 8 3 25 10 38 7 12 10 27 6 33 -4 6 8 24 27 40
35 30 51 31 28 2 -11 -14 -9 -13 13 2 25 18 41 44 18 30 -5 -3 -10 -2 -10 4 0
15 51 51 63 44 6 -4 8 0 4 10 -3 10 -3 17 2 17 4 0 21 12 37 28 70 66 186 151
200 145 8 -3 14 1 14 9 0 18 175 149 192 144 7 -1 9 -1 5 2 -9 5 56 52 72 52
5 0 11 3 13 8 4 9 127 85 230 141 58 32 82 40 94 33 15 -8 12 -11 -14 -17 -18
-3 -35 -11 -39 -17 -4 -8 0 -9 13 -4 10 5 32 13 48 18 l29 11 -24 13 -24 12
30 12 c16 6 52 23 80 37 93 47 226 102 238 98 7 -2 28 -6 47 -9 25 -4 31 -3
20 4 -10 6 -11 10 -2 10 6 0 12 5 12 12 0 9 -3 9 -12 0 -7 -7 -23 -12 -38 -12
-24 1 -23 2 10 20 19 11 40 19 47 20 6 0 24 5 40 12 15 6 32 10 37 9 5 -1 12
2 15 7 3 5 40 21 81 35 68 22 118 38 305 94 33 10 68 17 78 15 10 -1 26 2 35
7 50 26 491 98 682 111 160 10 585 5 755 -10z m-3455 -1205 c0 -6 -40 -53 -58
-69 -7 -6 -20 -17 -28 -25 -8 -7 -18 -11 -21 -8 -3 4 16 29 43 56 45 45 64 59
64 46z m-160 -164 c0 -12 -20 -25 -27 -18 -7 7 6 27 18 27 5 0 9 -4 9 -9z
m3790 -7361 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4
-10z"/>
<path d="M5410 9770 c-34 -7 -34 -7 -5 -8 17 0 44 4 60 8 27 7 27 8 5 8 -14
-1 -41 -4 -60 -8z"/>
<path d="M5558 9773 c23 -2 61 -2 85 0 23 2 4 4 -43 4 -47 0 -66 -2 -42 -4z"/>
<path d="M5735 9770 c17 -4 44 -8 60 -8 25 0 24 2 -10 9 -51 10 -92 10 -50 -1z"/>
<path d="M5298 9763 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"/>
<path d="M5858 9763 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"/>
<path d="M5990 9750 c8 -5 24 -10 34 -10 26 0 18 6 -19 14 -22 5 -26 4 -15 -4z"/>
<path d="M5168 9743 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M5245 9741 c-6 -11 74 -25 101 -18 11 3 0 5 -23 6 -23 0 -45 6 -48
11 -8 13 -22 13 -30 1z"/>
<path d="M5568 9743 c17 -2 47 -2 65 0 17 2 3 4 -33 4 -36 0 -50 -2 -32 -4z"/>
<path d="M5880 9731 c-42 -6 -39 -7 41 -15 47 -4 94 -6 105 -3 10 2 -10 6 -46
7 -49 1 -59 4 -40 10 31 10 7 10 -60 1z"/>
<path d="M4985 9720 c3 -5 12 -7 20 -3 21 7 19 13 -6 13 -11 0 -18 -4 -14 -10z"/>
<path d="M5528 9723 c39 -2 105 -2 145 0 39 1 7 3 -73 3 -80 0 -112 -2 -72 -3z"/>
<path d="M6193 9723 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M5188 9713 c18 -2 45 -2 60 0 15 2 0 4 -33 4 -33 0 -45 -2 -27 -4z"/>
<path d="M5265 9700 c-44 -4 -123 -13 -175 -20 -121 -15 -168 -20 -205 -23
-16 -2 -37 -6 -45 -9 -27 -11 -180 -38 -216 -38 -24 0 -33 -4 -28 -12 5 -8 0
-9 -14 -6 -12 4 -22 3 -22 -2 0 -4 -12 -10 -27 -13 -40 -7 -145 -34 -165 -42
-11 -4 -18 -3 -18 4 0 6 12 11 28 12 l27 1 -25 7 c-29 9 -70 -17 -49 -30 8 -4
-4 -12 -29 -19 -64 -17 -196 -61 -207 -70 -5 -4 -22 -10 -37 -14 -15 -3 -56
-19 -90 -36 -35 -16 -99 -43 -143 -61 -44 -18 -91 -40 -105 -48 -15 -10 -21
-11 -17 -3 6 9 2 11 -15 8 -34 -7 -35 -7 -13 -16 19 -7 18 -9 -7 -19 -86 -33
-300 -154 -423 -238 -11 -7 -38 -25 -60 -40 -39 -25 -251 -182 -288 -213 -10
-8 -31 -25 -45 -38 -96 -83 -112 -94 -125 -84 -14 12 -46 -2 -34 -15 5 -4 12
-1 16 6 6 10 10 10 16 1 4 -6 -8 -26 -29 -46 -39 -38 -48 -42 -40 -16 4 13 3
14 -4 4 -5 -8 -12 -13 -16 -12 -14 3 -31 -8 -23 -16 4 -5 12 -2 16 5 5 7 11 9
14 4 3 -5 -54 -70 -126 -145 -73 -74 -144 -151 -159 -169 -14 -19 -40 -50 -57
-69 -18 -19 -39 -45 -48 -57 -8 -13 -21 -23 -27 -23 -7 0 -13 -6 -13 -12 0 -7
-29 -52 -64 -100 -102 -137 -150 -207 -202 -295 -36 -60 -54 -80 -66 -76 -12
4 -13 3 -3 -5 14 -10 7 -27 -48 -117 -14 -22 -33 -58 -44 -80 -10 -22 -25 -51
-32 -65 -15 -26 -63 -127 -64 -135 0 -3 -15 -38 -34 -78 -18 -41 -39 -90 -45
-110 -7 -21 -16 -37 -21 -37 -5 0 -9 -8 -8 -17 0 -10 -16 -63 -37 -118 -40
-110 -72 -208 -86 -270 -5 -22 -14 -49 -19 -60 -5 -11 -14 -45 -20 -75 -5 -30
-17 -86 -26 -125 -28 -126 -70 -410 -84 -575 -12 -144 -12 -484 0 -650 13
-181 45 -394 90 -613 24 -120 89 -339 158 -537 15 -41 25 -84 24 -95 -2 -13 0
-16 5 -8 6 8 14 -3 25 -33 8 -24 12 -44 7 -44 -4 0 -11 9 -14 21 -5 14 -10 18
-17 11 -13 -13 -2 -46 12 -37 24 15 68 -67 71 -130 0 -13 3 -15 6 -6 5 11 138
-244 135 -259 0 -3 5 -12 13 -20 24 -27 75 -130 76 -153 0 -21 1 -21 9 -2 5
11 9 14 9 7 1 -7 33 -60 71 -119 39 -58 68 -108 65 -111 -2 -3 -13 6 -24 19
-11 13 -20 19 -21 13 0 -5 6 -16 13 -23 10 -11 9 -13 -5 -8 -10 3 -20 2 -22
-2 -3 -5 15 -8 39 -7 42 1 44 0 39 -24 -4 -17 -3 -21 4 -12 6 10 16 2 37 -30
28 -42 139 -182 210 -265 21 -25 33 -48 29 -54 -4 -7 -3 -9 4 -5 6 3 37 -21
69 -55 44 -47 58 -68 57 -89 -1 -20 3 -27 12 -23 8 3 14 -1 14 -9 0 -7 10 -19
22 -27 l21 -13 -22 27 c-29 37 -17 47 14 11 13 -15 21 -35 18 -44 -4 -14 -3
-14 5 -3 8 11 26 -1 86 -59 66 -64 74 -75 65 -94 -10 -20 -9 -20 5 -2 14 17
15 17 37 -3 13 -12 27 -21 32 -21 5 0 7 -6 4 -13 -3 -8 1 -14 8 -14 15 0 83
-53 84 -66 1 -4 -14 0 -31 8 -30 15 -31 15 -13 0 17 -14 18 -17 5 -26 -11 -8
-9 -9 10 -3 14 4 30 8 35 11 6 2 20 -5 30 -14 11 -10 58 -47 105 -82 47 -35
84 -68 83 -72 -2 -5 3 -6 10 -3 7 2 22 -5 34 -16 12 -11 27 -20 32 -20 6 0 14
-6 18 -13 4 -6 21 -19 38 -27 16 -8 62 -36 102 -62 40 -27 75 -48 79 -48 3 0
18 -9 34 -20 27 -19 370 -196 380 -195 17 0 159 -69 154 -76 -3 -5 1 -6 9 -3
12 4 93 -20 152 -46 11 -5 65 -23 120 -41 55 -17 109 -35 120 -39 11 -5 83
-23 160 -41 77 -18 143 -37 146 -41 3 -5 13 -6 23 -2 10 4 27 2 39 -4 21 -10
233 -41 422 -62 145 -16 719 -13 865 5 146 18 376 51 405 58 11 3 61 15 110
26 50 11 115 28 145 37 30 10 67 17 83 17 15 0 25 2 22 5 -11 12 205 72 235
65 20 -3 30 -1 30 6 0 8 -8 10 -22 6 -55 -17 3 13 67 35 39 13 87 31 107 41
35 18 74 17 62 -2 -7 -11 57 1 74 14 10 8 10 12 0 18 -6 4 -16 5 -21 2 -5 -3
-3 -9 4 -14 11 -7 11 -9 -1 -8 -8 1 -25 4 -38 8 -20 5 -11 12 60 44 133 62
329 162 382 196 58 36 59 36 80 15 15 -14 16 -14 16 5 0 14 -5 19 -15 15 -27
-11 -16 4 19 25 19 12 40 20 47 18 8 -2 10 -2 6 1 -9 5 11 32 25 32 5 0 38 21
73 46 37 26 70 42 76 38 7 -4 9 -3 6 3 -4 6 5 19 19 29 15 11 52 38 84 62 41
30 63 40 76 35 17 -6 17 -5 5 10 -7 9 -9 17 -4 17 6 0 21 10 34 23 42 41 96
77 103 70 4 -4 4 0 0 10 -3 9 -2 17 3 17 5 0 20 10 32 21 19 18 25 19 33 8 8
-11 9 -11 5 2 -7 20 36 64 52 55 6 -4 9 -1 6 7 -3 7 14 32 41 57 37 34 48 40
56 29 7 -10 8 -8 3 8 -5 18 -3 22 10 17 10 -4 15 -2 13 7 -2 8 3 13 10 11 8
-1 11 2 7 8 -3 6 0 17 9 25 20 20 30 19 22 -2 -6 -17 -5 -17 7 -1 8 10 17 15
20 11 4 -3 7 -1 7 6 0 8 -6 11 -16 7 -9 -3 -14 -2 -12 3 3 11 117 131 123 131
3 0 2 -8 -1 -17 -5 -14 -4 -15 4 -4 6 8 8 20 6 26 -3 7 9 24 26 39 17 14 28
26 24 26 -4 0 6 15 22 32 17 18 53 62 80 98 26 36 54 70 60 77 6 7 24 32 40
57 16 25 35 46 42 46 7 0 11 4 8 9 -3 5 22 52 57 104 34 53 80 125 102 161 32
51 43 61 54 52 12 -9 12 -8 1 11 -12 19 -12 24 5 43 10 11 20 26 21 33 7 33
131 267 139 260 4 -4 5 -3 1 4 -4 7 -2 20 3 30 5 10 17 38 27 63 10 25 27 68
39 95 12 28 33 82 45 122 13 40 28 69 33 66 6 -4 7 -1 2 6 -4 7 -3 23 3 34 14
29 72 226 72 244 0 8 5 11 10 8 14 -9 13 -55 -2 -55 -6 0 -9 -3 -5 -6 3 -4 0
-19 -8 -35 -21 -39 -19 -46 5 -19 11 13 20 29 20 36 0 7 5 25 11 41 10 26 12
27 20 8 l9 -20 -3 20 c-2 11 -9 19 -15 17 -20 -4 -34 46 -22 82 6 17 19 67 30
111 19 78 19 79 16 25 -4 -52 -4 -53 8 -22 6 18 15 30 19 26 4 -4 7 0 7 9 0 9
-5 19 -10 22 -6 4 -8 16 -5 28 5 17 4 19 -4 7 -15 -21 -14 -9 8 116 18 99 38
247 47 349 2 22 7 159 11 305 7 241 9 254 13 140 l6 -125 2 116 c1 87 -2 124
-13 145 -8 16 -15 52 -15 79 0 62 -26 304 -39 365 -6 25 -13 68 -16 95 -9 73
-43 230 -74 345 -51 183 -64 226 -72 243 -5 10 -7 22 -4 27 4 6 1 10 -4 10 -6
0 -11 6 -11 13 0 7 -11 42 -25 78 -14 35 -27 71 -29 79 -1 8 -10 31 -19 50 -8
19 -39 91 -68 160 -29 69 -64 143 -77 164 -21 34 -23 44 -13 75 5 19 8 37 6
40 -3 2 -5 -2 -5 -10 0 -12 -2 -12 -10 1 -5 8 -13 11 -17 6 -4 -5 -2 -11 5
-13 6 -3 12 -12 12 -21 0 -13 -5 -11 -20 8 -11 14 -20 28 -20 32 0 7 -44 85
-121 213 -26 44 -49 87 -51 95 -2 8 -11 21 -20 30 -9 8 -39 47 -65 86 -52 77
-82 117 -126 170 -16 18 -26 38 -22 44 3 5 0 10 -8 10 -17 0 -63 61 -59 79 2
7 -1 10 -6 7 -5 -3 -34 22 -63 55 -60 68 -70 85 -45 76 9 -4 16 -1 16 4 0 7
-9 9 -21 6 -15 -4 -31 4 -55 28 -32 33 -45 53 -25 41 11 -7 8 21 -4 31 -4 4
-5 3 -1 -4 3 -6 2 -14 -4 -18 -5 -3 -26 13 -47 36 -50 56 -58 64 -89 88 -15
11 -23 25 -19 32 6 8 10 8 16 -2 4 -7 11 -10 16 -6 12 13 -20 27 -33 16 -9 -7
-25 2 -56 32 -24 23 -42 46 -40 51 1 5 -1 7 -6 4 -5 -3 -28 11 -51 30 -33 29
-39 39 -30 50 7 9 8 14 1 14 -6 0 -12 -6 -15 -12 -7 -20 -47 20 -40 40 4 14 3
14 -5 3 -8 -12 -19 -7 -59 25 -96 79 -215 163 -368 260 -49 31 -92 59 -95 63
-3 3 -30 18 -61 34 -37 17 -56 33 -55 44 0 9 -6 18 -14 20 -13 4 -13 3 0 -6 8
-5 11 -13 7 -18 -4 -4 -16 -2 -25 5 -9 7 -26 16 -37 21 -73 32 -122 56 -135
66 -8 7 -42 23 -74 36 -57 23 -58 24 -30 30 22 5 19 6 -11 3 -29 -2 -59 6
-114 32 -40 19 -85 37 -100 40 -14 4 -30 10 -36 14 -11 8 -182 64 -300 100
-38 11 -83 25 -100 30 -16 5 -47 12 -68 16 -21 3 -35 9 -32 13 4 3 -29 11 -72
17 -146 21 -228 36 -249 46 -12 6 -32 7 -45 3 -22 -7 -22 -7 -6 9 21 21 23 33
2 16 -17 -14 -124 -14 -210 0 -77 14 -655 21 -760 10z m493 -257 c-21 -2 -57
-2 -80 0 -24 2 -7 4 37 4 44 0 63 -2 43 -4z m-158 -22 c0 -14 -10 -21 -36 -26
-21 -3 -40 -2 -43 3 -3 5 -15 12 -26 15 -11 4 -4 4 15 2 23 -3 43 0 55 10 27
19 35 19 35 -4z m425 -26 c54 -16 84 -31 93 -46 9 -14 20 -19 34 -16 27 7 79
-25 69 -42 -7 -10 -13 -8 -30 10 -23 24 -42 19 -21 -6 16 -19 1 -19 -24 0 -25
19 -46 19 -46 1 0 -8 10 -17 23 -19 15 -4 12 -5 -8 -4 -32 2 -48 33 -25 47 17
11 -5 50 -29 50 -10 0 -32 7 -47 15 -16 8 -40 15 -54 14 -20 0 -17 -3 15 -15
29 -10 41 -20 41 -34 0 -24 2 -23 -31 -8 -24 11 -25 13 -8 19 14 6 13 8 -9 8
-15 1 -33 8 -42 16 -8 8 -26 15 -40 15 -24 0 -41 12 -30 23 9 9 87 -4 169 -28z
m-556 1 c9 -11 7 -14 -12 -18 -17 -3 -23 0 -23 14 0 21 19 24 35 4z m-108 -21
c-18 -8 -38 -15 -45 -15 -15 1 46 28 64 29 8 0 0 -6 -19 -14z m506 9 c-3 -3
-12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m-267 -19 c0 -11 12 -15 43
-17 l42 -1 -45 -6 c-50 -7 -73 -4 -64 10 3 5 -3 9 -13 9 -15 0 -16 2 -3 10 22
14 40 12 40 -5z m324 7 c10 -17 -11 -34 -33 -27 -21 6 -22 7 -4 21 21 16 30
17 37 6z m-186 -24 c-3 -7 -11 -13 -18 -13 -7 0 -15 6 -17 13 -3 7 4 12 17 12
13 0 20 -5 18 -12z m-468 -18 c-8 -6 -22 -10 -30 -9 -9 0 -5 6 10 14 27 14 44
10 20 -5z m280 10 c12 -8 11 -10 -7 -10 -13 0 -23 5 -23 10 0 13 11 13 30 0z
m273 3 c-13 -2 -33 -2 -45 0 -13 2 -3 4 22 4 25 0 35 -2 23 -4z m-133 -23 c26
-16 3 -22 -27 -6 -23 13 -24 15 -8 15 11 1 27 -3 35 -9z m103 3 c-18 -2 -33
-9 -33 -14 0 -6 -5 -7 -11 -3 -17 10 11 24 46 22 l30 -1 -32 -4z m143 -29 c21
-22 31 -25 62 -20 20 3 30 3 22 -1 -8 -3 -18 -10 -21 -15 -6 -9 -56 9 -117 40
-26 13 -34 14 -41 4 -5 -9 -14 -10 -32 -3 l-24 10 28 0 c15 1 27 6 27 12 0 20
68 0 96 -27z m-656 16 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2
0 4 -4 4 -10z m330 0 c8 -5 13 -10 10 -10 -65 -10 -120 1 -72 13 29 8 46 7 62
-3z m-370 -15 c-1 -5 -14 -9 -30 -7 -26 3 -30 0 -30 -20 0 -13 -5 -29 -12 -36
-15 -15 -48 -16 -48 0 0 6 -10 2 -23 -10 -13 -12 -29 -22 -35 -22 -7 0 -11 -5
-9 -12 1 -7 -3 -12 -10 -13 -27 -1 -37 -23 -23 -50 7 -14 10 -28 7 -32 -4 -3
-7 1 -7 10 0 10 -4 17 -10 17 -22 0 -5 -33 22 -43 11 -4 17 -2 15 6 -1 6 9 13
23 15 21 3 22 2 11 -12 -12 -14 -11 -16 7 -16 19 0 47 31 37 41 -2 2 8 5 21 5
13 1 24 0 24 -2 0 -2 -18 -17 -41 -34 -44 -32 -86 -32 -122 -2 -28 24 -16 78
24 114 63 55 87 69 92 56 3 -10 7 -10 20 1 10 7 17 18 17 24 0 17 34 37 58 34
12 -1 22 -6 22 -12z m1033 -38 c-5 -25 19 -43 40 -30 6 4 2 10 -11 14 -12 5
-22 13 -22 19 0 16 12 12 45 -14 l30 -24 -38 -7 c-45 -9 -61 3 -71 53 -5 29
-4 32 13 23 12 -7 17 -18 14 -34z m-909 17 c13 -5 14 -9 5 -20 -14 -17 -8 -18
26 -2 22 10 24 13 10 18 -9 3 10 6 42 6 32 1 51 -1 43 -4 -8 -2 -48 -17 -88
-33 -41 -16 -79 -29 -85 -29 -17 0 4 17 28 23 14 3 10 5 -10 6 -17 0 -35 -3
-40 -8 -6 -5 -19 -5 -30 -1 -18 8 -17 9 8 9 15 1 27 6 27 12 0 7 11 9 30 6 29
-6 42 6 18 16 -7 3 -10 6 -6 6 3 1 14 -2 22 -5z m682 -25 c3 -6 15 -8 26 -6
31 9 68 -10 68 -33 0 -23 -15 -27 -24 -5 -3 8 -14 15 -24 15 -19 0 -82 28 -82
36 0 9 29 3 36 -7z m114 1 c0 -5 -4 -10 -9 -10 -6 0 -13 5 -16 10 -3 6 1 10 9
10 9 0 16 -4 16 -10z m70 0 c0 -5 -9 -10 -20 -10 -11 0 -20 5 -20 10 0 6 9 10
20 10 11 0 20 -4 20 -10z m-1030 -35 c0 -8 8 -15 18 -15 14 0 15 -2 2 -10 -10
-6 -16 -6 -18 0 -2 6 -10 10 -18 10 -8 0 -14 7 -14 15 0 8 7 15 15 15 8 0 15
-7 15 -15z m100 -12 c0 -5 -23 -21 -50 -36 -28 -16 -50 -24 -50 -19 0 6 6 13
13 16 6 3 26 15 42 25 33 21 45 25 45 14z m1073 0 c-7 -2 -21 -2 -30 0 -10 3
-4 5 12 5 17 0 24 -2 18 -5z m-148 -41 c3 3 -2 13 -11 23 -17 16 -17 17 2 13
13 -2 19 -12 21 -34 l1 -32 -44 25 c-24 14 -42 29 -39 34 4 5 19 -1 35 -13 17
-12 32 -19 35 -16z m205 -36 c-1 -48 -22 -69 -71 -69 -33 0 -47 6 -72 33 l-32
34 38 -28 c28 -20 46 -26 75 -24 34 3 38 6 47 42 7 29 6 41 -3 44 -7 2 -12 8
-12 14 0 6 6 6 15 -2 8 -7 15 -27 15 -44z m-590 5 c26 -4 -20 -6 -104 -4 -82
2 -151 5 -154 8 -8 8 206 5 258 -4z m-273 -7 c-3 -3 -12 -4 -19 -1 -8 3 -5 6
6 6 11 1 17 -2 13 -5z m-55 -21 c-7 -3 -22 -15 -33 -27 l-20 -21 33 -6 c18 -4
27 -7 20 -8 -7 0 -10 -5 -7 -11 3 -5 1 -10 -4 -10 -6 0 -11 4 -11 9 0 6 -9 9
-20 8 -11 -1 -20 -6 -20 -12 0 -5 -4 -4 -9 4 -5 8 -7 20 -4 28 3 7 2 13 -1 13
-14 0 -56 -33 -56 -44 0 -6 -21 -16 -47 -22 l-47 -11 24 19 c13 11 32 17 42
15 10 -3 18 -1 18 4 0 5 -6 9 -12 9 -7 1 1 8 17 18 41 23 139 59 145 54 3 -3
-1 -7 -8 -9z m823 7 c-3 -5 4 -11 17 -11 l23 -2 -23 -4 c-12 -2 -29 3 -38 11
-14 15 -13 16 6 16 12 0 18 -4 15 -10z m-290 -48 c28 -16 34 -22 20 -22 -11 0
-29 6 -40 14 -11 8 -39 19 -63 26 -23 7 -42 17 -42 21 0 11 76 -13 125 -39z
m-525 8 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10
-10z m67 -16 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m381 -1
c-10 -2 -26 -2 -35 0 -10 3 -2 5 17 5 19 0 27 -2 18 -5z m47 -13 c3 -5 1 -10
-4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m-356 -16 c10 -9
-55 -3 -69 6 -10 6 -2 7 25 3 22 -3 42 -7 44 -9z m84 9 c-13 -2 -33 -2 -45 0
-13 2 -3 4 22 4 25 0 35 -2 23 -4z m124 1 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6
11 1 17 -2 13 -5z m-44 -11 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13
-5z m93 0 c-4 -5 -24 -13 -44 -19 l-37 -12 33 -1 c17 -1 32 -6 32 -11 0 -10
-37 -6 -70 8 -8 3 -55 9 -105 13 l-90 6 105 1 c58 0 119 5 135 10 37 13 51 14
41 5z m262 -46 c10 -12 8 -14 -14 -14 -16 0 -21 2 -14 7 8 5 1 13 -20 24 -18
8 -36 13 -41 10 -10 -6 -12 9 -3 19 8 8 76 -26 92 -46z m-783 24 c-3 -6 -14
-10 -23 -10 -15 1 -15 2 1 6 9 2 17 9 17 15 0 6 3 9 6 5 3 -3 3 -10 -1 -16z
m148 12 c-12 -2 -24 -10 -27 -18 -4 -10 2 -11 27 -4 17 5 35 5 40 0 5 -5 -8
-12 -29 -15 -43 -9 -64 5 -44 29 7 8 22 14 34 14 l21 -2 -22 -4z m-269 -52
c-1 -47 -18 -71 -50 -71 -25 0 -33 -15 -11 -23 6 -2 8 -8 4 -13 -10 -10 -27
14 -27 39 0 12 8 17 30 17 25 0 30 4 31 25 2 33 3 38 12 53 12 18 12 16 11
-27z m353 33 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m493 -14
c0 -5 -8 -10 -17 -11 -15 0 -15 -2 -3 -7 9 -4 15 -13 15 -21 0 -17 -42 -34
-50 -20 -4 5 1 12 9 15 9 3 14 10 11 14 -8 13 6 40 21 40 8 0 14 -4 14 -10z
m-775 -10 c-3 -5 -13 -10 -21 -10 -8 0 -12 5 -9 10 3 6 13 10 21 10 8 0 12 -4
9 -10z m-107 -22 c-8 -12 -21 -24 -28 -26 -8 -3 -6 5 6 21 23 32 42 36 22 5z
m252 6 c0 -5 -92 -54 -102 -54 -17 0 3 21 30 32 25 10 26 11 7 18 -14 5 -7 7
23 7 23 0 42 -1 42 -3z m528 -9 c4 -5 -1 -5 -12 -1 -14 5 -17 2 -12 -9 5 -13
1 -13 -27 1 -45 23 -45 24 2 20 23 -2 45 -7 49 -11z m-618 -4 c0 -5 -9 -11
-20 -14 -20 -5 -26 3 -13 16 9 10 33 8 33 -2z m814 -7 c13 -33 6 -49 -9 -20
-18 33 -18 36 -6 36 5 0 12 -7 15 -16z m-39 -4 c-4 -6 -1 -17 5 -25 6 -8 9
-23 5 -35 -8 -25 10 -27 24 -2 10 16 10 16 11 0 0 -20 -37 -48 -65 -48 -11 0
-33 9 -50 20 -18 12 -24 20 -14 20 8 0 24 -7 35 -15 22 -17 54 -20 54 -5 0 6
-9 10 -20 10 -11 0 -20 4 -20 9 0 5 -8 12 -17 14 -10 2 -4 2 14 0 31 -4 52 10
33 22 -13 8 -13 45 1 45 5 0 7 -5 4 -10z m-832 -17 c-7 -2 -19 -2 -25 0 -7 3
-2 5 12 5 14 0 19 -2 13 -5z m707 -3 c0 -5 -6 -10 -14 -10 -8 0 -18 5 -21 10
-3 6 3 10 14 10 12 0 21 -4 21 -10z m-760 -51 c-7 -12 -16 -16 -28 -11 -16 6
-16 7 1 10 11 2 16 9 13 17 -3 9 0 12 9 8 11 -4 12 -10 5 -24z m790 21 c0 -5
-4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m-754 -35
c-27 -25 -79 -34 -91 -15 -4 6 5 8 22 4 21 -4 33 0 47 15 11 12 26 21 34 21
10 0 6 -8 -12 -25z m450 -12 c-4 -4 -28 -6 -54 -6 l-47 1 47 -7 c65 -10 66
-16 2 -16 -32 0 -54 4 -54 11 0 6 -14 9 -32 7 -25 -3 -30 -2 -18 6 16 12 168
15 156 4z m44 -13 c0 -5 -4 -10 -9 -10 -6 0 -13 5 -16 10 -3 6 1 10 9 10 9 0
16 -4 16 -10z m-200 -9 c18 -6 10 -8 -30 -8 -37 0 -49 2 -35 8 24 9 33 9 65 0z
m262 -1 c13 0 -13 -25 -36 -33 -19 -8 -19 -7 -2 12 9 10 14 21 9 23 -4 3 -2 3
5 1 8 -1 18 -3 24 -3z m-362 -46 c0 -8 -4 -12 -10 -9 -20 12 -32 -7 -13 -21
23 -17 0 -19 -27 -2 -18 11 -18 14 -3 30 20 22 53 24 53 2z m434 1 c21 -16 21
-17 -11 -34 -15 -8 -23 -8 -23 -1 0 5 7 10 15 10 8 0 15 5 15 10 0 6 -7 10
-15 10 -8 0 -15 5 -15 10 0 14 11 12 34 -5z m-508 -37 c4 -7 3 -8 -4 -4 -8 5
-12 -1 -12 -15 0 -18 -3 -20 -12 -11 -8 8 -8 15 2 27 15 18 17 18 26 3z m154
8 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z
m294 -11 c-4 -8 1 -17 10 -21 9 -3 16 -10 16 -15 0 -5 -11 -4 -25 3 -20 9 -22
14 -14 29 12 23 21 25 13 4z m113 -5 c3 -11 9 -20 14 -20 14 0 10 -53 -5 -73
-17 -22 -81 -34 -99 -18 -8 6 -13 20 -12 31 2 26 15 39 15 14 0 -11 5 -25 12
-32 15 -15 48 -16 48 -2 0 6 7 10 16 10 9 0 12 5 8 12 -4 7 -3 8 4 4 8 -5 12
0 12 13 0 11 -4 23 -10 26 -5 3 -10 0 -10 -8 0 -21 -34 -15 -43 7 -5 12 -2 25
9 37 22 24 35 24 41 -1z m-434 -25 c-28 -21 -11 -25 32 -10 22 8 67 15 100 16
l60 2 -45 7 c-45 7 -45 7 -8 8 20 1 49 -3 63 -10 19 -8 31 -8 50 0 14 6 27 7
30 2 10 -15 -38 -24 -117 -21 -70 3 -134 -9 -164 -31 -6 -5 -19 -6 -28 -2 -9
3 -16 1 -16 -5 0 -6 6 -11 12 -11 7 0 2 -7 -11 -16 -14 -10 -26 -13 -30 -7 -3
6 -13 13 -21 16 -8 4 0 4 19 1 30 -6 32 -4 23 12 -8 14 -7 23 6 37 14 16 14
20 2 28 -11 8 -9 9 8 4 14 -4 22 -2 22 6 0 8 4 8 15 -1 13 -11 13 -14 -2 -25z
m84 19 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m-247 -45 c0
-11 -4 -17 -10 -14 -5 3 -10 13 -10 21 0 8 5 14 10 14 6 0 10 -9 10 -21z m430
1 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4 11 -10z
m40 0 c8 -5 11 -12 8 -16 -10 -9 -38 3 -38 16 0 12 10 13 30 0z m-438 -47 c5
-6 19 -14 31 -16 19 -4 19 -4 -4 -6 -38 -2 -60 19 -52 49 6 22 8 23 11 5 2
-11 8 -25 14 -32z m515 11 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13
-5z m-227 -114 c0 -5 -7 -10 -15 -10 -8 0 -15 -5 -15 -10 0 -6 -8 -10 -17 -8
-12 2 -19 -4 -21 -20 -4 -26 -22 -20 -22 7 0 11 14 25 33 35 37 18 57 20 57 6z
m63 -42 c18 -24 19 -32 8 -68 -13 -43 -49 -70 -96 -70 -39 0 -85 53 -83 94 l1
31 4 -33 c4 -29 7 -31 20 -21 12 11 14 10 11 -6 -2 -12 6 -23 20 -31 17 -8 20
-13 10 -17 -7 -3 0 -6 16 -6 24 -1 27 1 16 14 -17 21 -6 29 37 28 20 -1 32 2
26 5 -6 4 -13 17 -17 30 -4 12 -12 22 -17 22 -5 0 -9 7 -9 15 0 26 18 16 31
-17 11 -30 13 -31 16 -10 6 28 -21 56 -48 49 -17 -5 -18 -3 -8 9 17 20 38 14
62 -18z m-104 -54 c4 3 13 0 21 -5 13 -8 13 -10 0 -19 -27 -18 -35 -11 -36 33
-1 23 1 30 3 14 2 -15 8 -25 12 -23z m23 -268 c4 -6 8 -19 8 -28 0 -20 26 -24
50 -8 12 8 11 10 -7 10 -22 0 -30 10 -18 22 10 9 104 -20 152 -48 63 -37 151
-127 185 -190 55 -102 73 -290 43 -444 -20 -105 -26 -123 -79 -233 -25 -53
-46 -99 -46 -102 0 -3 -4 -11 -10 -18 -5 -7 -41 -52 -80 -102 -98 -127 -114
-145 -129 -145 -7 0 -11 -6 -8 -15 4 -8 2 -17 -3 -20 -6 -4 -10 5 -10 19 0 18
6 26 18 27 16 1 16 2 0 6 -13 3 -18 15 -18 40 0 23 -4 33 -12 31 -9 -3 -14
-31 -16 -81 -2 -65 -6 -77 -20 -77 -12 0 -13 -3 -5 -8 20 -13 -38 -85 -204
-250 -84 -84 -165 -171 -180 -195 -27 -40 -138 -170 -248 -287 -29 -30 -71
-76 -95 -102 -23 -27 -48 -48 -54 -48 -23 0 -96 -104 -117 -166 -7 -22 -26
-58 -41 -81 -15 -23 -28 -44 -28 -47 0 -3 -16 -40 -35 -82 -19 -41 -35 -78
-35 -80 0 -3 -11 -20 -25 -39 -25 -31 -26 -38 -23 -146 3 -96 7 -122 26 -161
52 -106 152 -183 251 -195 99 -11 250 53 333 142 7 7 42 44 79 82 36 37 80 87
99 111 18 23 38 42 43 42 6 0 1 -10 -11 -23 -12 -13 -22 -28 -22 -33 0 -6 -15
-25 -32 -43 -18 -19 -40 -45 -50 -59 -9 -13 -58 -67 -109 -118 -78 -79 -108
-102 -188 -142 -128 -66 -172 -76 -281 -69 -186 12 -335 124 -398 299 -23 64
-26 88 -25 193 1 222 47 344 205 536 21 26 38 52 38 58 0 13 133 163 206 232
100 95 200 195 225 224 29 34 248 240 324 305 72 61 122 117 158 178 17 28 37
52 44 52 6 0 22 17 34 38 13 20 35 47 49 59 14 11 32 32 39 46 8 15 19 23 27
20 9 -3 12 0 9 9 -7 18 40 64 50 49 3 -6 2 -11 -3 -11 -12 0 -23 -40 -15 -53
11 -19 26 28 29 92 2 35 7 67 12 70 5 3 12 23 16 44 4 21 13 37 20 37 17 0 29
27 14 32 -8 3 -6 18 4 49 40 113 43 134 43 315 0 110 -4 190 -11 205 -49 107
-86 179 -96 185 -8 5 -5 10 8 15 17 7 16 8 -6 8 -14 1 -38 12 -54 26 -17 14
-40 28 -53 31 -13 4 -23 10 -23 15 0 5 -7 6 -15 3 -8 -4 -15 -1 -15 6 0 15
102 3 112 -14z m1683 -60 c225 -77 330 -155 432 -321 95 -155 118 -254 118
-495 -1 -219 -27 -357 -111 -590 -48 -132 -124 -292 -179 -375 -18 -27 -41
-64 -51 -82 -83 -140 -263 -349 -354 -408 -19 -13 -68 -55 -108 -94 -40 -39
-78 -71 -84 -71 -9 0 -56 -36 -113 -88 -11 -10 -41 -35 -67 -56 -27 -21 -48
-44 -48 -51 0 -7 -18 -15 -39 -19 -46 -7 -138 -61 -146 -85 -3 -9 -38 -37 -77
-64 -40 -26 -122 -81 -182 -123 -97 -68 -112 -76 -143 -71 -56 9 -66 24 -61
85 6 64 22 82 100 110 90 33 168 82 168 105 0 30 130 147 164 147 21 0 65 39
92 82 14 21 35 43 48 48 13 4 56 40 97 78 41 38 97 88 124 110 78 62 191 191
271 311 20 29 54 77 75 105 21 28 39 55 39 60 0 4 13 25 29 45 74 93 195 392
245 601 41 175 40 465 -4 599 -55 171 -155 338 -234 393 -17 12 -33 25 -36 28
-3 3 -28 20 -56 38 -74 47 -171 65 -314 59 -108 -4 -113 -3 -80 11 56 23 127
31 245 27 98 -4 124 -9 240 -49z m-548 -12 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6
6 11 1 17 -2 13 -5z m-2709 -427 c3 -14 -5 -17 -37 -17 -62 0 -217 -35 -243
-54 -22 -18 -53 -68 -68 -111 -10 -30 -14 -154 -17 -506 -4 -425 -3 -467 12
-482 15 -15 69 -17 593 -17 445 0 583 3 602 13 l25 13 3 434 c2 293 0 457 -8
502 -14 79 -50 139 -96 162 -48 22 -157 46 -215 46 -35 0 -49 4 -49 14 0 8 10
16 23 20 18 4 559 -4 912 -14 26 -1 23 -3 -20 -17 -116 -35 -135 -45 -169 -87
-19 -23 -40 -62 -45 -86 -6 -26 -11 -179 -11 -353 l0 -308 -26 -52 c-18 -37
-70 -95 -176 -199 -83 -81 -164 -155 -181 -163 -26 -13 -110 -15 -588 -15
-494 0 -559 -2 -573 -16 -14 -13 -16 -55 -15 -312 0 -163 4 -389 8 -502 6
-179 10 -211 28 -252 35 -78 124 -124 263 -137 44 -4 65 -10 65 -19 0 -11 -78
-13 -414 -12 -366 1 -610 6 -619 15 -1 1 36 7 82 13 93 12 147 35 193 81 60
59 65 83 71 325 4 208 6 222 26 241 11 11 25 20 30 20 5 0 11 6 14 13 2 8 -3
12 -14 10 -12 -2 -20 4 -22 17 -2 11 -10 24 -18 28 -12 7 -14 130 -14 770 1
849 2 831 -65 900 -24 24 -54 42 -89 52 -49 14 -159 35 -175 33 -19 -2 -33 3
-27 10 4 4 202 9 439 12 599 7 601 7 605 -13z m2806 -238 c11 -19 41 -88 67
-154 76 -193 147 -367 168 -410 10 -22 33 -78 51 -125 19 -47 37 -87 41 -90 3
-3 18 -40 32 -82 30 -91 28 -103 -37 -211 -112 -186 -127 -192 -179 -73 -20
47 -37 88 -37 91 0 8 -117 281 -137 319 -9 17 -30 72 -47 121 -27 80 -34 90
-55 90 -19 0 -28 -10 -47 -55 -13 -30 -42 -98 -64 -150 -23 -52 -53 -124 -66
-160 -14 -36 -40 -98 -59 -137 -19 -40 -35 -75 -35 -78 0 -4 -8 -25 -19 -48
-10 -23 -29 -66 -41 -94 -12 -29 -25 -53 -28 -53 -16 0 -82 77 -82 95 0 12 11
44 25 71 14 28 42 93 64 145 94 230 115 280 156 369 24 52 47 106 51 120 4 14
26 66 49 115 23 50 48 108 55 130 7 22 23 60 35 85 12 25 35 79 49 120 37 101
54 111 90 49z m-534 -584 c0 -2 -10 -9 -22 -15 -22 -11 -22 -10 -4 4 21 17 26
19 26 11z m466 -192 c21 -54 17 -204 -7 -228 -14 -14 -14 -9 -3 57 7 40 11 84
8 98 -11 53 -36 130 -45 136 -5 3 -9 11 -9 17 1 20 38 -35 56 -80z m-866 -268
c0 -8 0 -18 1 -22 0 -4 -4 -9 -10 -11 -6 -2 -11 8 -11 22 0 14 5 26 10 26 6 0
10 -7 10 -15z m698 4 c17 -6 33 -17 36 -25 7 -19 46 -18 75 2 l23 16 -21 -40
c-14 -28 -33 -46 -64 -61 -55 -27 -87 -27 -121 0 -36 29 -34 87 4 106 31 16
30 15 68 2z m-1380 -321 l-3 -153 -41 -20 c-55 -27 -76 -44 -105 -83 -23 -33
-24 -39 -24 -201 l0 -168 30 -43 c20 -29 47 -51 85 -69 30 -14 57 -27 59 -28
12 -8 -52 -82 -117 -136 l-34 -27 -223 0 c-209 0 -285 9 -197 24 63 10 143 54
193 106 37 38 55 50 79 50 29 0 30 2 30 44 0 39 -4 47 -27 58 -15 7 -26 16
-25 21 1 4 2 84 2 177 l0 170 25 12 c22 10 25 16 22 62 -2 43 1 55 28 88 156
192 222 268 237 268 5 0 7 -69 6 -152z m1077 -36 c-6 -7 -35 18 -35 31 0 5 9
2 20 -8 11 -10 18 -20 15 -23z m-77 -68 c48 -42 63 -80 29 -69 -12 3 -43 9
-69 12 -50 6 -55 11 -39 41 5 9 12 25 15 35 8 25 19 21 64 -19z m1241 -33 l23
-50 -28 -51 c-22 -40 -25 -53 -15 -59 11 -7 12 -47 9 -190 -3 -99 -1 -181 4
-181 4 0 8 -7 8 -15 0 -9 6 -12 15 -8 10 3 15 1 13 -7 -6 -23 61 -50 144 -58
l81 -7 47 -89 c26 -49 62 -104 81 -123 38 -39 114 -93 132 -93 7 0 6 -4 -3 -9
-23 -13 -184 -20 -505 -23 -290 -3 -356 5 -243 28 50 10 114 39 149 66 53 43
54 117 5 258 -21 58 -44 132 -53 165 -17 68 -48 138 -67 154 -21 17 -49 99
-42 124 7 31 194 227 209 221 7 -2 23 -26 36 -53z m-1024 -53 c4 -10 33 -12
118 -7 149 7 166 1 106 -42 -25 -18 -47 -23 -103 -24 -39 -1 -103 -5 -141 -9
-86 -10 -101 0 -83 57 11 35 13 37 55 37 26 0 46 -5 48 -12z m-122 -25 c-7 -3
-13 -12 -14 -21 0 -11 -2 -12 -6 -4 -2 6 -13 12 -23 12 -10 0 -21 4 -24 8 -3
5 14 9 37 9 23 0 36 -2 30 -4z m-36 -29 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6
11 1 17 -2 13 -5z m-69 -20 c20 -6 21 -8 6 -18 -8 -7 -28 -34 -42 -61 -31 -57
-59 -68 -93 -36 -20 18 -20 22 -8 62 10 32 21 45 39 50 33 9 70 10 98 3z
m1272 -26 c0 -5 -7 -8 -15 -8 -17 0 -18 2 -9 25 5 13 8 14 15 3 5 -7 9 -16 9
-20z m-2260 -52 c0 -66 -4 -74 -40 -81 -31 -6 -43 27 -29 78 13 51 25 67 50
67 17 0 19 -8 19 -64z m2330 -23 c12 -27 35 -86 52 -133 17 -47 37 -94 45
-105 7 -11 13 -28 13 -38 0 -17 -6 -19 -50 -15 -34 4 -59 13 -75 28 -24 22
-25 30 -26 139 0 74 -4 109 -9 96 -5 -11 -9 -15 -9 -9 -1 14 27 84 34 84 2 0
14 -21 25 -47z m-1487 -120 c16 -3 31 -11 34 -18 6 -16 -52 -132 -69 -137 -18
-6 -58 3 -58 13 0 5 -4 9 -10 9 -11 0 -52 -91 -44 -99 3 -3 20 -11 37 -17 35
-12 34 -7 22 -131 -10 -98 1 -124 71 -158 29 -14 85 -34 124 -43 38 -9 70 -19
70 -23 0 -18 -609 -25 -675 -7 -34 8 -37 11 -21 20 12 7 21 7 25 1 8 -13 101
-24 101 -12 0 4 -10 15 -22 25 -13 9 -16 14 -7 11 9 -3 26 3 37 14 12 10 26
19 32 19 5 0 10 5 10 10 0 6 7 10 15 10 8 0 15 6 15 14 0 8 16 38 36 67 20 29
48 77 61 108 14 31 43 93 64 139 21 45 42 95 46 110 3 15 13 42 20 61 12 27
18 32 36 27 12 -4 35 -9 50 -13z m-851 -28 c17 -7 17 -127 0 -133 -30 -10 -83
97 -65 131 5 8 45 10 65 2z m2268 -140 c-7 -8 -17 -12 -22 -9 -5 3 -1 15 9 26
20 22 32 6 13 -17z m-681 -176 c13 -48 21 -100 19 -115 -2 -20 -12 6 -31 81
-27 111 -35 165 -18 135 5 -8 18 -54 30 -101z m-1372 -87 c-34 -4 -48 5 -27
18 8 5 22 4 34 -3 20 -11 20 -12 -7 -15z m1400 -119 c-3 -10 -5 -2 -5 17 0 19
2 27 5 18 2 -10 2 -26 0 -35z m-1324 -50 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5
14 0 19 -2 13 -5z m1344 -270 c-9 -240 -41 -470 -83 -588 -14 -38 -34 -99 -45
-135 -21 -66 -79 -194 -85 -187 -4 4 31 111 69 207 14 36 33 106 42 155 9 50
23 124 31 165 8 41 18 98 24 125 9 49 23 187 36 353 11 143 17 89 11 -95z
m-927 150 c0 -5 -21 -30 -46 -58 -25 -27 -57 -68 -72 -90 -15 -22 -33 -44 -40
-48 -7 -5 -10 -12 -8 -16 3 -5 -8 -23 -24 -41 -16 -18 -27 -38 -23 -43 4 -6 0
-8 -10 -4 -9 3 -18 1 -21 -6 -5 -9 -7 -9 -12 1 -3 6 -14 12 -25 12 -17 0 -19
-8 -19 -83 0 -46 -3 -87 -7 -91 -12 -11 -31 -96 -23 -101 9 -5 0 -58 -10 -65
-4 -3 -10 -23 -12 -46 -3 -23 -8 -46 -12 -53 -4 -7 -7 -89 -6 -184 3 -266 3
-258 18 -252 12 4 13 -4 8 -42 -3 -27 -3 -42 0 -35 10 23 20 12 21 -24 1 -21
8 -41 20 -51 17 -14 17 -14 -1 -9 -16 5 -17 4 -7 -8 7 -8 10 -20 6 -26 -3 -6
-8 -40 -10 -76 -1 -36 -5 -68 -9 -71 -10 -11 5 -23 30 -23 28 0 32 15 7 24
-10 4 -13 10 -8 14 17 12 13 82 -4 82 -13 0 -13 2 1 16 14 15 18 14 48 -12 18
-16 36 -39 41 -52 5 -13 13 -21 18 -17 6 3 13 -1 18 -8 12 -21 141 -84 193
-96 57 -13 179 3 232 30 21 11 38 16 38 12 0 -15 -156 -82 -218 -94 -68 -13
-228 -7 -245 10 -5 5 -15 7 -21 5 -7 -3 -24 6 -39 20 -27 25 -112 68 -120 60
-2 -2 -14 7 -27 21 -13 14 -28 25 -34 25 -6 1 -24 19 -41 40 -16 22 -43 55
-60 73 -33 38 -86 154 -111 244 -20 69 -32 324 -22 434 7 77 40 215 59 251 6
11 17 41 25 67 8 27 27 65 44 86 16 21 30 44 30 51 0 7 11 26 25 42 14 17 25
34 25 39 0 18 68 86 79 79 6 -4 11 0 11 9 0 28 20 57 33 48 14 -11 43 -9 77 5
23 10 21 11 -18 11 -26 1 -41 5 -37 11 7 12 295 14 295 3z m-258 -355 c-9 -9
-12 -7 -12 12 0 19 3 21 12 12 9 -9 9 -15 0 -24z m952 -750 c-4 -13 -16 -34
-27 -48 l-19 -25 7 25 c4 13 14 30 21 38 8 7 14 18 14 23 0 5 3 9 6 9 3 0 2
-10 -2 -22z m-234 -308 c0 -5 -10 -15 -22 -21 -23 -12 -23 -12 -4 10 21 23 26
26 26 11z m-317 -517 c-18 -2 -48 -2 -65 0 -18 2 -4 4 32 4 36 0 50 -2 33 -4z
m400 0 c-18 -2 -48 -2 -65 0 -18 2 -4 4 32 4 36 0 50 -2 33 -4z m1627 -57 c0
-37 -4 -66 -10 -66 -5 0 -10 -19 -10 -42 0 -23 -3 -38 -7 -34 -9 9 -10 69 -1
76 3 3 8 31 10 63 l4 57 -55 -2 -56 -1 45 -6 c45 -6 45 -6 48 -48 2 -32 0 -41
-12 -39 -24 3 -28 12 -11 26 25 21 17 30 -27 32 l-43 1 45 7 c44 7 45 7 8 8
-91 4 -90 28 2 31 l70 2 0 -65z m-2411 23 c-7 -4 -17 -5 -22 -2 -5 3 -3 9 4
14 7 4 17 5 22 2 5 -3 3 -9 -4 -14z m354 14 c-13 -2 -33 -2 -45 0 -13 2 -3 4
22 4 25 0 35 -2 23 -4z m54 1 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2
13 -5z m381 -1 c-15 -2 -42 -2 -60 0 -18 2 -6 4 27 4 33 0 48 -2 33 -4z m934
-14 c11 -6 18 -5 21 4 2 6 6 10 9 7 3 -3 -1 -16 -9 -30 -8 -16 -13 -19 -13 -9
0 19 -104 44 -143 34 -29 -8 -52 -45 -45 -73 7 -25 -24 -24 -34 1 -8 18 9 64
19 54 2 -3 0 -15 -7 -26 -6 -12 -7 -21 -1 -21 5 0 12 13 16 29 4 20 15 33 33
40 29 11 126 5 154 -10z m-4034 4 c-26 -2 -71 -2 -100 0 -29 2 -8 3 47 3 55 0
79 -1 53 -3z m240 0 c-26 -2 -71 -2 -100 0 -29 2 -8 3 47 3 55 0 79 -1 53 -3z
m2102 -8 c0 -8 -4 -15 -10 -15 -5 0 -7 7 -4 15 4 8 8 15 10 15 2 0 4 -7 4 -15z
m378 -67 l-2 -73 -3 67 -4 67 -57 4 -57 3 63 2 62 2 -2 -72z m314 -45 c-4
-218 -8 -239 -10 -60 -1 97 1 177 6 177 4 0 6 -53 4 -117z m63 64 c0 -26 5
-47 10 -47 6 0 9 23 9 52 l-2 53 7 -50 c6 -47 -20 -190 -27 -151 -2 9 -7 14
-12 11 -5 -3 -8 33 -8 81 1 64 -2 88 -13 95 -10 7 -8 9 11 7 23 -3 25 -7 25
-51z m-3115 21 c0 -18 -2 -20 -9 -8 -6 8 -7 18 -5 22 9 14 14 9 14 -14z m17
-100 c-2 -24 -4 -5 -4 42 0 47 2 66 4 43 2 -24 2 -62 0 -85z m210 75 c-3 -10
-5 -2 -5 17 0 19 2 27 5 18 2 -10 2 -26 0 -35z m30 -215 c-1 -51 -3 -12 -3 87
0 99 2 141 3 93 2 -48 2 -129 0 -180z m3781 242 c12 -12 22 -26 22 -33 0 -6
-8 -2 -17 8 -10 11 -24 26 -32 33 -8 6 -10 12 -5 12 6 0 20 -9 32 -20z m-4075
-6 c-3 -7 -10 -11 -17 -7 -6 4 -20 7 -31 5 -18 -1 -18 -1 -2 6 33 14 56 12 50
-4z m3113 -21 c-11 -11 -19 6 -11 24 8 17 8 17 12 0 3 -10 2 -21 -1 -24z
m-1496 16 c0 -6 -9 -8 -20 -4 -21 7 -90 -14 -90 -26 0 -18 13 -38 21 -33 13 8
11 -10 -3 -24 -9 -9 -9 -12 0 -12 7 0 12 -4 12 -10 0 -5 -6 -9 -12 -7 -10 1
-13 -23 -12 -98 0 -55 4 -111 8 -125 7 -24 7 -24 -9 -5 -13 17 -15 44 -13 180
l3 160 30 6 c49 11 85 10 85 -2z m714 -23 c-3 -14 -10 -26 -15 -26 -4 0 -3 14
3 31 12 36 22 33 12 -5z m2364 17 c-5 -26 -38 -29 -38 -4 0 15 6 21 21 21 14
0 19 -5 17 -17z m-572 -61 c-12 -11 -16 6 -9 39 l8 34 3 -33 c2 -19 1 -36 -2
-40z m-2546 40 c-8 -3 -23 -9 -32 -14 -10 -5 -18 -5 -18 -1 0 11 43 30 55 24
5 -2 2 -7 -5 -9z m885 -107 c6 -17 5 -17 -5 -5 -9 12 -11 9 -6 -18 3 -19 2
-31 -3 -27 -5 3 -11 0 -14 -7 -2 -7 -2 -3 0 10 2 12 -2 32 -8 43 -9 17 -8 20
1 14 10 -6 11 -2 7 16 -3 13 -8 42 -12 64 -5 36 -4 35 13 -15 11 -30 23 -64
27 -75z m218 119 c8 -8 -3 -34 -14 -34 -5 0 -9 9 -9 20 0 19 11 26 23 14z
m-1068 -24 c-3 -5 -14 -10 -23 -10 -15 0 -15 2 -2 10 20 13 33 13 25 0z m2249
-24 c1 -15 11 -33 22 -40 26 -20 13 -29 -14 -10 -16 11 -22 25 -22 51 0 41 10
40 14 -1z m-3597 -108 c-2 -24 -4 -5 -4 42 0 47 2 66 4 43 2 -24 2 -62 0 -85z
m2503 12 c5 0 10 8 12 18 2 9 2 -24 0 -75 -3 -53 0 -105 7 -123 9 -28 9 -31
-4 -20 -8 7 -15 24 -16 39 0 25 0 25 -9 4 -13 -32 -22 -29 -14 3 4 17 3 25 -3
21 -6 -4 -7 7 -4 26 5 32 6 32 9 5 6 -52 22 -28 22 33 0 37 -4 58 -10 54 -5
-3 -10 -1 -10 5 0 6 -5 8 -12 4 -10 -6 -9 -3 0 8 8 9 13 25 12 35 -1 10 -1 32
1 48 1 17 4 4 6 -27 2 -32 8 -58 13 -58z m-2714 23 c16 -6 19 -43 3 -43 -6 0
-9 7 -5 15 3 9 0 15 -7 15 -9 0 -13 16 -14 48 0 40 0 41 4 9 2 -21 11 -41 19
-44z m2338 62 c3 -8 1 -15 -4 -15 -6 0 -10 7 -10 15 0 8 2 15 4 15 2 0 6 -7
10 -15z m726 -52 c0 -38 -5 -75 -10 -83 -7 -10 -10 11 -10 68 0 48 4 82 10 82
6 0 10 -29 10 -67z m805 56 c4 -6 5 -12 2 -15 -7 -7 -37 7 -37 17 0 13 27 11
35 -2z m873 -36 c23 20 78 31 87 18 3 -7 -3 -12 -17 -13 -13 0 -29 -2 -36 -2
-23 -2 -52 -46 -52 -80 0 -17 -5 -38 -11 -46 -8 -11 -9 -7 -4 18 4 20 3 32 -4
32 -6 0 -11 9 -11 21 0 11 5 17 10 14 6 -4 11 13 12 42 1 38 2 41 5 15 4 -31
6 -32 21 -19z m-2508 -38 c-21 -56 -25 -75 -14 -75 8 0 4 -9 -11 -24 -13 -13
-29 -42 -36 -65 -7 -22 -16 -41 -21 -41 -9 0 27 100 40 109 4 3 9 15 9 26 1
28 44 145 53 145 5 0 -5 -34 -20 -75z m47 53 c-3 -8 -6 -5 -6 6 -1 11 2 17 5
13 3 -3 4 -12 1 -19z m1698 -14 c33 -9 54 -19 48 -21 -21 -8 -143 34 -143 48
0 5 8 5 18 0 9 -6 44 -18 77 -27z m-3464 14 c0 -9 2 -10 5 -1 4 8 14 9 36 2
46 -13 49 -22 4 -14 -28 6 -37 5 -32 -4 5 -7 1 -9 -8 -5 -9 3 -16 10 -16 15 0
13 -34 11 -48 -3 -7 -7 -12 -9 -12 -4 0 4 -10 0 -22 -8 -29 -20 -44 -21 -28
-1 23 28 119 46 121 23z m693 -4 c3 -9 6 -34 6 -55 0 -27 4 -38 11 -33 7 4 10
-1 7 -11 -1 -10 -9 -20 -15 -23 -9 -2 -13 11 -13 46 0 28 -3 57 -6 66 -7 20
-33 21 -59 3 -25 -17 -65 -28 -65 -17 0 11 70 39 101 39 16 1 29 -6 33 -15z
m1613 10 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m460 -26 c23
-21 37 -58 22 -58 -5 0 -9 8 -9 18 0 23 -85 68 -103 54 -19 -15 -47 -22 -47
-13 0 15 53 30 85 24 17 -3 40 -14 52 -25z m338 11 c12 -12 -6 -12 -39 1 -24
9 -26 8 -26 -20 0 -21 5 -30 16 -30 27 0 10 -69 -17 -70 -4 0 -7 15 -7 33 -1
81 -2 88 -24 98 -17 7 -9 8 32 4 30 -4 59 -10 65 -16z m-2797 4 c-27 -2 -69
-2 -95 0 -27 2 -5 3 47 3 52 0 74 -1 48 -3z m177 0 c-15 -3 -26 -23 -44 -84
-13 -44 -28 -82 -33 -85 -10 -6 -11 20 -1 30 7 6 43 114 43 128 0 4 -10 9 -22
11 -13 2 0 4 27 4 28 0 41 -2 30 -4z m286 -13 c15 -12 19 -19 10 -20 -11 0
-10 -4 4 -20 10 -11 15 -26 11 -36 -10 -26 -38 3 -34 37 2 19 -4 33 -17 43
-11 9 -15 16 -9 16 7 0 22 -9 35 -20z m342 13 c-13 -2 -33 -2 -45 0 -13 2 -3
4 22 4 25 0 35 -2 23 -4z m217 -8 c0 -8 -8 -15 -17 -15 -16 0 -18 -10 -17 -87
1 -49 0 -74 -3 -58 -3 17 -9 36 -15 43 -7 8 -7 12 1 12 6 0 11 17 11 41 0 36
-3 40 -22 39 -40 -4 -58 0 -58 10 0 6 26 11 58 12 57 2 56 2 -18 8 l-75 6 78
2 c63 2 77 -1 77 -13z m178 -92 l-2 -108 -3 102 -4 102 -59 -1 c-33 -1 -63 1
-67 5 -3 4 26 7 65 7 l72 0 -2 -107z m622 92 c0 -9 -6 -12 -15 -9 -8 4 -12 10
-9 15 8 14 24 10 24 -6z m140 5 c0 -5 -3 -10 -7 -10 -5 0 -19 -3 -33 -6 l-25
-5 25 15 c30 18 40 20 40 6z m122 -51 c21 -41 23 -60 5 -34 -8 10 -19 15 -25
11 -11 -7 -16 7 -15 42 1 6 -3 12 -8 12 -17 0 -20 -21 -9 -56 10 -29 15 -34
33 -28 22 6 22 6 -1 -11 -12 -9 -20 -21 -17 -26 4 -5 -1 -9 -11 -9 -13 0 -15
-6 -11 -30 4 -16 2 -32 -4 -36 -6 -3 -10 0 -8 7 1 8 0 34 -1 59 l-3 45 -7 -55
c-7 -60 7 -119 21 -83 6 14 7 12 6 -9 -1 -25 -3 -26 -18 -12 -10 9 -19 11 -23
6 -3 -6 0 -12 6 -15 7 -2 1 -8 -14 -12 -37 -10 -56 4 -26 19 21 11 24 20 30
110 4 54 10 101 13 104 3 3 5 -5 5 -18 0 -34 13 -16 14 20 1 20 -3 29 -11 26
-7 -3 -15 0 -19 6 -5 7 2 9 20 6 21 -4 26 -2 21 10 -11 30 39 -13 57 -49z
m588 51 c0 -5 -6 -7 -14 -4 -8 3 -17 1 -21 -5 -3 -6 -14 -11 -23 -11 -15 1
-15 2 2 15 22 17 56 20 56 5z m817 3 c-7 -7 -139 -4 -146 3 -2 2 31 4 74 4 43
0 75 -3 72 -7z m141 0 c-21 -2 -55 -2 -75 0 -21 2 -4 4 37 4 41 0 58 -2 38 -4z
m439 -25 c6 -7 14 -27 17 -44 6 -25 3 -33 -11 -38 -21 -8 -43 17 -43 51 0 35
15 27 27 -14 l10 -38 2 36 c1 29 -4 38 -25 47 -14 7 -23 8 -20 3 3 -5 -3 -7
-14 -4 -17 5 -20 1 -20 -28 l1 -34 14 30 14 30 -5 -45 c-3 -33 -2 -40 5 -25 7
14 10 16 11 5 1 -8 3 -23 5 -33 2 -9 -1 -15 -6 -11 -5 3 -9 -11 -9 -31 0 -20
-4 -34 -10 -30 -5 3 -7 11 -5 18 3 7 1 26 -4 42 -8 27 -10 23 -12 -30 -2 -46
-4 -36 -8 45 -6 103 -6 105 17 108 12 2 22 8 22 13 0 12 32 -4 47 -23z m-1760
-30 c-2 -13 -4 -5 -4 17 -1 22 1 32 4 23 2 -10 2 -28 0 -40z m-2947 33 c0 -6
-4 -13 -10 -16 -5 -3 -10 1 -10 9 0 9 5 16 10 16 6 0 10 -4 10 -9z m583 3 c3
-3 2 -17 -4 -31 -13 -34 -1 -73 22 -73 24 0 39 -35 42 -101 1 -30 7 -49 14
-49 18 0 27 21 14 30 -7 4 -10 17 -6 32 4 16 -1 38 -14 61 -11 21 -17 37 -13
37 24 0 60 -119 46 -154 -3 -9 -16 -16 -29 -16 -18 0 -26 10 -39 48 -10 26
-22 55 -27 66 -8 14 -7 17 2 14 7 -2 17 -19 22 -37 11 -43 18 -35 10 12 -4 27
-11 37 -24 37 -11 0 -21 13 -29 38 -7 20 -16 41 -21 47 -12 12 -11 25 0 25 5
0 11 -8 13 -17 3 -15 5 -14 10 5 3 12 3 20 -1 18 -4 -3 -13 -1 -21 5 -12 7
-11 9 6 9 11 0 23 -3 27 -6z m77 -4 c0 -5 -12 -10 -27 -10 -22 0 -25 2 -13 10
20 13 40 13 40 0z m420 -6 c0 -2 -7 -4 -15 -4 -8 0 -15 4 -15 10 0 5 7 7 15 4
8 -4 15 -8 15 -10z m736 -8 c3 -13 4 -35 1 -47 -3 -17 -5 -12 -8 16 -1 25 -5
7 -8 -45 -5 -66 -9 -85 -21 -85 -12 0 -16 17 -18 78 -3 79 6 107 34 107 8 0
16 -11 20 -24z m1249 14 c4 -6 1 -9 -7 -8 -10 2 -14 -22 -19 -97 -3 -55 -2
-101 2 -103 5 -2 9 -12 9 -23 0 -26 -45 -47 -68 -32 -10 6 -52 8 -102 5 -47
-2 -83 -2 -80 1 3 3 10 6 15 7 6 1 15 11 22 23 l12 22 1 -22 c0 -27 20 -31 21
-5 0 14 2 14 9 -3 8 -19 9 -18 9 4 1 20 3 22 16 11 13 -11 13 -15 3 -21 -9 -6
-9 -9 -1 -9 21 0 26 21 26 109 l-1 86 7 -88 c6 -86 15 -106 47 -107 26 0 34
31 36 143 3 102 5 117 20 117 9 0 20 -5 23 -10z m1043 -2 c17 -17 16 -178 0
-178 -7 0 -5 -5 5 -11 9 -5 17 -19 17 -29 0 -34 35 -23 64 20 22 34 26 50 26
113 0 43 -5 78 -12 85 -9 9 -6 12 14 12 56 0 58 -5 56 -104 l-2 -91 -5 90 c-5
71 -9 90 -21 90 -12 0 -16 -16 -18 -75 -1 -41 -6 -84 -11 -95 -17 -36 -19 -75
-5 -75 8 0 16 16 20 41 5 28 10 37 17 30 7 -7 7 -19 -1 -36 -7 -15 -10 -31 -7
-36 4 -5 -5 -9 -20 -9 -14 0 -28 7 -31 15 -5 13 -10 12 -31 -5 -28 -22 -69
-26 -93 -9 -11 7 -5 8 23 3 20 -3 37 -2 37 2 -1 15 -27 44 -33 37 -4 -3 -7 1
-7 10 0 9 -5 17 -11 17 -7 0 -9 -10 -5 -25 4 -14 2 -25 -4 -25 -5 0 -10 9 -10
20 0 15 -7 20 -25 20 -15 0 -25 6 -25 14 0 11 7 13 28 7 27 -8 59 9 45 23 -4
3 -1 6 5 6 5 0 13 -6 16 -12 2 -7 4 24 3 69 l-2 83 -48 0 c-30 0 -46 4 -42 10
9 14 78 13 93 -2z m202 -78 c0 -53 -4 -90 -10 -90 -6 0 -10 37 -10 90 0 53 4
90 10 90 6 0 10 -37 10 -90z m-4037 74 c-7 -3 -9 -12 -6 -21 4 -11 2 -14 -5
-9 -18 11 -14 36 6 35 9 0 12 -3 5 -5z m145 -1 c-10 -2 -28 -2 -40 0 -13 2 -5
4 17 4 22 1 32 -1 23 -4z m558 -5 c4 -7 3 -8 -4 -4 -20 12 -82 -23 -75 -42 4
-15 3 -15 -6 -2 -12 17 -15 44 -3 36 4 -2 18 2 32 10 31 17 47 17 56 2z m774
-73 c0 -50 -4 -85 -10 -85 -6 0 -10 35 -10 85 0 50 4 85 10 85 6 0 10 -35 10
-85z m1570 65 c8 -15 7 -26 -6 -45 -18 -28 -34 -33 -34 -11 0 21 -30 48 -46
42 -8 -3 -14 1 -14 8 0 18 47 12 71 -10 10 -9 22 -14 25 -11 4 4 -4 15 -17 26
-20 17 -21 20 -7 21 10 0 22 -9 28 -20z m143 13 c11 -18 18 -93 10 -93 -5 0
-10 8 -10 18 1 69 -14 96 -28 52 -8 -24 -21 -26 -29 -4 -3 8 -2 12 4 9 6 -3
10 -4 10 0 0 3 -10 10 -22 15 -19 7 -16 9 19 9 23 1 44 -2 46 -6z m300 0 c-7
-2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m-3523 -7 c0 -3 -4 -8 -10
-11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z m1058 -144 c1 9 6 19
11 22 12 8 9 -26 -4 -40 -18 -21 -25 7 -23 91 l2 80 6 -85 c3 -47 7 -77 8 -68z
m355 93 c0 -25 -3 -48 -7 -52 -3 -3 -6 20 -6 52 0 32 3 55 6 52 4 -4 7 -27 7
-52z m486 -15 c0 -8 -6 0 -14 19 -8 18 -15 38 -14 45 1 15 28 -46 28 -64z m21
20 c0 -9 6 -22 13 -29 10 -10 9 -11 -5 -6 -15 6 -15 3 -3 -32 7 -21 10 -42 7
-47 -3 -6 -11 6 -17 25 -10 29 -17 35 -51 40 l-39 6 37 2 c46 1 52 11 39 58
-9 34 -9 36 4 19 8 -11 15 -27 15 -36z m20 6 c0 -26 -6 -18 -14 19 -5 22 -4
26 4 15 5 -8 10 -24 10 -34z m320 34 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3
6 8 10 11 10 2 0 4 -4 4 -10z m590 -1 c0 -5 -4 -9 -10 -9 -5 0 -10 -8 -10 -17
0 -15 -2 -16 -10 -3 -15 23 -12 36 10 37 11 1 20 -2 20 -8z m577 -24 c20 -19
34 -37 30 -41 -4 -4 -7 -2 -7 4 0 7 -6 12 -13 12 -8 0 -26 14 -40 30 -37 41
-17 38 30 -5z m33 8 c0 -13 -3 -13 -15 -3 -8 7 -15 16 -15 21 0 5 7 6 15 3 8
-4 15 -13 15 -21z m507 -10 c-3 -10 -5 -4 -5 12 0 17 2 24 5 18 2 -7 2 -21 0
-30z m-3997 7 c0 -11 5 -20 10 -20 6 0 10 3 10 8 0 4 14 8 30 8 19 1 29 -3 27
-10 -2 -6 -13 -10 -23 -9 -10 1 -21 -2 -24 -6 -10 -16 -50 8 -50 29 0 11 5 20
10 20 6 0 10 -9 10 -20z m230 -37 c0 -57 -5 -53 -13 10 -4 31 -3 46 3 42 6 -3
10 -27 10 -52z m3290 47 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10
10 6 0 10 -4 10 -10z m180 -84 c0 -53 -31 -123 -50 -111 -6 3 -10 0 -10 -8 0
-16 -21 -27 -48 -26 -10 0 -6 5 10 10 26 10 44 47 39 79 -4 23 -47 54 -94 67
l-42 13 40 -6 c22 -3 50 -12 62 -20 28 -18 31 -18 36 4 2 9 3 5 1 -10 -2 -16
1 -28 8 -28 7 0 8 -12 4 -32 l-6 -33 20 25 c25 32 27 111 4 134 -8 9 -20 14
-25 11 -5 -4 -6 1 -3 10 6 14 10 13 30 -6 19 -18 24 -33 24 -73z m-3970 72 c0
-5 -20 -8 -45 -8 -25 0 -45 3 -45 8 0 4 20 7 45 7 25 0 45 -3 45 -7z m1027 5
c-4 -3 -3 -11 3 -17 6 -8 2 -16 -11 -24 -18 -12 -19 -11 -10 6 7 13 7 22 -1
30 -9 9 -7 12 7 12 10 0 15 -3 12 -7z m356 -8 c-3 -9 -8 -14 -10 -11 -3 3 -2
9 2 15 9 16 15 13 8 -4z m-1523 1 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6
5 11 10 11 6 0 10 -2 10 -4z m899 -94 c1 -24 -17 -3 -22 25 -3 16 -8 39 -11
53 -4 14 2 5 13 -20 11 -25 20 -51 20 -58z m1551 58 c0 -13 -1 -13 -10 0 -5 8
-10 22 -10 30 0 13 1 13 10 0 5 -8 10 -22 10 -30z m848 3 c-18 -22 -28 -14
-16 12 8 18 14 22 19 13 4 -7 3 -18 -3 -25z m-2168 17 c0 -5 -4 -10 -10 -10
-5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m142 -28 c-6 -2 -8 -10
-5 -18 3 -8 -1 -14 -11 -14 -19 0 -21 -16 -3 -23 7 -3 5 -6 -5 -6 -10 -1 -18
4 -18 9 0 6 -9 10 -20 10 -11 0 -20 -4 -20 -10 0 -5 -10 -10 -22 -11 -22 0
-22 -1 -3 -9 19 -8 19 -9 -2 -9 -14 -1 -23 5 -23 14 0 9 10 16 23 16 18 1 16
3 -8 9 l-30 8 31 1 c72 3 95 12 101 43 5 27 7 28 16 12 7 -12 7 -19 -1 -22z
m2183 27 c12 -19 -5 -23 -22 -6 -16 16 -16 17 -1 17 9 0 20 -5 23 -11z m-3435
-74 c0 -61 -1 -65 -22 -64 -17 1 -19 2 -5 6 14 4 17 16 17 60 0 50 -2 55 -20
50 -11 -3 -20 -1 -20 4 0 5 11 9 25 9 24 0 25 -2 25 -65z m2627 48 c0 -10 -6
-24 -14 -31 -11 -11 -13 -8 -13 17 0 19 5 31 13 31 8 0 14 -8 14 -17z m693 7
c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z m750
-49 c0 -45 -6 -37 -13 18 -4 29 -2 40 4 30 5 -7 9 -29 9 -48z m617 -53 c-2
-24 -4 -7 -4 37 0 44 2 63 4 43 2 -21 2 -57 0 -80z m-4151 64 c-2 -9 -9 -18
-16 -20 -7 -3 -10 0 -6 7 4 6 1 11 -6 11 -9 0 -9 3 2 10 8 5 11 10 7 10 -5 0
-5 5 -1 11 8 14 23 -7 20 -29z m571 32 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11
1 17 -2 13 -5z m453 -20 c0 -8 -4 -12 -10 -9 -5 3 -10 10 -10 16 0 5 5 9 10 9
6 0 10 -7 10 -16z m426 -103 c-18 -20 -21 -41 -6 -41 6 0 11 8 11 18 1 16 2
16 6 -1 3 -12 12 -16 29 -13 13 3 24 1 24 -4 0 -4 -23 -10 -50 -12 -45 -3 -50
-1 -50 17 0 11 -9 27 -20 35 -11 8 -20 18 -20 22 0 14 23 8 36 -9 12 -17 14
-17 28 2 8 11 16 40 18 65 2 45 2 45 5 -9 3 -38 0 -58 -11 -70z m1114 62 c-1
-53 -2 -56 -15 -39 -8 11 -15 25 -15 30 0 6 5 4 10 -4 7 -11 10 -4 10 28 0 23
2 42 5 42 3 0 5 -26 5 -57z m153 -39 c4 -4 13 0 20 9 10 13 14 13 24 3 8 -10
8 -19 0 -36 -15 -28 -37 -38 -37 -16 0 9 -7 19 -15 22 -11 5 -15 21 -14 63 l2
56 6 -47 c4 -26 10 -50 14 -54z m967 86 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10
10 0 6 5 10 10 10 6 0 10 -4 10 -10z m-1768 -35 c4 -15 5 -32 2 -37 -7 -11
-34 -10 -34 2 0 5 7 7 15 4 20 -8 19 6 -2 23 -10 8 -12 12 -5 8 7 -4 12 0 12
10 0 9 -4 13 -10 10 -5 -3 -10 -1 -10 5 0 22 24 3 32 -25z m2465 3 c-4 -40
-14 -65 -39 -97 -17 -22 -18 -22 -18 -4 0 11 6 26 14 32 7 6 19 32 26 56 15
53 22 58 17 13z m-4432 13 c3 -5 1 -12 -5 -16 -5 -3 -10 -1 -10 5 0 6 -4 8
-10 5 -5 -3 -10 -1 -10 4 0 13 27 14 35 2z m3072 3 c-3 -3 -12 -4 -19 -1 -8 3
-5 6 6 6 11 1 17 -2 13 -5z m103 -26 c0 -36 -10 -32 -14 6 -2 14 1 26 5 26 5
0 9 -14 9 -32z m-3236 7 c-10 -8 -28 -14 -39 -14 -16 1 -13 4 10 14 40 19 53
19 29 0z m3051 8 c-11 -3 -24 -9 -29 -14 -6 -5 -19 -9 -30 -9 -19 1 -19 2 4
15 14 8 36 14 50 13 20 0 21 -1 5 -5z m45 -2 c0 -5 -5 -11 -12 -13 -12 -4 -14
-54 -3 -89 5 -16 10 -18 21 -8 9 7 14 8 14 1 0 -13 -7 -17 -42 -26 -17 -4 -28
-2 -28 4 0 5 7 10 15 10 8 0 15 5 15 11 0 5 -4 8 -8 5 -5 -3 -7 9 -5 27 2 24
1 27 -5 13 -8 -19 -9 -19 -14 2 -4 14 -1 22 11 25 10 3 8 5 -7 6 -28 1 -19 21
9 21 10 0 19 5 19 10 0 6 5 10 10 10 6 0 10 -4 10 -9z m1138 -22 c-3 -8 -7 -3
-11 10 -4 17 -3 21 5 13 5 -5 8 -16 6 -23z m-4481 -1 c-3 -8 -6 -5 -6 6 -1 11
2 17 5 13 3 -3 4 -12 1 -19z m923 12 c0 -5 -6 -10 -12 -10 -9 0 -8 -4 2 -11
12 -8 11 -9 -5 -7 -18 3 -20 -2 -19 -42 2 -45 2 -45 -11 -15 -14 31 -11 50 13
78 17 19 32 22 32 7z m215 1 c3 -5 1 -12 -5 -16 -5 -3 -10 1 -10 9 0 18 6 21
15 7z m2245 -6 c0 -8 -2 -15 -4 -15 -2 0 -6 7 -10 15 -3 8 -1 15 4 15 6 0 10
-7 10 -15z m827 -7 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z
m-3938 5 c-3 -20 2 -27 10 -14 7 10 9 7 8 -12 -1 -15 -5 -27 -9 -27 -16 0 -7
-30 10 -39 13 -7 23 -6 30 1 9 9 12 9 12 1 0 -14 -65 -37 -83 -30 -8 4 -7 6 3
6 11 1 15 14 16 46 1 28 -2 42 -9 38 -6 -3 -7 -1 -3 5 4 7 3 12 -3 12 -5 0
-11 -3 -13 -8 -1 -4 -19 -4 -38 -1 l-35 6 35 2 c19 1 42 6 50 11 18 12 20 12
19 3z m171 -3 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4
4 -10z m1220 -27 c0 -7 -9 -13 -19 -13 -14 0 -19 -6 -18 -20 1 -14 8 -20 24
-20 13 0 23 -5 23 -11 0 -6 8 -8 18 -5 14 5 14 4 -2 -9 -25 -19 -52 -18 -91 1
-16 8 -22 12 -12 9 22 -6 22 2 -3 43 -25 41 -25 50 0 27 11 -10 20 -25 21 -34
0 -10 3 -8 9 7 5 12 16 22 24 22 9 0 13 7 9 23 -4 18 -3 19 6 7 6 -8 11 -21
11 -27z m1970 27 c0 -5 -4 -10 -9 -10 -6 0 -13 5 -16 10 -3 6 1 10 9 10 9 0
16 -4 16 -10z m-2973 -32 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z
m76 -1 c-4 -7 -20 -47 -35 -90 -15 -43 -38 -91 -52 -108 -14 -17 -26 -27 -26
-23 0 5 -5 3 -12 -4 -19 -19 -44 -14 -77 17 -35 33 -40 51 -13 52 11 0 12 2 4
6 -10 4 -9 8 5 19 21 16 47 18 38 3 -4 -6 0 -9 10 -7 10 2 20 -3 22 -9 5 -15
-23 -18 -32 -3 -10 16 -19 12 -31 -13 -8 -17 -7 -26 2 -35 9 -8 14 -7 18 4 3
8 10 12 16 9 5 -3 10 -1 10 4 0 6 5 11 12 11 6 0 1 -11 -11 -24 -12 -13 -19
-26 -14 -29 15 -9 71 21 78 42 3 12 11 21 16 21 6 0 7 5 4 10 -4 6 -2 16 3 23
5 7 17 33 27 59 14 39 15 51 5 63 -7 9 -8 15 -2 15 6 0 13 -6 15 -12 3 -8 6
-5 6 5 1 10 6 15 11 12 6 -4 7 -12 3 -18z m2504 17 c-3 -3 -12 -4 -19 -1 -8 3
-5 6 6 6 11 1 17 -2 13 -5z m492 -76 c8 3 11 0 7 -7 -9 -14 -36 -15 -36 -1 0
6 -8 10 -17 10 -15 0 -16 -2 -3 -10 17 -11 9 -13 -15 -4 -13 6 -14 9 -3 16 10
7 10 11 -4 22 -10 7 -18 18 -18 25 0 6 -4 11 -10 11 -5 0 -10 -7 -10 -15 0 -8
5 -15 10 -15 6 0 10 -7 10 -15 0 -8 -5 -15 -11 -15 -5 0 -7 -4 -4 -10 3 -5 1
-10 -4 -10 -6 0 -11 10 -11 23 0 12 -3 32 -6 44 -11 39 27 32 71 -13 22 -23
46 -39 54 -36z m-3319 63 c0 -5 -7 -11 -14 -14 -10 -4 -13 -1 -9 9 6 15 23 19
23 5z m45 -63 c5 -13 2 -18 -10 -18 -9 0 -13 5 -10 10 3 6 2 10 -2 10 -5 0 -7
17 -4 38 l4 37 7 -30 c4 -16 11 -38 15 -47z m724 28 c-6 -21 -12 -36 -14 -34
-3 2 0 21 6 42 6 21 12 36 14 34 3 -2 0 -21 -6 -42z m279 14 c-5 -17 -14 -33
-19 -36 -12 -7 -11 -2 7 34 20 40 26 41 12 2z m1234 8 c-7 -7 -12 -8 -12 -2 0
14 12 26 19 19 2 -3 -1 -11 -7 -17z m36 0 c-7 -12 -21 -31 -30 -42 -16 -17
-18 -18 -18 -3 0 9 5 17 10 17 6 0 15 11 20 25 5 14 14 25 20 25 6 0 5 -8 -2
-22z m152 0 c0 -19 -2 -20 -10 -8 -13 19 -13 30 0 30 6 0 10 -10 10 -22z m640
-22 c-6 -20 -13 -36 -15 -36 -2 0 -10 -3 -19 -6 -12 -5 -16 0 -15 22 1 18 3
22 6 11 7 -27 26 -15 37 21 5 18 11 30 13 28 3 -3 0 -21 -7 -40z m1034 -24 c5
-8 1 -10 -10 -5 -12 4 -15 3 -10 -5 4 -7 1 -12 -8 -12 -9 0 -16 7 -16 15 0 8
5 15 11 15 5 0 9 8 8 18 -3 35 3 46 10 16 4 -17 11 -36 15 -42z m-4217 26 c-3
-7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m690 0 c-3 -7 -5 -2 -5 12 0
14 2 19 5 13 2 -7 2 -19 0 -25z m61 11 c3 -12 2 -12 -6 0 -8 11 -12 9 -22 -8
-6 -13 -9 -29 -6 -37 3 -9 1 -12 -4 -9 -6 3 -10 21 -10 39 0 27 3 32 22 31 12
-1 24 -8 26 -16z m480 -19 c-2 -7 -10 1 -17 16 -12 27 -11 28 4 12 10 -9 16
-21 13 -28z m727 -11 c-5 -14 -3 -19 3 -15 6 3 21 2 34 -4 17 -7 -2 -9 -70 -7
-50 1 -92 -1 -92 -5 0 -14 -18 -8 -24 8 -3 9 -2 12 5 9 6 -4 19 1 30 11 17 16
19 16 19 1 0 -12 9 -17 31 -17 38 0 59 20 53 51 -5 21 -4 22 6 6 6 -9 8 -27 5
-38z m936 1 c6 0 17 -7 25 -15 14 -13 14 -15 0 -15 -24 0 -46 29 -45 58 l2 27
4 -27 c2 -16 9 -28 14 -28z m1079 46 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4
0 6 5 11 10 11 6 0 10 -2 10 -4z m-4270 -10 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1
-10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z m1797 -18 c-3 -8 -6 -5 -6 6 -1 11 2
17 5 13 3 -3 4 -12 1 -19z m2818 -14 l-15 -29 0 27 c0 14 6 28 13 31 18 7 19
3 2 -29z m-4941 0 l-6 -25 58 4 c33 3 68 1 79 -3 13 -6 -16 -9 -77 -9 -63 -1
-98 3 -98 10 0 5 5 7 10 4 6 -3 14 5 20 19 12 34 22 34 14 0z m766 -11 c-11
-17 -11 -17 -6 0 3 10 6 24 7 30 0 9 2 9 5 0 3 -7 0 -20 -6 -30z m1180 27 c0
-5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m-1840
-9 c0 -13 -49 -20 -57 -8 -3 5 -2 8 3 5 5 -3 18 -2 29 3 11 4 21 8 23 8 1 1 2
-3 2 -8z m240 -1 c0 -5 -10 -10 -22 -9 -22 0 -22 1 -3 9 11 5 21 9 23 9 1 1 2
-3 2 -9z m140 -17 c0 -13 -3 -13 -15 -3 -8 7 -15 16 -15 21 0 5 7 6 15 3 8 -4
15 -13 15 -21z m1526 0 c-10 -10 -19 5 -10 18 6 11 8 11 12 0 2 -7 1 -15 -2
-18z m1651 -5 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m670 17
c9 -24 -1 -27 -15 -5 -8 13 -8 20 -2 20 6 0 13 -7 17 -15z m282 -28 c9 -3 -3
-5 -26 -6 -45 -1 -50 4 -32 29 9 13 10 12 5 -2 -3 -10 -1 -18 4 -18 6 0 10 10
11 23 l0 22 11 -22 c6 -12 18 -24 27 -26z m296 11 c-2 -26 -31 -36 -49 -18 -8
8 -7 10 6 5 13 -5 19 0 24 19 7 31 21 26 19 -6z m-3685 -4 c0 -8 9 -14 20 -14
11 0 20 5 20 11 0 5 5 7 11 3 21 -13 -21 -26 -59 -19 -26 5 -32 9 -21 16 11 6
11 9 1 9 -7 0 -11 4 -7 10 8 13 35 1 35 -16z m3495 5 c-9 -13 9 -11 24 4 9 8
12 8 7 0 -4 -7 3 -13 16 -16 13 -2 4 -5 -19 -6 -37 -1 -43 2 -43 20 0 11 5 17
10 14 6 -4 8 -11 5 -16z m-2675 4 c0 -5 -5 -15 -10 -23 -8 -12 -10 -11 -10 8
0 12 5 22 10 22 6 0 10 -3 10 -7z m1307 -15 c-3 -8 -6 -5 -6 6 -1 11 2 17 5
13 3 -3 4 -12 1 -19z m1038 12 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10
4 10 3 0 8 -4 11 -10z m562 -12 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12
1 -19z m-4667 -2 c8 -2 -9 -4 -37 -5 -29 0 -53 3 -53 7 0 7 52 6 90 -2z m109
-1 c2 -3 -17 -5 -42 -5 -26 0 -47 4 -47 10 0 9 79 5 89 -5z m121 5 c0 -5 -5
-10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z m913 -11 c-7 -7
-22 -9 -40 -4 l-28 9 35 6 c40 7 48 4 33 -11z m272 11 c-10 -15 -69 -22 -95
-11 -21 9 -19 10 18 5 23 -3 42 -2 42 3 0 5 9 9 20 10 11 1 18 -2 15 -7z m605
-2 c0 -5 -20 -8 -45 -8 -25 0 -45 4 -45 8 0 5 20 8 45 8 25 -1 45 -4 45 -8z
m510 0 c0 -5 -29 -8 -65 -8 -36 0 -65 3 -65 8 0 4 29 7 65 7 36 0 65 -3 65 -7z
m-2125 -8 c13 -5 14 -9 5 -9 -8 0 -24 4 -35 9 -13 5 -14 9 -5 9 8 0 24 -4 35
-9z m3043 3 c-10 -2 -28 -2 -40 0 -13 2 -5 4 17 4 22 1 32 -1 23 -4z m329 -9
c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m-4927 -44 c0 -5 -4
-10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z"/>
<path d="M5975 8720 c-3 -5 1 -10 9 -10 9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0
-13 -4 -16 -10z"/>
<path d="M5680 8149 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M3500 5881 c0 -4 11 -6 25 -3 14 2 25 6 25 8 0 2 -11 4 -25 4 -14 0
-25 -4 -25 -9z"/>
<path d="M5810 4989 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M5731 4778 c-1 -16 -5 -28 -11 -28 -5 0 -10 -7 -10 -15 0 -8 5 -15
11 -15 5 0 8 -4 5 -9 -10 -16 6 -71 20 -71 11 0 14 19 14 83 0 50 -4 77 -9 68
-7 -11 -9 -11 -14 0 -3 8 -6 2 -6 -13z"/>
<path d="M5766 4615 c-20 -30 -22 -52 -3 -33 21 20 39 58 29 58 -6 0 -17 -11
-26 -25z"/>
<path d="M5761 3393 c0 -21 3 -31 6 -23 15 46 15 46 23 25 8 -19 9 -19 9 1 1
18 -16 34 -35 34 -2 0 -4 -17 -3 -37z"/>
<path d="M6560 2761 c0 -6 5 -13 10 -16 6 -3 10 1 10 9 0 9 -4 16 -10 16 -5 0
-10 -4 -10 -9z"/>
<path d="M7030 2665 c0 -8 2 -15 4 -15 2 0 6 7 10 15 3 8 1 15 -4 15 -6 0 -10
-7 -10 -15z"/>
<path d="M6350 2711 c0 -6 5 -13 10 -16 6 -3 10 1 10 9 0 9 -4 16 -10 16 -5 0
-10 -4 -10 -9z"/>
<path d="M4291 2504 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M5437 2723 c-11 -11 -8 -163 3 -163 7 0 10 32 8 85 -1 47 -3 85 -3
85 -1 0 -5 -3 -8 -7z"/>
<path d="M6680 2490 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M6750 2535 c-10 -12 -10 -15 4 -15 9 0 16 7 16 15 0 8 -2 15 -4 15
-2 0 -9 -7 -16 -15z"/>
<path d="M5290 2480 c0 -5 4 -10 9 -10 6 0 13 5 16 10 3 6 -1 10 -9 10 -9 0
-16 -4 -16 -10z"/>
<path d="M6328 9703 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M4783 9693 c9 -2 17 -9 17 -14 0 -5 7 -9 15 -9 23 0 18 17 -7 24 -13
3 -27 5 -33 5 -5 -1 -2 -3 8 -6z"/>
<path d="M4957 9689 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M5008 9693 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M6168 9693 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6441 9686 c2 -2 14 -9 27 -15 17 -9 22 -9 22 1 0 8 -12 15 -27 16
-14 1 -25 0 -22 -2z"/>
<path d="M4730 9650 l-25 -8 25 0 c14 0 34 3 45 8 l20 9 -20 -1 c-11 0 -31 -4
-45 -8z"/>
<path d="M6381 9656 c2 -2 27 -6 54 -9 32 -4 43 -3 30 3 -19 8 -93 14 -84 6z"/>
<path d="M4655 9640 c-3 -5 1 -10 9 -10 9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0
-13 -4 -16 -10z"/>
<path d="M6560 9639 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M4498 9633 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M4550 9630 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M6528 9633 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6633 9628 c7 -4 30 -5 52 -3 l40 5 -30 -14 c-23 -12 -26 -15 -10
-15 11 -1 26 3 34 8 25 16 1 30 -48 28 -27 -1 -44 -5 -38 -9z"/>
<path d="M4508 9603 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6775 9600 l-30 -8 29 -1 c28 -1 28 -2 11 -14 -17 -13 -17 -14 3 -19
14 -4 19 -2 16 7 -3 7 3 15 13 18 17 4 17 5 0 6 -10 0 -15 6 -12 11 3 6 5 9 3
9 -2 -1 -16 -5 -33 -9z"/>
<path d="M4360 9591 c0 -6 9 -11 19 -11 11 0 21 -5 23 -10 2 -8 20 -7 56 1 30
6 52 12 50 14 -2 1 -25 5 -53 9 -37 4 -45 3 -30 -4 18 -9 18 -10 -5 -6 -14 2
-33 7 -42 11 -11 4 -18 3 -18 -4z"/>
<path d="M6690 9586 c0 -7 40 -14 44 -7 3 4 -6 8 -20 9 -13 1 -24 0 -24 -2z"/>
<path d="M4286 9561 c-4 -5 3 -7 14 -4 23 6 26 13 6 13 -8 0 -17 -4 -20 -9z"/>
<path d="M4214 9545 c-10 -8 -14 -14 -9 -15 15 0 40 18 34 24 -3 3 -14 -1 -25
-9z"/>
<path d="M6844 9545 c8 -8 20 -15 27 -15 7 0 4 6 -7 15 -25 19 -40 19 -20 0z"/>
<path d="M6970 9540 c8 -5 22 -10 30 -10 13 0 13 1 0 10 -8 5 -22 10 -30 10
-13 0 -13 -1 0 -10z"/>
<path d="M7038 9523 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4140 9502 c8 -3 18 -9 21 -15 4 -6 15 -4 28 5 21 15 20 15 -21 15
-24 0 -36 -2 -28 -5z"/>
<path d="M7011 9494 c13 -7 26 -9 29 -5 3 5 12 10 20 13 8 3 -5 5 -29 5 -41 0
-43 0 -20 -13z"/>
<path d="M4050 9480 c-12 -8 -11 -10 8 -10 12 0 22 5 22 10 0 13 -11 13 -30 0z"/>
<path d="M7120 9480 c0 -5 7 -10 16 -10 8 0 12 5 9 10 -3 6 -10 10 -16 10 -5
0 -9 -4 -9 -10z"/>
<path d="M4108 9473 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7070 9476 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0
-15 -2 -15 -4z"/>
<path d="M7200 9460 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M4036 9441 c-3 -4 6 -6 19 -3 14 2 25 6 25 8 0 8 -39 4 -44 -5z"/>
<path d="M7128 9443 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7238 9443 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7175 9430 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 -8 0
-12 -4 -9 -10z"/>
<path d="M3886 9421 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 -4 11 -6 11 -12 0z"/>
<path d="M3934 9421 c3 -5 -1 -14 -9 -21 -8 -7 -15 -18 -15 -24 0 -8 2 -8 8 0
4 6 18 17 31 24 19 9 21 14 10 21 -18 11 -32 11 -25 0z"/>
<path d="M7245 9405 c11 -8 26 -19 33 -25 6 -6 12 -7 12 -2 0 10 -44 42 -57
42 -4 0 1 -7 12 -15z"/>
<path d="M7300 9410 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M3838 9393 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7338 9388 c9 -9 15 -9 24 0 9 9 7 12 -12 12 -19 0 -21 -3 -12 -12z"/>
<path d="M3796 9382 c-2 -4 6 -12 19 -18 22 -11 23 -10 12 7 -13 20 -23 24
-31 11z"/>
<path d="M3764 9355 c11 -8 27 -15 35 -15 9 0 3 7 -13 15 -36 19 -47 19 -22 0z"/>
<path d="M7448 9363 c6 -2 12 -13 12 -24 0 -11 7 -19 18 -19 13 0 14 2 3 9 -7
5 -11 13 -7 19 5 9 -16 23 -32 21 -4 0 -1 -3 6 -6z"/>
<path d="M3726 9349 c3 -6 0 -15 -7 -20 -11 -7 -10 -9 4 -9 10 0 17 8 17 20 0
11 -5 20 -11 20 -5 0 -7 -5 -3 -11z"/>
<path d="M7425 9330 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M3618 9293 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7560 9291 c0 -15 33 -22 44 -10 8 9 8 10 -1 5 -6 -3 -14 -2 -18 4
-8 12 -25 13 -25 1z"/>
<path d="M7501 9279 c18 -11 39 -11 39 0 0 5 -12 9 -26 9 -18 0 -22 -3 -13 -9z"/>
<path d="M3614 9255 c-10 -8 -14 -14 -9 -14 6 0 19 6 29 14 11 8 15 15 10 15
-6 0 -19 -7 -30 -15z"/>
<path d="M7560 9260 c8 -6 24 -15 35 -21 16 -8 15 -6 -4 10 -13 12 -28 21 -35
21 -6 0 -4 -5 4 -10z"/>
<path d="M7615 9260 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 -8 0
-12 -4 -9 -10z"/>
<path d="M7693 9220 c35 -30 47 -36 47 -22 0 8 -62 52 -73 52 -4 0 8 -13 26
-30z"/>
<path d="M3495 9229 c-4 -6 -17 -14 -29 -19 -15 -6 -16 -9 -5 -9 9 -1 27 8 40
19 13 10 19 19 12 20 -6 0 -15 -5 -18 -11z"/>
<path d="M3418 9183 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3347 9145 c-15 -14 -24 -25 -19 -25 5 0 21 11 36 25 35 32 20 32
-17 0z"/>
<path d="M3423 9158 c-13 -6 -23 -15 -23 -20 0 -7 31 8 59 29 10 7 -16 1 -36
-9z"/>
<path d="M7750 9160 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5
0 -3 -5 5 -10z"/>
<path d="M7840 9140 c0 -5 6 -10 13 -11 6 -1 1 -5 -13 -9 -23 -7 -23 -8 -4 -9
12 -1 24 -8 28 -16 3 -8 13 -15 23 -15 14 0 13 3 -6 16 -14 10 -19 19 -12 23
6 4 3 11 -9 19 -12 7 -20 8 -20 2z"/>
<path d="M3358 9113 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3316 9094 c-17 -12 -17 -14 -4 -14 9 0 20 5 23 11 11 17 2 18 -19 3z"/>
<path d="M7914 9097 c3 -10 6 -21 6 -23 0 -2 8 -4 18 -4 10 0 23 -5 29 -11 6
-6 17 -9 23 -7 7 2 -5 13 -26 23 -22 11 -43 25 -47 30 -5 6 -6 2 -3 -8z"/>
<path d="M3245 9080 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M3218 9033 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8033 9002 c-1 -22 0 -24 9 -8 6 10 6 22 2 26 -5 5 -10 -3 -11 -18z"/>
<path d="M3185 9000 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M3157 8993 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M8085 8960 c-13 -6 -15 -9 -5 -9 8 0 22 4 30 9 18 12 2 12 -25 0z"/>
<path d="M3060 8920 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0 -15
-4 -15 -10z"/>
<path d="M8125 8920 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
0 -7 -4 -4 -10z"/>
<path d="M8165 8910 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M2970 8855 c-8 -9 -8 -15 -2 -15 12 0 26 19 19 26 -2 2 -10 -2 -17
-11z"/>
<path d="M8210 8850 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M8260 8834 c0 -8 5 -12 10 -9 6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0
-10 -7 -10 -16z"/>
<path d="M2874 8799 c0 -13 3 -15 13 -7 7 6 13 12 13 13 0 2 -6 5 -13 8 -7 3
-13 -3 -13 -14z"/>
<path d="M8303 8810 c-31 -12 -29 -22 1 -10 13 5 27 6 32 2 4 -4 4 -1 0 6 -4
6 -8 12 -9 11 -1 0 -12 -4 -24 -9z"/>
<path d="M2840 8790 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M8345 8790 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M2805 8760 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 -8 0 -12 -5 -9 -10z"/>
<path d="M8390 8709 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M2750 8679 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M8435 8680 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M8525 8610 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M2670 8599 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M2605 8580 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 -8 0 -12 -5 -9 -10z"/>
<path d="M8575 8580 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M8595 8520 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M8647 8479 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M2471 8408 c-9 -15 -10 -23 -2 -31 10 -10 13 -4 10 19 0 4 5 10 11
14 7 4 8 10 3 13 -5 3 -15 -4 -22 -15z"/>
<path d="M8786 8381 c-3 -5 1 -11 9 -15 8 -3 15 -1 15 4 0 13 -18 22 -24 11z"/>
<path d="M2430 8359 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M8770 8350 c6 -11 16 -20 22 -20 6 0 3 9 -7 20 -10 11 -20 20 -22 20
-2 0 1 -9 7 -20z"/>
<path d="M2370 8339 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M2346 8291 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 -4 11 -6 11 -12 0z"/>
<path d="M2306 8246 c-4 -21 -5 -41 -2 -44 3 -3 6 4 6 16 0 14 6 22 18 22 10
0 13 3 6 8 -6 4 -13 14 -16 22 -3 8 -8 -2 -12 -24z"/>
<path d="M8870 8261 c0 -10 7 -22 16 -25 14 -5 15 -4 5 8 -7 8 -10 20 -6 26 3
5 1 10 -4 10 -6 0 -11 -9 -11 -19z"/>
<path d="M2275 8239 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M8920 8226 c0 -17 22 -46 31 -41 8 6 13 -8 10 -28 -1 -5 3 -6 9 -2 6
4 7 13 1 23 -11 21 -51 58 -51 48z"/>
<path d="M2240 8201 c0 -5 -7 -17 -16 -25 -8 -9 -12 -16 -7 -17 4 0 19 -3 33
-5 24 -4 24 -4 5 11 -14 12 -16 18 -7 21 14 7 16 24 2 24 -5 0 -10 -4 -10 -9z"/>
<path d="M2275 8180 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M8986 8132 c-3 -6 -1 -14 5 -17 15 -10 25 3 12 16 -7 7 -13 7 -17 1z"/>
<path d="M2172 8106 c-23 -23 -21 -39 4 -29 8 3 14 11 14 19 0 8 5 14 10 14 6
0 10 5 10 10 0 16 -13 11 -38 -14z"/>
<path d="M9006 8065 c4 -8 11 -15 16 -15 6 0 5 6 -2 15 -7 8 -14 15 -16 15 -2
0 -1 -7 2 -15z"/>
<path d="M2129 8046 c-10 -21 -10 -29 0 -39 10 -9 11 -8 5 6 -3 9 -1 24 6 32
7 9 10 18 7 22 -4 3 -12 -6 -18 -21z"/>
<path d="M2175 8060 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M9045 8060 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M9070 8031 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5
3 -10 2 -10 -4z"/>
<path d="M2075 7999 c-4 -6 -4 -13 -1 -16 3 -4 6 -1 6 6 0 7 5 9 10 6 6 -3 10
-1 10 4 0 14 -17 14 -25 0z"/>
<path d="M9070 7980 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M2046 7944 c-9 -24 -7 -28 9 -14 17 14 20 30 6 30 -5 0 -12 -7 -15
-16z"/>
<path d="M9126 7944 c-8 -22 -4 -25 11 -9 7 8 9 16 4 19 -5 3 -12 -1 -15 -10z"/>
<path d="M2073 7923 c4 -3 1 -13 -6 -22 -11 -14 -10 -14 5 -2 16 12 16 31 1
31 -4 0 -3 -3 0 -7z"/>
<path d="M2025 7881 c-3 -5 -1 -12 4 -15 5 -3 11 1 15 9 6 16 -9 21 -19 6z"/>
<path d="M9160 7872 c0 -11 3 -12 13 -3 8 6 17 8 20 4 4 -3 7 -1 7 5 0 6 -9
10 -20 9 -11 -1 -20 -8 -20 -15z"/>
<path d="M1986 7853 c-4 -9 -4 -14 0 -10 4 4 14 1 23 -6 14 -11 15 -10 1 8 -8
11 -15 21 -16 23 -1 2 -5 -5 -8 -15z"/>
<path d="M9195 7850 c-3 -5 1 -10 10 -10 9 0 13 5 10 10 -3 6 -8 10 -10 10 -2
0 -7 -4 -10 -10z"/>
<path d="M9220 7806 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 -5 3
-10 -1 -10 -9z"/>
<path d="M1943 7750 c0 -26 2 -27 13 -12 7 9 9 19 6 22 -4 3 -10 9 -13 13 -3
4 -6 -6 -6 -23z"/>
<path d="M9243 7765 c-7 -8 -9 -16 -4 -19 5 -3 12 1 15 10 8 22 4 25 -11 9z"/>
<path d="M1911 7744 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M9275 7750 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M9250 7720 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M1881 7693 l-13 -28 21 22 c23 24 26 33 13 33 -5 0 -14 -12 -21 -27z"/>
<path d="M9290 7715 c0 -3 10 -16 21 -28 l21 -22 -11 22 c-11 22 -31 40 -31
28z"/>
<path d="M1899 7664 c-5 -15 -7 -29 -5 -32 5 -4 10 6 22 46 7 23 -7 12 -17
-14z"/>
<path d="M9276 7682 c-3 -5 1 -9 9 -9 8 0 12 4 9 9 -3 4 -7 8 -9 8 -2 0 -6 -4
-9 -8z"/>
<path d="M1846 7638 c-24 -33 -19 -45 5 -14 12 15 19 29 16 32 -3 3 -12 -5
-21 -18z"/>
<path d="M9290 7645 c0 -8 7 -15 16 -15 14 0 14 3 4 15 -7 8 -14 15 -16 15 -2
0 -4 -7 -4 -15z"/>
<path d="M9318 7603 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M1840 7581 c0 -6 5 -13 10 -16 6 -3 10 1 10 9 0 9 -4 16 -10 16 -5 0
-10 -4 -10 -9z"/>
<path d="M9330 7581 c0 -6 5 -13 10 -16 6 -3 10 1 10 9 0 9 -4 16 -10 16 -5 0
-10 -4 -10 -9z"/>
<path d="M1811 7564 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M9390 7553 c0 -4 5 -15 10 -23 8 -13 10 -13 10 2 0 9 -4 20 -10 23
-5 3 -10 3 -10 -2z"/>
<path d="M9391 7494 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1747 7460 c-3 -11 -2 -22 2 -24 4 -3 8 6 9 20 2 29 -4 31 -11 4z"/>
<path d="M9426 7473 c5 -5 12 -12 16 -18 4 -6 8 -2 8 8 0 9 -7 17 -17 17 -9 0
-12 -3 -7 -7z"/>
<path d="M1761 7414 c-17 -38 -6 -41 12 -5 9 17 12 31 8 31 -4 0 -13 -12 -20
-26z"/>
<path d="M1720 7404 c0 -8 5 -12 10 -9 6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0
-10 -7 -10 -16z"/>
<path d="M9460 7410 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M9450 7372 c0 -20 24 -31 37 -17 8 9 9 16 3 20 -6 3 -10 1 -10 -6 0
-8 -4 -8 -15 1 -8 7 -15 8 -15 2z"/>
<path d="M1727 7363 c-4 -3 -7 -13 -7 -22 1 -13 3 -13 11 2 11 19 8 33 -4 20z"/>
<path d="M1692 7335 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M9502 7325 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M9519 7278 c0 -13 -3 -17 -6 -10 -2 6 -9 12 -14 12 -5 0 -4 -9 3 -19
7 -11 15 -18 19 -16 11 8 18 45 8 51 -5 3 -9 -5 -10 -18z"/>
<path d="M1690 7270 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M1642 7245 c-7 -15 -11 -30 -8 -32 7 -7 28 36 24 49 -2 6 -9 -2 -16
-17z"/>
<path d="M9557 7183 c-4 -3 -7 -13 -7 -22 1 -13 3 -13 11 2 11 19 8 33 -4 20z"/>
<path d="M1630 7171 c0 -6 5 -13 10 -16 6 -3 10 1 10 9 0 9 -4 16 -10 16 -5 0
-10 -4 -10 -9z"/>
<path d="M1612 7140 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M9577 7137 c-3 -9 -2 -17 4 -17 6 0 8 -9 4 -20 -4 -11 -2 -20 4 -20
6 0 11 10 12 23 0 21 1 21 9 2 6 -13 9 -15 9 -5 0 8 -4 22 -9 30 -9 13 -10 13
-11 0 0 -10 -3 -9 -8 4 -7 18 -8 18 -14 3z"/>
<path d="M1576 7083 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M1611 7084 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1590 7050 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M9626 7022 c-4 -6 -2 -21 4 -33 15 -28 21 -20 12 16 -5 18 -11 25
-16 17z"/>
<path d="M1553 6995 c-3 -9 -3 -18 -1 -21 3 -3 8 4 11 16 6 23 -1 27 -10 5z"/>
<path d="M9680 6928 c0 -20 19 -72 25 -67 2 3 -2 23 -10 44 -8 22 -14 32 -15
23z"/>
<path d="M1503 6899 c-7 -18 -11 -34 -9 -37 7 -7 27 39 24 55 -2 9 -8 2 -15
-18z"/>
<path d="M9651 6914 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1526 6865 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M9670 6840 c0 -5 5 -10 10 -10 6 0 10 -7 10 -17 0 -9 3 -14 6 -10 8
8 -5 47 -17 47 -5 0 -9 -4 -9 -10z"/>
<path d="M1501 6814 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M9716 6805 c-8 -33 3 -80 16 -67 6 6 6 17 -1 29 -5 11 -7 29 -4 41 3
12 3 22 0 22 -3 0 -8 -11 -11 -25z"/>
<path d="M1462 6804 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z"/>
<path d="M1475 6749 c-4 -17 -4 -33 -1 -36 3 -4 6 3 6 15 0 11 5 24 10 27 13
8 13 25 1 25 -5 0 -12 -14 -16 -31z"/>
<path d="M1441 6744 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M9756 6721 c-7 -10 8 -63 24 -88 11 -17 11 -17 5 2 -19 54 -24 79
-19 86 3 5 3 9 0 9 -3 0 -7 -4 -10 -9z"/>
<path d="M1425 6668 c-4 -13 -11 -25 -15 -28 -4 -3 -10 -23 -13 -45 -6 -35 -5
-37 4 -15 32 72 42 101 36 106 -3 3 -8 -5 -12 -18z"/>
<path d="M9731 6674 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1446 6634 c-10 -25 1 -29 14 -5 6 12 7 21 1 21 -5 0 -12 -7 -15 -16z"/>
<path d="M9762 6610 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M1425 6579 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M9766 6565 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M1397 6533 c-9 -9 -9 -45 1 -60 5 -7 8 4 9 27 2 41 1 45 -10 33z"/>
<path d="M9810 6491 c0 -6 5 -13 10 -16 6 -3 10 1 10 9 0 9 -4 16 -10 16 -5 0
-10 -4 -10 -9z"/>
<path d="M9790 6470 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M1386 6405 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M9800 6410 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3
-15 1 -15 -4z"/>
<path d="M1337 6340 c-3 -11 -1 -20 4 -20 5 0 9 9 9 20 0 11 -2 20 -4 20 -2 0
-6 -9 -9 -20z"/>
<path d="M9850 6357 c0 -4 7 -49 16 -99 15 -87 24 -120 24 -87 0 24 -29 182
-35 187 -3 3 -5 2 -5 -1z"/>
<path d="M1331 6284 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1355 6270 c-4 -12 -5 -24 -2 -27 3 -2 8 5 12 17 4 12 5 24 2 27 -3
2 -8 -5 -12 -17z"/>
<path d="M9830 6271 c0 -11 5 -23 10 -26 6 -3 10 3 10 14 0 11 -4 23 -10 26
-5 3 -10 -3 -10 -14z"/>
<path d="M1316 6252 c-2 -4 -1 -14 5 -22 7 -12 9 -10 9 8 0 23 -5 28 -14 14z"/>
<path d="M9845 6181 c-3 -5 -1 -12 5 -16 5 -3 10 1 10 9 0 18 -6 21 -15 7z"/>
<path d="M1302 6060 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M9861 6064 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M9890 6044 c0 -21 5 -46 10 -54 7 -10 8 1 4 35 -8 62 -14 70 -14 19z"/>
<path d="M9911 6064 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M9922 5945 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M9892 5905 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M1260 5861 c0 -11 4 -22 9 -25 4 -3 6 6 3 19 -5 30 -12 33 -12 6z"/>
<path d="M9932 5818 c-2 -44 -6 -58 -17 -58 -10 0 -15 -9 -14 -27 2 -26 2 -27
6 -4 4 18 7 21 13 11 11 -19 23 44 17 95 -3 32 -4 29 -5 -17z"/>
<path d="M1293 5785 c0 -33 2 -45 4 -27 2 18 2 45 0 60 -2 15 -4 0 -4 -33z"/>
<path d="M9902 5815 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M1271 5723 c-1 -23 3 -44 7 -47 4 -2 6 12 4 32 -5 56 -10 62 -11 15z"/>
<path d="M9921 5708 c0 -9 -4 -25 -7 -35 -5 -17 -5 -17 6 0 6 10 9 25 7 35 -4
15 -5 15 -6 0z"/>
<path d="M9947 5660 c3 -30 7 -57 9 -59 8 -9 2 75 -6 94 -5 12 -6 -1 -3 -35z"/>
<path d="M9932 5625 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M1262 5620 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M1281 5584 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1282 5495 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M9933 5480 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"/>
<path d="M1233 5400 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"/>
<path d="M1282 5305 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M1232 5300 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M9951 5294 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1282 5225 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M1261 5184 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M9952 5170 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"/>
<path d="M1241 5140 c0 -14 4 -43 8 -65 l9 -40 1 50 c0 28 -4 57 -9 65 -8 12
-10 10 -9 -10z"/>
<path d="M9902 5140 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M1273 5080 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"/>
<path d="M9935 5045 c-3 -31 -5 -59 -2 -61 3 -3 8 20 12 51 3 31 5 59 2 61 -3
3 -8 -20 -12 -51z"/>
<path d="M1292 5065 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M9902 5065 c0 -11 3 -29 8 -40 11 -25 11 1 0 35 -6 20 -8 21 -8 5z"/>
<path d="M1292 4985 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M1265 4959 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M9898 4964 c-5 -4 -8 -21 -8 -38 1 -26 2 -28 11 -13 11 19 8 63 -3
51z"/>
<path d="M9932 4940 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M1301 4920 c-1 -14 -4 -36 -6 -50 -5 -22 -4 -22 4 -5 9 19 10 18 11
-5 1 -14 3 -20 6 -15 2 6 0 30 -5 55 -5 27 -9 35 -10 20z"/>
<path d="M9922 4880 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"/>
<path d="M1272 4860 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M9872 4820 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M9900 4824 c0 -10 5 -26 10 -34 8 -11 9 -7 4 15 -8 37 -14 45 -14 19z"/>
<path d="M9872 4740 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M1291 4734 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1311 4608 c-1 -41 7 -68 21 -68 5 0 6 6 1 13 -4 6 -10 30 -14 52
l-6 40 -2 -37z"/>
<path d="M1342 4615 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M9851 4624 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M9857 4562 c1 -8 3 -16 3 -19 0 -3 7 0 15 7 8 7 15 17 15 22 0 6 -6
6 -14 -1 -8 -7 -16 -8 -18 -4 -3 4 -3 2 -1 -5z"/>
<path d="M1361 4525 c1 -19 18 -51 18 -35 0 8 -4 22 -9 30 -5 8 -9 11 -9 5z"/>
<path d="M1337 4495 c-4 -8 -2 -17 3 -20 6 -4 10 3 10 14 0 25 -6 27 -13 6z"/>
<path d="M1357 4454 c-4 -4 -7 -14 -7 -23 0 -11 3 -12 11 -4 6 6 10 16 7 23
-2 6 -7 8 -11 4z"/>
<path d="M9830 4436 c0 -8 5 -18 10 -21 6 -3 10 3 10 14 0 12 -4 21 -10 21 -5
0 -10 -6 -10 -14z"/>
<path d="M1374 4395 c-3 -14 -4 -29 0 -32 3 -4 6 3 6 15 0 11 5 22 12 24 9 3
9 6 0 12 -7 4 -14 -3 -18 -19z"/>
<path d="M9794 4394 c-8 -33 6 -76 26 -82 11 -4 10 1 -4 16 -14 16 -17 31 -13
57 7 41 0 47 -9 9z"/>
<path d="M9821 4384 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1426 4246 c2 -16 4 -32 4 -37 0 -5 4 -9 9 -9 5 0 9 14 9 31 -1 18
-4 25 -9 18 -5 -9 -9 -7 -12 7 -2 10 -3 6 -1 -10z"/>
<path d="M1401 4224 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1450 4180 c0 -8 5 -22 10 -30 9 -13 10 -13 10 0 0 8 -5 22 -10 30
-9 13 -10 13 -10 0z"/>
<path d="M9756 4135 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0
-6 -7 -10 -15z"/>
<path d="M1481 4094 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M9707 4096 c-3 -8 0 -17 7 -19 10 -4 12 1 9 14 -6 23 -9 24 -16 5z"/>
<path d="M9740 4096 c0 -8 4 -17 9 -20 5 -4 7 3 4 14 -6 23 -13 26 -13 6z"/>
<path d="M1446 4085 c-3 -9 0 -15 9 -15 9 0 12 6 9 15 -4 8 -7 15 -9 15 -2 0
-5 -7 -9 -15z"/>
<path d="M9710 4041 c0 -25 6 -27 13 -6 4 8 2 17 -3 20 -6 4 -10 -3 -10 -14z"/>
<path d="M1491 4023 c-1 -13 -6 -23 -12 -23 -5 0 -7 -5 -3 -11 5 -8 9 -8 14 1
5 8 13 9 21 4 11 -6 12 -5 3 7 -6 8 -14 21 -17 29 -4 10 -6 7 -6 -7z"/>
<path d="M9703 3985 c-7 -8 -13 -19 -13 -25 0 -18 15 -10 27 15 12 27 5 32
-14 10z"/>
<path d="M1490 3956 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 -5 3
-10 -1 -10 -9z"/>
<path d="M1526 3948 c5 -21 2 -28 -10 -28 -9 0 -13 -6 -10 -15 4 -8 10 -13 14
-10 5 3 11 -3 13 -12 2 -10 3 -5 1 10 -2 17 0 26 6 22 14 -9 12 6 -5 35 l-15
25 6 -27z"/>
<path d="M9655 3930 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M1557 3876 c-4 -10 -7 -32 -6 -49 1 -31 1 -31 10 7 10 43 7 72 -4 42z"/>
<path d="M9626 3843 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M9642 3817 c-6 -7 -8 -18 -4 -24 5 -7 11 -3 19 13 12 26 3 33 -15 11z"/>
<path d="M9611 3784 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1571 3736 c7 -15 15 -23 17 -16 3 7 -3 19 -13 28 -15 16 -16 15 -4
-12z"/>
<path d="M9613 3744 c-15 -16 -16 -24 -4 -24 8 0 24 30 19 35 -2 2 -9 -3 -15
-11z"/>
<path d="M9576 3734 c-4 -9 -4 -19 -1 -22 2 -3 7 3 11 12 4 9 4 19 1 22 -2 3
-7 -3 -11 -12z"/>
<path d="M9595 3690 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M9551 3641 c-7 -12 -7 -22 -2 -26 5 -3 13 4 16 16 9 28 -1 36 -14 10z"/>
<path d="M1640 3591 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M9510 3589 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M1695 3541 c6 -21 4 -23 -13 -19 -14 4 -19 2 -16 -6 6 -16 27 -16 41
-1 7 8 6 17 -4 31 -14 18 -15 18 -8 -5z"/>
<path d="M9490 3544 c0 -8 5 -12 10 -9 6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0
-10 -7 -10 -16z"/>
<path d="M9480 3500 c0 -10 -6 -23 -14 -27 -13 -8 -46 -60 -59 -96 -13 -34 12
-7 34 38 12 25 26 45 30 45 4 0 12 14 18 30 6 18 6 30 0 30 -5 0 -9 -9 -9 -20z"/>
<path d="M1722 3475 c6 -14 13 -24 14 -22 6 6 -9 47 -17 47 -5 0 -3 -11 3 -25z"/>
<path d="M1715 3430 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M1730 3403 c0 -4 5 -15 10 -23 8 -13 10 -13 10 2 0 9 -4 20 -10 23
-5 3 -10 3 -10 -2z"/>
<path d="M9456 3393 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M1770 3390 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M1790 3315 c7 -9 15 -13 17 -11 7 7 -7 26 -19 26 -6 0 -6 -6 2 -15z"/>
<path d="M1830 3281 c0 -6 5 -13 10 -16 6 -3 10 1 10 9 0 9 -4 16 -10 16 -5 0
-10 -4 -10 -9z"/>
<path d="M1800 3277 c0 -3 9 -21 21 -39 17 -28 19 -29 14 -8 -7 24 -35 62 -35
47z"/>
<path d="M9382 3264 c-7 -8 -12 -20 -9 -27 2 -7 9 -2 16 11 15 28 11 36 -7 16z"/>
<path d="M1865 3200 c-7 -21 18 -82 40 -100 21 -18 6 31 -17 53 -12 12 -16 26
-12 42 7 30 -2 34 -11 5z"/>
<path d="M9320 3188 c0 -37 -18 -45 -23 -11 l-5 28 2 -29 c1 -38 23 -45 38
-12 9 20 9 29 0 38 -9 9 -12 6 -12 -14z"/>
<path d="M1947 3080 c3 -11 9 -20 15 -20 5 0 4 9 -2 20 -6 11 -12 20 -14 20
-2 0 -2 -9 1 -20z"/>
<path d="M9240 3080 c-12 -22 -6 -40 13 -39 9 0 9 2 0 5 -8 4 -9 13 -3 30 11
29 5 32 -10 4z"/>
<path d="M1971 3041 c-7 -5 -12 -14 -10 -20 2 -6 10 -2 17 9 14 22 13 23 -7
11z"/>
<path d="M9198 3033 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M1970 2991 c0 -6 5 -13 10 -16 6 -3 10 1 10 9 0 9 -4 16 -10 16 -5 0
-10 -4 -10 -9z"/>
<path d="M9161 2931 c-13 -10 -19 -21 -14 -24 10 -7 50 29 42 37 -2 3 -15 -3
-28 -13z"/>
<path d="M2035 2910 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M9106 2892 c-3 -6 -1 -14 5 -17 15 -10 25 3 12 16 -7 7 -13 7 -17 1z"/>
<path d="M2070 2880 c0 -5 7 -7 15 -4 8 4 15 8 15 10 0 2 -7 4 -15 4 -8 0 -15
-4 -15 -10z"/>
<path d="M9077 2833 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M2120 2799 c0 -11 4 -18 10 -14 5 3 7 12 3 20 -7 21 -13 19 -13 -6z"/>
<path d="M2150 2775 c0 -8 62 -65 71 -65 4 0 -7 16 -24 35 -27 31 -47 44 -47
30z"/>
<path d="M9030 2751 c0 -6 5 -13 10 -16 6 -3 10 1 10 9 0 9 -4 16 -10 16 -5 0
-10 -4 -10 -9z"/>
<path d="M9000 2741 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M2150 2731 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5
3 -10 2 -10 -4z"/>
<path d="M8973 2713 c9 -2 17 -12 17 -21 0 -13 3 -13 12 -4 10 10 10 15 -2 22
-8 5 -22 9 -30 9 -11 -1 -10 -3 3 -6z"/>
<path d="M2200 2694 c0 -6 7 -19 15 -30 8 -10 14 -14 14 -9 0 6 -6 19 -14 29
-8 11 -15 15 -15 10z"/>
<path d="M8937 2674 c-23 -31 -21 -45 3 -15 15 18 20 19 20 7 0 -9 5 -16 10
-16 13 0 12 11 -3 31 -11 15 -14 14 -30 -7z"/>
<path d="M8905 2610 c-17 -18 -17 -20 -1 -20 9 0 19 7 23 15 9 25 -2 27 -22 5z"/>
<path d="M2276 2595 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0
-7 -7 -4 -15z"/>
<path d="M8864 2555 c-3 -8 -4 -20 -1 -27 3 -7 6 -3 6 9 1 12 7 24 14 26 9 4
9 6 -1 6 -7 1 -15 -6 -18 -14z"/>
<path d="M2360 2544 c0 -5 7 -18 15 -28 8 -11 15 -16 15 -10 0 5 -7 18 -15 28
-8 11 -15 16 -15 10z"/>
<path d="M8800 2521 c0 -5 -7 -16 -15 -25 -8 -8 -11 -17 -6 -21 5 -3 12 4 16
15 3 11 11 20 16 20 5 0 9 5 9 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -9z"/>
<path d="M2400 2501 c0 -10 19 -25 25 -20 1 2 -3 10 -11 17 -8 7 -14 8 -14 3z"/>
<path d="M8835 2500 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M2370 2484 c0 -3 7 -12 15 -20 16 -17 18 -14 9 10 -6 15 -24 23 -24
10z"/>
<path d="M2425 2470 c-17 -6 -17 -7 3 -12 12 -4 26 -16 30 -29 8 -21 9 -21 13
-3 7 25 -22 52 -46 44z"/>
<path d="M8780 2450 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M8726 2394 c-8 -22 -4 -25 11 -9 7 8 9 16 4 19 -5 3 -12 -1 -15 -10z"/>
<path d="M2472 2368 c5 -15 28 -23 28 -10 0 5 -7 13 -16 16 -10 4 -14 1 -12
-6z"/>
<path d="M8695 2359 c-4 -6 -16 -14 -28 -18 -20 -7 -20 -8 -1 -12 20 -5 59 26
44 36 -5 3 -12 0 -15 -6z"/>
<path d="M2520 2331 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M2585 2310 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M8590 2308 c0 -9 -6 -19 -12 -21 -10 -4 -10 -6 0 -6 14 -1 28 26 18
36 -3 4 -6 -1 -6 -9z"/>
<path d="M2550 2299 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M8617 2289 c-3 -11 -15 -23 -26 -26 -21 -5 -30 -33 -10 -33 5 0 7 5
3 12 -5 8 -2 9 9 5 11 -4 17 -1 17 8 0 8 7 15 15 15 9 0 12 6 8 17 -4 11 -3
14 5 9 7 -4 12 -2 12 3 0 20 -28 11 -33 -10z"/>
<path d="M2635 2260 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M2663 2235 c0 -8 4 -15 9 -15 4 0 8 4 8 9 0 6 -4 12 -8 15 -5 3 -9
-1 -9 -9z"/>
<path d="M2630 2219 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M8500 2215 c-20 -24 -6 -28 15 -5 10 11 13 20 8 20 -6 0 -16 -7 -23
-15z"/>
<path d="M8540 2219 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M2695 2200 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M8490 2169 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M2755 2120 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M8430 2119 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M8340 2039 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M2927 2004 c3 -8 12 -13 19 -10 8 3 14 0 14 -6 0 -6 3 -8 7 -4 5 4
-1 14 -11 22 -26 18 -37 18 -29 -2z"/>
<path d="M8211 1970 c-17 -15 -19 -20 -8 -20 9 0 19 5 23 11 3 6 15 8 26 6 16
-4 17 -3 7 9 -15 18 -19 17 -48 -6z"/>
<path d="M2980 1960 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M2985 1920 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 -8 0
-12 -4 -9 -10z"/>
<path d="M3028 1905 c5 -29 11 -28 17 4 2 13 -1 21 -9 21 -9 0 -12 -9 -8 -25z"/>
<path d="M8153 1915 c0 -8 4 -12 9 -9 5 3 6 10 3 15 -9 13 -12 11 -12 -6z"/>
<path d="M8198 1923 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M3145 1840 c3 -5 14 -10 23 -10 15 0 15 2 2 10 -20 13 -33 13 -25 0z"/>
<path d="M8030 1840 c-13 -8 -13 -10 2 -10 9 0 20 5 23 10 8 13 -5 13 -25 0z"/>
<path d="M3177 1813 c-9 -2 -15 -9 -12 -14 9 -14 22 -11 29 6 3 8 4 14 3 14
-1 -1 -10 -3 -20 -6z"/>
<path d="M8007 1804 c6 -16 19 -18 27 -5 3 5 -3 11 -13 14 -14 3 -18 1 -14 -9z"/>
<path d="M3200 1785 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M7991 1784 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3240 1780 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M3275 1761 c-3 -5 -2 -12 3 -15 5 -3 9 1 9 9 0 17 -3 19 -12 6z"/>
<path d="M3322 1734 c10 -10 20 -16 22 -13 3 3 -5 11 -17 18 -21 13 -21 12 -5
-5z"/>
<path d="M7879 1748 c-6 -14 -6 -57 0 -53 8 4 12 55 5 55 -2 0 -5 -1 -5 -2z"/>
<path d="M7911 1732 c-1 -22 0 -22 24 -6 14 9 23 19 21 22 -3 3 -12 0 -20 -7
-11 -9 -15 -9 -19 1 -3 7 -6 3 -6 -10z"/>
<path d="M3291 1717 c2 -1 13 -9 24 -17 19 -14 19 -14 6 3 -7 9 -18 17 -24 17
-6 0 -8 -1 -6 -3z"/>
<path d="M3417 1679 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M3400 1650 c0 -5 7 -10 16 -10 8 0 12 5 9 10 -3 6 -10 10 -16 10 -5
0 -9 -4 -9 -10z"/>
<path d="M7775 1650 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M3460 1640 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3
-15 1 -15 -4z"/>
<path d="M7705 1643 c-23 -6 -73 -43 -57 -43 6 0 17 7 26 15 8 8 26 15 40 15
14 0 26 5 26 10 0 11 -3 11 -35 3z"/>
<path d="M3526 1615 c19 -16 24 -25 14 -25 -10 -1 -8 -7 9 -21 13 -11 26 -17
29 -14 3 3 -3 12 -14 20 -19 14 -19 14 1 15 20 1 20 1 0 10 -12 4 -27 15 -34
24 -7 9 -18 16 -24 16 -5 0 3 -11 19 -25z"/>
<path d="M3471 1606 c2 -2 14 -9 26 -15 19 -10 22 -9 17 4 -4 8 -15 15 -27 15
-11 0 -18 -2 -16 -4z"/>
<path d="M7708 1603 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3620 1560 c0 -5 9 -12 20 -15 11 -3 20 -11 20 -16 0 -6 9 -7 20 -4
11 4 20 2 20 -4 0 -6 10 -11 23 -11 22 1 22 1 -3 15 -14 8 -33 14 -42 15 -10
0 -18 4 -18 9 0 5 -9 11 -20 14 -11 3 -20 1 -20 -3z"/>
<path d="M7537 1554 c-16 -9 -27 -18 -24 -20 5 -5 77 24 77 31 0 9 -25 4 -53
-11z"/>
<path d="M7620 1559 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M3618 1523 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7530 1515 c-19 -8 -43 -17 -52 -21 -10 -3 -18 -10 -18 -15 0 -6 104
35 119 47 9 8 -16 2 -49 -11z"/>
<path d="M7426 1494 c-17 -12 -17 -14 -4 -14 9 0 20 5 23 11 11 17 2 18 -19 3z"/>
<path d="M3700 1494 c0 -2 9 -8 20 -14 11 -6 20 -7 20 -2 0 6 -9 12 -20 15
-11 3 -20 3 -20 1z"/>
<path d="M3760 1490 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3
-15 1 -15 -4z"/>
<path d="M3840 1464 c0 -6 11 -17 25 -24 20 -10 28 -11 37 -2 9 9 6 12 -13 12
-14 0 -30 5 -37 12 -7 7 -12 8 -12 2z"/>
<path d="M7398 1453 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3940 1417 c0 -10 8 -17 18 -17 9 0 13 4 7 8 -5 4 -13 11 -17 16 -5
5 -8 2 -8 -7z"/>
<path d="M7245 1410 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M7280 1395 c-19 -23 -8 -25 14 -4 11 11 15 19 9 19 -6 0 -16 -7 -23
-15z"/>
<path d="M7200 1390 c0 -5 4 -10 9 -10 6 0 13 5 16 10 3 6 -1 10 -9 10 -9 0
-16 -4 -16 -10z"/>
<path d="M3980 1380 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M4025 1370 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M7155 1370 c-3 -5 1 -10 9 -10 9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0
-13 -4 -16 -10z"/>
<path d="M7101 1363 c11 -3 15 -11 12 -24 -3 -10 0 -19 6 -19 5 0 8 7 5 15 -4
8 -2 15 4 15 6 0 12 -5 14 -12 3 -7 10 -8 17 -3 10 5 4 12 -19 21 -18 8 -37
13 -44 13 -6 -1 -4 -3 5 -6z"/>
<path d="M4120 1350 c0 -5 7 -10 16 -10 8 0 12 5 9 10 -3 6 -10 10 -16 10 -5
0 -9 -4 -9 -10z"/>
<path d="M4054 1336 c25 -20 43 -20 43 -1 0 8 -4 15 -9 15 -4 0 -8 -5 -8 -10
0 -7 -7 -7 -22 0 -22 11 -22 10 -4 -4z"/>
<path d="M4140 1320 c-21 -7 -21 -8 -5 -9 11 0 27 4 35 9 18 11 5 11 -30 0z"/>
<path d="M7058 1313 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4260 1300 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3
-15 1 -15 -4z"/>
<path d="M4285 1275 c-16 -8 -25 -14 -18 -15 6 0 19 -3 29 -7 11 -4 15 -3 10
5 -3 6 2 15 11 21 26 15 3 12 -32 -4z"/>
<path d="M6868 1283 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6869 1262 c17 -6 13 -22 -6 -23 -10 0 -13 -3 -8 -5 6 -2 29 4 50 15
l40 20 -44 -2 c-23 -1 -38 -3 -32 -5z"/>
<path d="M4320 1240 c0 -13 20 -13 40 0 12 8 9 10 -12 10 -16 0 -28 -4 -28
-10z"/>
<path d="M4418 1243 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M6758 1243 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4471 1224 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6721 1224 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M4510 1220 c0 -5 4 -10 9 -10 6 0 13 5 16 10 3 6 -1 10 -9 10 -9 0
-16 -4 -16 -10z"/>
<path d="M6636 1222 c-3 -5 10 -9 29 -10 19 -1 35 3 35 8 0 12 -57 13 -64 2z"/>
<path d="M6785 1220 c-19 -8 -19 -9 3 -9 12 -1 22 4 22 9 0 6 -1 10 -2 9 -2 0
-12 -4 -23 -9z"/>
<path d="M4568 1213 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6570 1200 c-13 -8 -13 -10 2 -10 9 0 20 5 23 10 8 13 -5 13 -25 0z"/>
<path d="M4478 1193 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M4548 1192 c-17 -7 -17 -8 0 -18 9 -6 28 -7 42 -3 24 7 24 7 -5 8
-23 1 -27 3 -15 11 17 11 4 12 -22 2z"/>
<path d="M6636 1189 c3 -5 -5 -9 -18 -9 -13 0 -30 -5 -38 -11 -11 -7 -6 -8 20
-3 19 3 44 10 54 14 19 6 18 7 -2 12 -12 4 -20 2 -16 -3z"/>
<path d="M4685 1180 l-40 -7 48 -2 c26 0 47 4 47 9 0 6 -3 9 -7 9 -5 -1 -26
-5 -48 -9z"/>
<path d="M6463 1173 c-18 -7 -16 -23 2 -23 8 0 15 4 15 9 0 5 10 12 23 14 20
4 20 4 -3 5 -14 0 -31 -2 -37 -5z"/>
<path d="M6538 1173 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6382 1161 c-11 -7 -11 -9 0 -13 18 -7 39 2 32 13 -6 11 -15 11 -32
0z"/>
<path d="M4758 1153 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4880 1150 c0 -5 12 -10 28 -9 24 0 25 1 7 9 -27 12 -35 12 -35 0z"/>
<path d="M6300 1150 c-13 -8 -12 -10 3 -10 9 0 17 5 17 10 0 12 -1 12 -20 0z"/>
<path d="M6505 1150 c-19 -8 -19 -9 3 -9 12 -1 22 4 22 9 0 6 -1 10 -2 9 -2 0
-12 -4 -23 -9z"/>
<path d="M6220 1140 c-21 -7 -21 -8 -5 -9 11 0 27 4 35 9 18 11 5 11 -30 0z"/>
<path d="M4978 1133 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"/>
<path d="M5000 1120 l-45 -7 40 -1 c22 0 51 4 65 8 32 10 5 10 -60 0z"/>
<path d="M6110 1120 c-10 -6 -2 -7 25 -3 49 7 58 13 19 13 -16 0 -36 -5 -44
-10z"/>
<path d="M4873 1113 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M5178 1113 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6308 1113 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"/>
<path d="M6060 1100 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M6145 1100 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M5080 1091 c-21 -6 -16 -9 29 -15 29 -4 56 -5 59 -1 3 3 -7 5 -21 5
-15 0 -27 5 -27 10 0 11 -4 11 -40 1z"/>
<path d="M6175 1090 c3 -5 10 -10 16 -10 5 0 9 5 9 10 0 6 -7 10 -16 10 -8 0
-12 -4 -9 -10z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
